<template>
  <div class="course-detail-container fullscreen-page">
    <div class="course-header">
      <div class="course-title-section">
        <div class="course-title-with-cover">
          <div class="course-cover-section" v-if="course.image && course.image !== 'default'">
            <img :src="course.image" class="course-cover-large" alt="课程封面">
          </div>
          <div class="course-info-section">
            <h1>{{ displayCourseTitle }}</h1>
            <div class="course-meta">
              <span class="meta-item">
                <i class="el-icon-user"></i>
                <template v-if="isTeacher">
                  教师: {{ course.teacher_name || '' }}
                </template>
                <template v-else>
                  学生: {{ currentUser ? (currentUser.userName || currentUser.username || currentUser.realName || currentUser.name || '') : '' }}
                </template>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="course-content">
      <div class="course-sidebar">
        <el-menu :default-active="activeMenu" class="course-menu" @select="handleMenuSelect">
          <!-- 隐藏教学计划 -->
          <!-- <el-menu-item index="teaching-plan">
            <i class="el-icon-date"></i>
            <span>教学计划</span>
          </el-menu-item> -->
          <!-- 隐藏课程通知 -->
          <!-- <el-menu-item index="inform">
            <i class="el-icon-document"></i>
            <span>课程通知</span>
          </el-menu-item> -->
          <!-- 隐藏课程简介 -->
          <!-- <el-menu-item index="profile">
            <i class="el-icon-document"></i>
            <span>课程简介</span>
          </el-menu-item> -->
          <!-- 隐藏教学目标 -->
          <!-- <el-menu-item index="target">
            <i class="el-icon-reading"></i>
            <span>教学目标</span>
          </el-menu-item> -->
          <el-menu-item index="chapter">
            <i class="el-icon-folder"></i>
            <span>课程章节</span>
          </el-menu-item>
          <!-- 隐藏课程知识点菜单 -->
          <!-- <el-menu-item index="knowledge">
            <i class="el-icon-collection"></i>
            <span>课程知识点</span>
          </el-menu-item> -->
          <el-menu-item index="class-management" v-if="isTeacher">
            <i class="el-icon-user"></i>
            <span>班级管理</span>
          </el-menu-item>
          <el-menu-item index="question-bank" v-if="isTeacher">
            <i class="el-icon-collection-tag"></i>
            <span>题库管理</span>
          </el-menu-item>
          <el-menu-item index="homework">
            <i class="el-icon-folder"></i>
            <span>{{ isTeacher ? '作业管理' : '我的作业' }}</span>
          </el-menu-item>
          <el-menu-item index="resources">
            <i class="el-icon-folder"></i>
            <span>课程资料</span>
          </el-menu-item>
          <el-menu-item index="discussion">
            <i class="el-icon-chat-dot-round"></i>
            <span>课程讨论</span>
          </el-menu-item>
          <!-- 隐藏错题集菜单项 -->
          <el-menu-item v-if="false" index="wrong-question-set">
            <i class="el-icon-folder"></i>
            <span>错题集</span>
          </el-menu-item>
          <el-menu-item index="analysis">
            <i class="el-icon-data-analysis"></i>
            <span>学情分析</span>
          </el-menu-item>
          <el-menu-item v-if="isTeacher" index="data-collection">
            <i class="el-icon-s-data"></i>
            <span>数据收集</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div class="course-main">
        <div v-show="activeMenu === 'teaching-plan'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">教学计划</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreatePlan">新建计划</el-button>
              <el-button size="small" @click="fetchPlans" :loading="plansLoading">刷新</el-button>
            </div>
          </div>

          <div v-if="plansLoading" class="loading-container" v-loading="true" element-loading-text="正在加载教学计划..." style="height:180px;" />

          <template v-else>
            <el-table v-if="displayPlans && displayPlans.length" :data="displayPlans" size="small" border>
              <el-table-column type="index" width="60" label="#" />
              <el-table-column prop="planName" label="计划名称" min-width="200" />
              <el-table-column prop="academicYear" label="学年" width="120" />
              <el-table-column prop="semester" label="学期" width="100" />
              <el-table-column prop="startDate" label="开始日期" width="120" />
              <el-table-column prop="endDate" label="结束日期" width="120" />
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="{ row }">
                  <el-tag :type="row.status===1?'success':(row.status===2?'info':'warning')">
                    {{ statusText(row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="描述" min-width="240" show-overflow-tooltip />
              <el-table-column v-if="isTeacher" label="操作" width="200">
                <template slot-scope="{ row }">
                  <el-button type="text" size="mini" @click="openEditPlan(row)">编辑</el-button>
                  <el-button type="text" size="mini" @click="togglePublish(row)">{{ row.status===1?'取消发布':'发布' }}</el-button>
                  <el-popconfirm title="确定删除该计划吗？" @onConfirm="removePlan(row)">
                    <el-button type="text" size="mini" slot="reference">删除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty-tip">
              <i class="el-icon-date"></i>
              <p>暂无教学计划</p>
            </div>
          </template>

          <!-- 新建/编辑教学计划对话框 -->
          <el-dialog :title="editingId? '编辑教学计划':'新建教学计划'" :visible.sync="planDialogVisible" width="520px">
            <el-form :model="planForm" :rules="planRules" ref="planForm" label-width="100px">
              <el-form-item label="计划名称" prop="planName">
                <el-input v-model="planForm.planName" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="学年" prop="academicYear">
                <el-input v-model="planForm.academicYear" placeholder="如：2025-2026" />
              </el-form-item>
              <el-form-item label="学期" prop="semester">
                <el-input v-model="planForm.semester" placeholder="如：上学期/秋季学期" />
              </el-form-item>
              <el-form-item label="日期范围">
                <el-date-picker v-model="planDateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:100%;" />
              </el-form-item>
              <el-form-item label="计划描述">
                <el-input type="textarea" :rows="4" v-model="planForm.description" />
              </el-form-item>
              <el-form-item label="状态" v-if="isTeacher">
                <el-select v-model="planForm.status" style="width:100%">
                  <el-option :value="0" label="草稿" />
                  <el-option :value="1" label="进行中/发布" />
                  <el-option :value="2" label="已完成/归档" />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="planDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="savingPlan" @click="submitPlan">保 存</el-button>
            </span>
          </el-dialog>

          <el-dialog title="作业详情与统计" :visible.sync="hwStatsVisible" width="820px" :append-to-body="true" :close-on-click-modal="false">
            <div v-loading="hwStatsLoading">
              <div v-if="hwStats && hwStats.homework">
                <p><b>标题：</b>{{ hwStats.homework.title }}</p>
                <p><b>时间：</b>{{ hwStats.homework.startTime || '--' }} ~ {{ hwStats.homework.endTime || '--' }}</p>
                <p><b>班级：</b>
                  <span v-if="hwStats.classes && hwStats.classes.length">{{ hwStats.classes.map(c=>c.name).join('、') }}</span>
                  <span v-else>（未指定）</span>
                </p>
                <p><b>题库文件ID：</b>
                  <span v-if="hwStats.qbFileIds && hwStats.qbFileIds.length">{{ hwStats.qbFileIds.join(', ') }}</span>
                  <span v-else>（无）</span>
                </p>
                <div style="display:flex;gap:16px;margin:10px 0;flex-wrap:wrap;">
                  <el-tag type="info">指派：{{ hwStats.summary && hwStats.summary.totalAssigned || 0 }}</el-tag>
                  <el-tag type="warning">已开始：{{ hwStats.summary && hwStats.summary.started || 0 }}</el-tag>
                  <el-tag type="success">已提交：{{ hwStats.summary && hwStats.summary.submitted || 0 }}</el-tag>
                  <el-tag>提交率：{{ formatPercent(hwStats.summary && hwStats.summary.submitRate) }}</el-tag>
                  <el-tag>平均用时：{{ formatDuration(hwStats.summary && hwStats.summary.avgElapsedSeconds) }}</el-tag>
                </div>
                <el-table :data="hwStats.rows || []" size="small" border>
                  <el-table-column type="index" width="60" label="#" />
                  <el-table-column prop="studentId" width="90" label="ID" />
                  <el-table-column prop="username" min-width="160" label="用户名" />
                  <el-table-column prop="status" width="100" label="状态" />
                  <el-table-column label="开始时间" width="180">
                    <template slot-scope="{ row }">{{ formatDateTime(row.startTime) }}</template>
                  </el-table-column>
                  <el-table-column label="提交时间" width="180">
                    <template slot-scope="{ row }">{{ formatDateTime(row.submitTime) }}</template>
                  </el-table-column>
                  <el-table-column label="用时" width="120">
                    <template slot-scope="{ row }">{{ formatDuration(row.elapsedSeconds) }}</template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="hwStatsVisible=false">关 闭</el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'inform'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">课程通知</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateNotice">发布通知</el-button>
              <el-button size="small" @click="fetchNotices" :loading="noticeLoading">刷新</el-button>
            </div>
          </div>

          <div v-if="noticeLoading" class="loading-container" v-loading="true" element-loading-text="正在加载课程通知..." style="height:180px;" />

          <template v-else>
            <el-table v-if="noticeList && noticeList.length" :data="noticeList" size="small" border>
              <el-table-column type="index" width="60" label="#" />
              <el-table-column prop="title" label="标题" min-width="220" show-overflow-tooltip />
              <el-table-column prop="content" label="内容" min-width="320" show-overflow-tooltip />
              <el-table-column prop="createdAt" label="发布时间" width="200">
                <template slot-scope="{ row }">
                  {{ formatDateTime(row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column v-if="isTeacher" label="操作" width="180">
                <template slot-scope="{ row }">
                  <el-button type="text" size="mini" @click="openEditNotice(row)">编辑</el-button>
                  <el-popconfirm title="确定删除该通知吗？" @onConfirm="removeNotice(row)">
                    <el-button type="text" size="mini" slot="reference">删除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty-tip">
              <i class="el-icon-document"></i>
              <p>暂无课程通知</p>
            </div>

            <div style="margin-top: 12px; text-align: right;" v-if="noticeTotal > noticePageSize">
              <el-pagination
                layout="prev, pager, next"
                :current-page="noticePage"
                :page-size="noticePageSize"
                :total="noticeTotal"
                @current-change="handleNoticePageChange"
              />
            </div>
          </template>

          <el-dialog :title="noticeEditingId? '编辑通知':'发布通知'" :visible.sync="noticeDialogVisible" width="520px">
            <el-form :model="noticeForm" :rules="noticeRules" ref="noticeForm" label-width="100px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="noticeForm.title" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input type="textarea" :rows="6" v-model="noticeForm.content" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="noticeDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="savingNotice" @click="submitNotice">发 布</el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'profile'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">课程简介</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" :loading="profileSaving" @click="saveProfile">保存</el-button>
              <el-button size="small" @click="fetchProfile" :loading="profileLoading">刷新</el-button>
            </div>
          </div>
          <div v-loading="profileLoading">
            <template v-if="isTeacher">
              <el-input type="textarea" :rows="10" v-model="profileContent" placeholder="请输入课程简介" />
            </template>
            <template v-else>
              <div class="placeholder-block">{{ profileContent || '暂无课程简介' }}</div>
            </template>
          </div>
        </div>
        <div v-show="activeMenu === 'target'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">教学目标</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateObjective">发布目标</el-button>
              <el-button size="small" @click="fetchObjectives" :loading="objectiveLoading">刷新</el-button>
            </div>
          </div>

          <div v-if="objectiveLoading" class="loading-container" v-loading="true" element-loading-text="正在加载教学目标..." style="height:180px;" />

          <template v-else>
            <el-table v-if="objectiveList && objectiveList.length" :data="objectiveList" size="small" border>
              <el-table-column type="index" width="60" label="#" />
              <el-table-column prop="title" label="标题" min-width="220" show-overflow-tooltip />
              <el-table-column prop="content" label="内容" min-width="320" show-overflow-tooltip />
              <el-table-column prop="createdAt" label="发布时间" width="200">
                <template slot-scope="{ row }">
                  {{ formatDateTime(row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column v-if="isTeacher" label="操作" width="180">
                <template slot-scope="{ row }">
                  <el-button type="text" size="mini" @click="openEditObjective(row)">编辑</el-button>
                  <el-popconfirm title="确定删除该目标吗？" @onConfirm="removeObjective(row)">
                    <el-button type="text" size="mini" slot="reference">删除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty-tip">
              <i class="el-icon-reading"></i>
              <p>暂无教学目标</p>
            </div>

            <div style="margin-top: 12px; text-align: right;" v-if="objectiveTotal > objectivePageSize">
              <el-pagination
                layout="prev, pager, next"
                :current-page="objectivePage"
                :page-size="objectivePageSize"
                :total="objectiveTotal"
                @current-change="handleObjectivePageChange"
              />
            </div>
          </template>

          <el-dialog :title="objectiveEditingId? '编辑教学目标':'发布教学目标'" :visible.sync="objectiveDialogVisible" width="520px">
            <el-form :model="objectiveForm" :rules="objectiveRules" ref="objectiveForm" label-width="100px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="objectiveForm.title" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="内容" prop="content">
                <el-input type="textarea" :rows="6" v-model="objectiveForm.content" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="objectiveDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="savingObjective" @click="submitObjective">发 布</el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'chapter'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">课程章节</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateChapter">新建章节</el-button>
              <el-button v-if="!chapterSortMode" size="small" icon="el-icon-rank" @click="enterChapterSortMode">调整顺序</el-button>
              <template v-else>
                <el-button size="small" @click="cancelChapterSort">取消</el-button>
                <el-button type="primary" size="small" :loading="savingChapterSort" @click="saveChapterSort">保存排序</el-button>
              </template>
              <el-button size="small" @click="fetchChaptersWithSections" :loading="chapterLoading">刷新</el-button>
            </div>
            <div v-else>
              <el-button type="primary" size="small" icon="el-icon-document" @click="showMyAnswerRecords">
                📝 我的答题记录
              </el-button>
              <el-button size="small" @click="fetchChaptersWithSections" :loading="chapterLoading">刷新</el-button>
            </div>
          </div>

          <div v-if="chapterLoading" class="loading-container" v-loading="true" element-loading-text="正在加载课程章节..." style="height:180px;" />

          <template v-else>
            <!-- 章节折叠面板 -->
            <el-collapse v-if="chapterList && chapterList.length" v-model="activeChapters" class="chapter-collapse" style="margin-top:10px;">
              <div
                v-for="chapter in chapterList"
                :key="chapter.id"
                class="chapter-sort-item"
                :class="{ 'is-dragging': dragChapterId === chapter.id }"
                :draggable="isTeacher && chapterSortMode"
                @dragstart="onChapterDragStart(chapter.id)"
                @dragover.prevent="onChapterDragOver(chapter.id)"
                @drop.prevent="onChapterDrop(chapter.id)"
                @dragend="onChapterDragEnd"
              >
                <el-collapse-item :name="chapter.id">
                  <template slot="title">
                    <div class="chapter-collapse-title">
                      <div class="chapter-collapse-main">
                        <i v-if="isTeacher && chapterSortMode" class="el-icon-rank chapter-drag-hint"></i>
                        <i class="el-icon-folder-opened" style="margin-right:8px;color:#409EFF;font-size:18px;"></i>
                        <span style="font-weight:600;font-size:15px;">{{ chapter.title }}</span>
                        <el-tag size="mini" style="margin-left:12px;">{{ (chapter.sections || []).length }} 小节</el-tag>
                      </div>
                      <div v-if="isTeacher && !chapterSortMode" @click.stop style="display:flex;gap:8px;">
                        <el-button type="text" size="mini" @click="openEditChapter(chapter)">编辑</el-button>
                        <el-button type="text" size="mini" @click="openCreateSection(chapter)">添加小节</el-button>
                        <el-popconfirm title="确定删除该章节吗？将同时删除所有小节和资源" @onConfirm="removeChapter(chapter)">
                          <el-button type="text" size="mini" slot="reference" style="color:#F56C6C;">删除</el-button>
                        </el-popconfirm>
                      </div>
                      <div v-else-if="isTeacher && chapterSortMode" class="chapter-sort-tip">拖动章节与小节调整顺序</div>
                      <div class="chapter-collapse-actions">
                        <span class="chapter-toggle-indicator">
                          <span class="chapter-toggle-text">{{ isChapterExpanded(chapter.id) ? '点击收起' : '点击展开' }}</span>
                          <i class="el-icon-arrow-down" :class="{ 'is-expanded': isChapterExpanded(chapter.id) }"></i>
                        </span>
                      </div>
                    </div>
                  </template>

                  <!-- 章节描述 -->
                  <div v-if="chapter.content" class="chapter-description">
                    <i class="el-icon-info"></i>
                    <span>{{ chapter.content }}</span>
                  </div>

                  <!-- 小节列表 -->
                  <div v-if="chapter.sections && chapter.sections.length" class="section-list">
                    <div
                      v-for="(section, idx) in chapter.sections"
                      :key="section.id"
                      class="section-item"
                      :class="{ 'section-item-locked': isSectionLocked(chapter, section, idx), 'section-item-draggable': isTeacher && chapterSortMode, 'is-dragging': dragSectionId === section.id }"
                      :draggable="isTeacher && chapterSortMode"
                      @dragstart="onSectionDragStart(chapter.id, section.id)"
                      @dragover.prevent="onSectionDragOver(chapter.id, section.id)"
                      @drop.prevent="onSectionDrop(chapter.id, section.id)"
                      @dragend="onSectionDragEnd"
                    >
                      <div class="section-header" @click="chapterSortMode ? null : handleSectionClick(chapter, section, idx)">
                        <div class="section-left">
                          <i v-if="isTeacher && chapterSortMode" class="el-icon-rank section-drag-hint"></i>
                          <span class="section-number">{{ idx + 1 }}</span>
                          <i class="el-icon-video-play" style="color:#67C23A;margin:0 8px;"></i>
                          <span class="section-title">{{ section.title }}</span>
                          <el-tag v-if="section.durationMinutes" size="mini" type="info" style="margin-left:8px;">
                            {{ section.durationMinutes }}分钟
                          </el-tag>
                          <!-- 学生进度标识 -->
                          <el-tag v-if="!isTeacher && section.progress && section.progress.isCompleted" size="mini" type="success" style="margin-left:8px;">
                            <i class="el-icon-check"></i> 已完成
                          </el-tag>
                        </div>
                        <div class="section-right" v-if="isTeacher && !chapterSortMode" @click.stop>
                          <el-button type="text" size="mini" @click="openUploadResource(section)">上传资源</el-button>
                          <el-button type="text" size="mini" @click="openEditSection(section)">编辑</el-button>
                          <el-popconfirm title="确定删除该小节吗？" @onConfirm="removeSection(section)">
                            <el-button type="text" size="mini" slot="reference" style="color:#F56C6C;">删除</el-button>
                          </el-popconfirm>
                        </div>
                      </div>

                      <!-- 资源列表 -->
                      <div v-if="section.resources && section.resources.length" class="resource-list">
                        <div v-for="resource in section.resources" :key="resource.id" class="resource-item">
                          <i :class="getResourceIcon(resource.resourceType)" :style="{color: getResourceColor(resource.resourceType)}"></i>
                          <span class="resource-name">{{ resource.resourceName }}</span>
                          <span v-if="getResourceOptimizeState(resource).visible" class="resource-optimize-inline" :class="`resource-optimize-inline--${getResourceOptimizeState(resource).status}`">
                            {{ getResourceOptimizeState(resource).text }}
                          </span>
                          <span class="resource-size">{{ formatFileSize(resource.fileSize) }}</span>
                          <div class="resource-actions">
                            <el-button type="text" size="mini" @click.stop="handleResourceClick(chapter, section, idx, resource)">
                              {{ resource.resourceType === 'video' ? '播放' : '查看' }}
                            </el-button>
                            <el-button
                              v-if="isTeacher && resource.resourceType !== 'homework'"
                              type="text"
                              size="mini"
                              style="color:#67C23A;"
                              @click.stop="downloadResource(resource)"
                            >
                              下载
                            </el-button>
                            <el-button
                              v-if="isTeacher && resource.resourceType === 'video'"
                              type="text"
                              size="mini"
                              style="color:#409EFF;"
                              @click.stop="manageVideoMarkers(resource)"
                            >
                              标签
                            </el-button>
                            <el-button
                              v-if="isTeacher && resource.resourceType === 'video'"
                              type="text"
                              size="mini"
                              style="color:#67C23A;"
                              @click.stop="manageVideoQuestions(resource)"
                            >
                              插入内容
                            </el-button>
                            <el-button
                              v-if="isTeacher && resource.resourceType === 'video'"
                              type="text"
                              size="mini"
                              style="color:#E6A23C;"
                              @click.stop="viewVideoAnswerRecords(resource)"
                            >
                              📊 答题记录
                            </el-button>
                            <el-button
                              v-if="isTeacher && (resource.resourceType === 'ppt' || isPptFile(resource.fileExtension))"
                              type="text"
                              size="mini"
                              style="color:#409EFF;"
                              @click.stop="reconvertPptResource(resource)"
                            >
                              🔄 重新转换
                            </el-button>
                            <el-button v-if="isTeacher" type="text" size="mini" style="color:#F56C6C;" @click.stop="removeResource(resource)">删除</el-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="no-resources">暂无学习资源</div>
                      <div v-if="isSectionLocked(chapter, section, idx)" class="section-lock-overlay" @click="showSectionLimitMessage">
                        <div class="section-lock-card">
                          <i class="el-icon-lock"></i>
                          <span>开通会员后即可查看本小节资料</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="no-sections">
                    <i class="el-icon-folder"></i>
                    <span>暂无小节，点击"添加小节"开始创建</span>
                  </div>
                </el-collapse-item>
              </div>
            </el-collapse>

            <div v-else class="empty-tip">
              <i class="el-icon-folder"></i>
              <p>暂无课程章节</p>
            </div>
          </template>

          <!-- 新建/编辑章节对话框 -->
          <el-dialog :title="chapterEditingId ? '编辑课程章节' : '新建课程章节'" :visible.sync="chapterDialogVisible" width="520px">
            <el-form :model="chapterForm" :rules="chapterRules" ref="chapterForm" label-width="100px">
              <el-form-item label="标题" prop="title">
                <el-input v-model="chapterForm.title" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="排序">
                <el-input v-model.number="chapterForm.sort" type="number" min="0" />
              </el-form-item>
              <el-form-item label="内容">
                <el-input type="textarea" :rows="6" v-model="chapterForm.content" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="chapterDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="savingChapter" @click="submitChapter">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 新建/编辑小节对话框 -->
          <el-dialog :title="sectionEditingId ? '编辑小节' : '新建小节'" :visible.sync="sectionDialogVisible" width="520px">
            <el-form :model="sectionForm" ref="sectionForm" label-width="120px">
              <el-form-item label="小节标题" prop="title">
                <el-input v-model="sectionForm.title" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="小节描述">
                <el-input type="textarea" :rows="3" v-model="sectionForm.description" />
              </el-form-item>
              <el-form-item label="预计学习时长">
                <el-input v-model.number="sectionForm.durationMinutes" type="number" min="0">
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
              <el-form-item label="排序">
                <el-input v-model.number="sectionForm.sort" type="number" min="0" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="sectionDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="savingSection" @click="submitSection">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 上传资源对话框 -->
          <el-dialog title="上传资源" :visible.sync="uploadResourceVisible" width="600px">
            <el-form :model="resourceForm" ref="resourceForm" label-width="120px">
              <el-form-item label="资源类型">
                <el-select v-model="resourceForm.resourceType" placeholder="请选择" style="width:100%;">
                  <el-option label="视频" value="video" />
                  <el-option label="教案文档" value="document" />
                  <el-option label="PPT课件" value="ppt" />
                  <el-option label="作业" value="homework" />
                  <el-option label="其他" value="other" />
                </el-select>
              </el-form-item>
              <el-form-item label="资源名称">
                <el-input v-model="resourceForm.resourceName" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="资源描述">
                <el-input type="textarea" :rows="2" v-model="resourceForm.description" />
              </el-form-item>
              <el-form-item v-if="resourceForm.resourceType === 'homework'" label="选择作业">
                <el-select v-model="resourceForm.homeworkId" placeholder="请选择作业" style="width:100%;" filterable @change="handleHomeworkResourceChange">
                  <el-option
                    v-for="item in homeworkList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item v-else label="上传文件">
                <el-upload
                  ref="resourceUpload"
                  :action="uploadAction"
                  :show-file-list="false"
                  :http-request="customResourceUpload"
                  :before-upload="beforeResourceUpload"
                  :limit="1"
                  :file-list="resourceFileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    视频支持mp4, avi, mov等格式（请使用H.264编码，H.265/HEVC编码可能无法播放）；文档支持pdf, doc, docx, ppt, pptx等格式
                  </div>
                </el-upload>
                <div v-if="resourceUploadingFileName" class="resource-upload-status">
                  <div v-if="resourceUploadStatus === 'uploading'" class="resource-upload-status__content resource-upload-status__content--uploading">
                    <i class="el-icon-loading resource-upload-status__icon"></i>
                    <span class="resource-upload-status__name">{{ resourceUploadingFileName }}</span>
                    <span class="resource-upload-status__text">上传中 {{ resourceUploadPercent }}%</span>
                  </div>
                  <div v-else-if="resourceUploadStatus === 'optimizing'" class="resource-upload-status__content resource-upload-status__content--uploading">
                    <i class="el-icon-loading resource-upload-status__icon"></i>
                    <span class="resource-upload-status__name">{{ resourceUploadingFileName }}</span>
                    <span class="resource-upload-status__text">{{ resourceOptimizeMessage || ('视频优化处理中 ' + resourceOptimizeProgress + '%，请耐心等待...') }}</span>
                  </div>
                  <div v-else-if="resourceUploadStatus === 'success'" class="resource-upload-status__content resource-upload-status__content--success">
                    <i class="el-icon-success resource-upload-status__icon"></i>
                    <span class="resource-upload-status__name">{{ resourceUploadingFileName }}</span>
                    <span class="resource-upload-status__text">上传完成</span>
                  </div>
                  <div v-else-if="resourceUploadStatus === 'error'" class="resource-upload-status__content resource-upload-status__content--error">
                    <i class="el-icon-error resource-upload-status__icon"></i>
                    <span class="resource-upload-status__name">{{ resourceUploadingFileName }}</span>
                    <span class="resource-upload-status__text">上传失败，请重试</span>
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="uploadResourceVisible=false">取 消</el-button>
              <el-button type="primary" :loading="uploadingResource" @click="submitResource">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 视频播放对话框 -->
          <el-dialog title="视频学习" :visible.sync="videoPlayerVisible" width="900px" @close="closeVideoPlayer" :close-on-click-modal="false" :destroy-on-close="true">
            <!-- 模式切换 -->
            <div v-if="!isTeacher" style="margin-bottom:15px;">
              <el-radio-group v-model="videoPlayMode" size="small" @change="onPlayModeChange">
                <el-radio-button label="interactive">📚 随堂学习</el-radio-button>
                <el-radio-button label="review">📹 课后复习</el-radio-button>
              </el-radio-group>
              <span style="margin-left:15px;font-size:13px;color:#909399;">
                {{ videoPlayMode === 'interactive' ? '视频会随时弹出题目，请认真答题' : '普通视频播放模式' }}
              </span>
            </div>

            <!-- 视频播放器容器 -->
            <div ref="videoPlayerContainer" class="video-player-container">
              <video
                v-if="currentVideoUrl"
                ref="videoPlayer"
                controls
                preload="metadata"
                playsinline
                style="width:100%;max-height:480px;border-radius:4px;cursor:pointer;"
                @timeupdate="onVideoTimeUpdate"
                @loadedmetadata="onVideoLoaded"
                @error="onVideoError"
                @dblclick="toggleContainerFullscreen"
              >
                您的浏览器不支持视频播放
              </video>
              <!-- 视频加载错误提示 -->
              <div v-if="videoLoadError" class="video-error-tip">
                <i class="el-icon-warning" style="font-size:48px;color:#E6A23C;"></i>
                <p style="margin:15px 0 10px;font-size:16px;color:#303133;">视频无法播放</p>
                <p style="font-size:13px;color:#909399;margin-bottom:15px;">{{ videoLoadError }}</p>
                <el-button type="primary" size="small" @click="openVideoInNewTab">在新标签页打开</el-button>
              </div>

              <!-- 自定义进度条标签 -->
              <div v-if="videoMarkers.length > 0 && currentVideoDuration > 0" class="video-markers" :class="{ 'markers-fullscreen': isVideoFullscreen, 'markers-hidden': isVideoFullscreen && !videoControlsVisible }">
                <!-- 标签进度轨道 (点击可跳转) -->
                <div class="markers-timeline-track" @click="onMarkersTimelineClick">
                  <div class="markers-timeline-played" :style="{ width: (lastVideoTime / currentVideoDuration) * 90 + '%' }"></div>
                  <div class="markers-timeline-handle" :style="{ left: (lastVideoTime / currentVideoDuration) * 90 + '%' }"></div>
                </div>

                <div
                  v-for="marker in videoMarkers"
                  :key="marker.id"
                  class="video-marker"
                  :style="{left: (getMarkerPosition(marker.timeSeconds) * 0.9) + '%'}"
                  @click="jumpToTime(marker.timeSeconds)"
                >
                  <div class="marker-label">{{ marker.label }}</div>
                  <div class="marker-line"></div>
                  <div class="marker-dot"></div>
                </div>

                <!-- 极简全屏切换按钮 -->
                <div class="markers-fullscreen-toggle" @click="toggleContainerFullscreen" :title="isVideoFullscreen ? '退出全屏' : '全屏播放'">
                  <i :class="isVideoFullscreen ? 'el-icon-aim' : 'el-icon-full-screen'"></i>
                </div>
              </div>
            </div>

            <!-- 学习提示信息 -->
            <div v-if="videoPlayMode === 'interactive' && !isTeacher" style="margin-top:15px;padding:10px;background:#FFF7E6;border-radius:4px;font-size:13px;">
              ℹ️ 随堂学习模式：视频会在特定时间点暂停并弹出题目，请在限定时间内完成答题。
            </div>
          </el-dialog>

          <!-- 弹题对话框 (随堂内容弹窗：支持测试题与随堂投票插件) -->
          <el-dialog
            :title="currentQuestion && currentQuestion.questionText.startsWith('[VOTE_') ? '📊 随堂互动投票' : '📝 随堂随测题'"
            :visible.sync="questionPopVisible"
            width="700px"
            :close-on-click-modal="false"
            :show-close="false"
            append-to-body
          >
            <div v-if="currentQuestion" class="question-dialog-content">
              <!-- 倒计时 -->
              <div class="countdown-badge" :class="{ 'countdown-vote': currentQuestion.questionText.startsWith('[VOTE_') }">
                <i class="el-icon-timer"></i>
                <span>{{ questionCountdown }}</span> 秒
              </div>

              <!-- 随堂投票内容 -->
              <template v-if="currentQuestion.questionText.startsWith('[VOTE_')">
                <div class="vote-widget-container">
                  <div class="vote-header-tip">
                    <el-tag type="warning" size="small" effect="dark" style="margin-right: 8px;">
                      {{ currentQuestion.questionText.startsWith('[VOTE_SINGLE]') ? '投票·单选' : '投票·多选' }}
                    </el-tag>
                    <span>投票时间截止或提交后视频将自动继续播放</span>
                  </div>

                  <div class="question-content-box">
                    <div class="question-title vote-widget-title">
                      {{ currentQuestion.questionText.startsWith('[VOTE_SINGLE]') ? currentQuestion.questionText.replace('[VOTE_SINGLE]', '') : currentQuestion.questionText.replace('[VOTE_MULTI]', '') }}
                    </div>
                  </div>

                  <!-- 投票选项 -->
                  <div class="options-container">
                    <div
                      v-for="option in parseOptions(currentQuestion.optionset)"
                      :key="option.key"
                      class="option-card vote-option-card"
                      :class="{ selected: isOptionSelected(option.key) }"
                      @click="selectAnswer(option.key)"
                    >
                      <div class="option-checkbox-indicator">
                        <div v-if="isOptionSelected(option.key)" class="checkbox-indicator-checked">
                          <i class="el-icon-check"></i>
                        </div>
                      </div>
                      <div class="option-content">
                        <span class="option-label" style="color: #E6A23C;">{{ option.key }}.</span>
                        <span class="option-text">{{ option.value }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 普通题目内容 -->
              <template v-else>
                <!-- 题目内容 -->
                <div class="question-content-box">
                  <div class="question-title" v-html="renderLatex(currentQuestion.questionText)"></div>
                  <div v-if="currentQuestion.questionTextEn" class="question-title-en" v-html="renderLatex(currentQuestion.questionTextEn)"></div>
                </div>

                <!-- 选项 -->
                <div v-if="!questionResult" class="options-container">
                  <div
                    v-for="option in parseOptions(currentQuestion.optionset)"
                    :key="option.key"
                    class="option-card"
                    :class="{selected: studentAnswer === option.key}"
                    @click="selectAnswer(option.key)"
                  >
                    <div class="option-radio">
                      <div v-if="studentAnswer === option.key" class="radio-checked"></div>
                    </div>
                    <div class="option-content">
                      <span class="option-label">{{ option.key }}.</span>
                      <span class="option-text" v-html="renderLatex(option.value)"></span>
                    </div>
                  </div>
                </div>

                <!-- 答题结果（优化：只显示对错，不显示解析） -->
                <div v-if="questionResult" class="question-result">
                  <!-- 答题结果标题 -->
                  <div style="text-align:center;margin-bottom:20px;">
                    <div v-if="questionResult.isCorrect" style="font-size:64px;margin-bottom:15px;">
                      <i class="el-icon-success" style="color:#67C23A;"></i>
                    </div>
                    <div v-else style="font-size:64px;margin-bottom:15px;">
                      <i class="el-icon-error" style="color:#F56C6C;"></i>
                    </div>
                    <h3 style="margin:0;font-size:24px;font-weight:bold;">
                      {{ questionResult.isCorrect ? '🎉 回答正确！' : '❌ 回答错误' }}
                    </h3>
                    <p style="margin:10px 0 0 0;font-size:14px;color:#909399;">
                      {{ questionResult.isCorrect ? '继续加油！' : '继续努力！' }}
                    </p>
                  </div>

                  <!-- 只显示学生的答案 -->
                  <div style="margin-bottom:20px;">
                    <div v-if="questionResult.isCorrect" style="padding:20px;background:linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);border-radius:8px;text-align:center;">
                      <p style="margin:0;font-size:16px;color:#2E7D32;">
                        <i class="el-icon-success" style="font-size:20px;margin-right:5px;"></i>
                        你的答案：<span style="font-weight:bold;font-size:20px;margin-left:5px;">{{ studentAnswer }}</span>
                      </p>
                    </div>
                    <div v-else style="padding:20px;background:linear-gradient(135deg, #FFEBEE 0%, #FFCDD2 100%);border-radius:8px;text-align:center;">
                      <p style="margin:0;font-size:16px;color:#C62828;">
                        <i class="el-icon-error" style="font-size:20px;margin-right:5px;"></i>
                        你的答案：<span style="font-weight:bold;font-size:20px;margin-left:5px;">{{ studentAnswer }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </template>

              <!-- 按钮 -->
              <div slot="footer" class="dialog-footer" style="text-align:center;margin-top:20px;">
                <el-button v-if="!questionResult && (!currentQuestion.questionText.startsWith('[VOTE_') || studentAnswer)" type="primary" @click="submitAnswer" :disabled="!studentAnswer" style="padding: 10px 30px; border-radius: 20px;">
                  {{ currentQuestion.questionText.startsWith('[VOTE_') ? '提交投票' : '提交答案' }}
                </el-button>
                <el-button v-else-if="questionResult" type="success" @click="continueVideo" style="padding: 10px 30px; border-radius: 20px;">
                  继续播放 <i class="el-icon-video-play"></i>
                </el-button>
              </div>
            </div>
          </el-dialog>

          <!-- 小节详情对话框（学生查看） -->
          <el-dialog :title="currentSection ? currentSection.title : '小节详情'" :visible.sync="sectionDetailVisible" width="900px">
            <div v-if="currentSection" class="section-detail-content">
              <div v-if="currentSection.description" class="detail-description">
                <h4>小节介绍</h4>
                <p>{{ currentSection.description }}</p>
              </div>
              <div v-if="currentSection.resources && currentSection.resources.length">
                <h4>学习资源</h4>
                <div class="detail-resources">
                  <div v-for="resource in currentSection.resources" :key="resource.id" class="detail-resource-item" @click="handleCurrentSectionResourceClick(resource)">
                    <i :class="getResourceIcon(resource.resourceType)" :style="{color: getResourceColor(resource.resourceType)}"></i>
                    <div class="detail-resource-info">
                      <div class="detail-resource-name">{{ resource.resourceName }}</div>
                      <div class="detail-resource-meta">{{ formatFileSize(resource.fileSize) }}</div>
                    </div>
                    <div @click.stop>
                      <el-button type="primary" size="mini" @click="handleCurrentSectionResourceClick(resource)">
                        {{ resource.resourceType === 'video' ? '播放' : '查看' }}
                      </el-button>
                      <el-button
                        v-if="isTeacher"
                        type="success"
                        size="mini"
                        @click="downloadResource(resource)"
                      >
                        下载
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!isTeacher && currentSection.progress">
                <el-divider></el-divider>
                <div style="text-align:center;">
                  <el-button v-if="!currentSection.progress.isCompleted" type="success" @click="markSectionComplete">标记为已完成</el-button>
                  <el-tag v-else type="success" size="large"><i class="el-icon-check"></i> 已完成学习</el-tag>
                </div>
              </div>
            </div>
          </el-dialog>

          <!-- 视频标签管理 -->
          <video-marker-manager
            :visible.sync="markerManagerVisible"
            :section-id="currentMarkerSectionId"
            :video-url="currentMarkerVideoUrl"
            @saved="onMarkersSaved"
          />

          <!-- 视频问题管理 -->
          <video-question-manager
            :visible.sync="questionManagerVisible"
            :section-id="currentQuestionSectionId"
            :course-id="courseId"
            :repo-id="course.repoId"
            :video-url="currentQuestionVideoUrl"
            @saved="onQuestionsSaved"
          />

          <!-- 视频答题记录对话框（老师端） -->
          <video-answer-records-dialog
            :visible.sync="answerRecordsVisible"
            :section-id="currentAnswerRecordSectionId"
            :students="classStudents"
            :questions="videoQuestions"
            :class-options="classOptions"
          />

          <!-- 学生答题记录对话框（学生端） -->
          <student-video-answer-records
            :visible.sync="studentAnswerRecordsVisible"
            :course-id="courseId"
          />

          <!-- PPT在线预览对话框（学生端，带水印保护） -->
          <ppt-preview-dialog
            :visible.sync="pptPreviewVisible"
            :resource-id="pptPreviewResourceId"
            :resource-name="pptPreviewResourceName"
            @close="pptPreviewVisible = false"
          />
        </div>

        <!-- 知识点管理 -->
        <div v-show="activeMenu === 'knowledge'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">课程知识点</h3>
            <div style="display:flex;gap:8px;align-items:center;">
              <el-input v-model="knowledgeFilter" placeholder="搜索知识点" size="small" clearable style="width:260px;" />
              <el-button-group>
                <el-button size="small" :type="knowledgeViewMode==='tree'?'primary':'default'" icon="el-icon-s-operation" @click="knowledgeViewMode='tree'">树</el-button>
                <el-button size="small" :type="knowledgeViewMode==='grid'?'primary':'default'" icon="el-icon-menu" @click="knowledgeViewMode='grid'">卡片</el-button>
              </el-button-group>
              <el-button size="small" @click="fetchKnowledgeTree" :loading="knowledgeLoading">刷新</el-button>
            </div>
          </div>

          <div v-show="knowledgeViewMode==='tree'" class="knowledge-tree-wrap">
            <el-tree
              v-loading="knowledgeLoading"
              :data="knowledgeViewData"
              node-key="id"
              :props="knowledgeProps"
              :default-expanded-keys="knowledgeExpandedKeys"
              :highlight-current="true"
              :expand-on-click-node="false"
              :filter-node-method="knowledgeFilterMethod"
              ref="knowledgeTreeRef"
            >
              <span slot-scope="{ data }" class="custom-tree-node">
                <i class="el-icon-collection-tag knowledge-icon"></i>
                <span>{{ data.label }}</span>
              </span>
            </el-tree>
          </div>

          <div v-show="knowledgeViewMode==='grid'" class="knowledge-grid" v-loading="knowledgeLoading">
            <div v-for="root in knowledgeViewData" :key="root.id" class="knowledge-card">
              <div class="kc-title">
                <i class="el-icon-collection-tag knowledge-icon"></i>
                <span class="kc-title-text">{{ root.label }}</span>
              </div>
              <div class="kc-chips">
                <el-tag v-for="(name, idx) in flattenLabels(root)" :key="root.id+'-'+idx" size="small" effect="plain" class="kc-chip">{{ name }}</el-tag>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isTeacher" v-show="activeMenu === 'class-management'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">班级管理</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateClass">新建班级</el-button>
              <el-button size="small" @click="fetchClasses" :loading="classLoading">刷新</el-button>
            </div>
          </div>

          <template v-if="isTeacher">
            <div v-if="classLoading" class="loading-container" v-loading="true" element-loading-text="正在加载班级..." style="height:180px;" />
            <template v-else>
              <el-table :data="classList" size="small" border>
                <el-table-column type="index" width="60" label="#" />
                <el-table-column prop="name" label="班级名称" min-width="200" />
                <el-table-column prop="inviteCode" label="邀请码" width="160" />
                <el-table-column prop="description" label="描述" min-width="240" show-overflow-tooltip />
                <el-table-column prop="createdAt" label="创建时间" width="200">
                  <template slot-scope="{ row }">{{ formatDateTime(row.createdAt) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="360">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="openEditClass(row)">编辑</el-button>
                    <el-button type="text" size="mini" @click="openAddStudent(row)">拉人</el-button>
                    <el-button type="text" size="mini" @click="openMembers(row)">成员</el-button>
                    <el-popconfirm title="确定删除该班级吗？" @onConfirm="removeClass(row)">
                      <el-button type="text" size="mini" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </template>

          <template v-else>
            <div style="display:flex;gap:8px;align-items:center;">
              <el-input v-model="joinInviteCode" placeholder="输入班级邀请码加入" size="small" style="width:260px;" />
              <el-button type="primary" size="small" :loading="joinLoading" @click="studentJoinByInvite">加入</el-button>
            </div>
          </template>

          <el-dialog :title="classEditingId? '编辑班级':'新建班级'" :visible.sync="classDialogVisible" width="520px">
            <el-form :model="classForm" :rules="classRules" ref="classForm" label-width="100px">
              <el-form-item label="班级名称" prop="name">
                <el-input v-model="classForm.name" maxlength="128" show-word-limit />
              </el-form-item>
              <el-form-item label="邀请码">
                <el-input v-model="classForm.inviteCode" placeholder="留空自动生成" maxlength="32" />
              </el-form-item>
              <el-form-item label="描述">
                <el-input type="textarea" :rows="3" v-model="classForm.description" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="classDialogVisible=false">取 消</el-button>
              <el-button type="primary" :loading="classSaving" @click="submitClass">保 存</el-button>
            </span>
          </el-dialog>

          <el-dialog title="拉学生进班（按用户名）" :visible.sync="addStudentVisible" width="860px" :close-on-click-modal="false">
            <div style="display:flex; gap:8px; align-items:center; margin-bottom:12px; flex-wrap:wrap;">
              <el-input
                v-model="addStudentKeyword"
                size="small"
                clearable
                placeholder="输入学生username搜索（留空显示全部）"
                style="width: 320px;"
                @keyup.enter.native="fetchStudentCandidates(1)"
              />
              <el-button type="primary" size="small" :loading="addStudentCandidatesLoading" @click="fetchStudentCandidates(1)">查询</el-button>
              <el-button size="small" :disabled="addStudentCandidatesLoading" @click="resetStudentCandidates">重置</el-button>
              <span style="color:#909399; font-size:12px;">点击“拉取”即可将学生加入当前班级</span>
            </div>

            <el-table
              :data="addStudentCandidates"
              size="small"
              border
              v-loading="addStudentCandidatesLoading"
              element-loading-text="正在加载学生列表..."
            >
              <el-table-column prop="id" label="ID" width="90" />
              <el-table-column prop="userName" label="username" min-width="180" show-overflow-tooltip />
              <el-table-column prop="realName" label="姓名" min-width="140" show-overflow-tooltip />
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="{ row }">
                  <el-button
                    type="primary"
                    size="mini"
                    :loading="addStudentLoading"
                    :disabled="addStudentLoading || !!addStudentJoinedMap[Number(row.id)]"
                    @click="pullStudentToClass(row)"
                  >拉取</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div style="margin-top: 12px; text-align: right;" v-if="addStudentCandidateTotal > addStudentCandidatePageSize">
              <el-pagination
                layout="prev, pager, next"
                :current-page="addStudentCandidatePage"
                :page-size="addStudentCandidatePageSize"
                :total="addStudentCandidateTotal"
                @current-change="handleCandidatePageChange"
              />
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="addStudentVisible=false">关 闭</el-button>
            </span>
          </el-dialog>

          <el-dialog title="班级成员" :visible.sync="membersVisible" width="520px">
            <div v-if="membersLoading" class="loading-container" v-loading="true" element-loading-text="正在加载成员..." style="height:160px;" />
            <template v-else>
              <el-table :data="membersList" size="small" border>
                <el-table-column type="index" width="60" label="#" />
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="userName" label="用户名" min-width="180" />
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row }">
                    <el-popconfirm title="确定移除该成员吗？" @onConfirm="confirmRemoveMember(row)">
                      <el-button type="text" size="mini" slot="reference">移除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!membersList || !membersList.length" class="empty-tip" style="margin-top:8px;">
                <i class="el-icon-user"></i>
                <p>暂无成员</p>
              </div>
            </template>
            <span slot="footer" class="dialog-footer">
              <el-button @click="membersVisible=false">关 闭</el-button>
              <el-button @click="refreshMembers" :loading="membersLoading">刷 新</el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'question-bank'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">{{ isTeacher ? '题目管理' : '题目练习' }}</h3>
            <div v-if="isTeacher">
              <el-button type="primary" size="small" @click="openQuestionDialog">新建题目</el-button>
              <el-button type="success" size="small" @click="openSelectFromLibrary">从题库选题</el-button>
              <el-button size="small" @click="loadQuestions" :loading="questionLoading">刷新</el-button>
            </div>
            <div v-else>
              <el-button size="small" @click="loadQuestions" :loading="questionLoading">刷新</el-button>
            </div>
          </div>

          <!-- 老师侧：标签页切换 -->
          <el-tabs v-if="isTeacher" v-model="questionTab" style="margin-top:10px;">
            <el-tab-pane label="我的题库" name="private">
              <el-table :data="questionList" size="small" border>
                <el-table-column type="index" width="60" label="#" />
                <el-table-column prop="contentCn" label="题目内容" min-width="280" show-overflow-tooltip />
                <el-table-column prop="answer" label="答案" width="80" />
                <el-table-column prop="difficulty" label="难度" width="80" />
                <el-table-column label="知识点" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.knowledgeNames">{{ scope.row.knowledgeNames }}</span>
                    <span v-else-if="scope.row.knowledge" style="color:#999;">{{ scope.row.knowledge }}</span>
                    <span v-else style="color:#ccc;">--</span>
                  </template>
                </el-table-column>
                <el-table-column prop="year" label="年份" width="80" />
                <el-table-column label="操作" width="200">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="openQuestionDialog(row)">编辑</el-button>
                    <el-popconfirm title="确定从我的题库移除该题目吗？" @onConfirm="removeQuestionFromMyCourse(row.id)">
                      <el-button type="text" size="mini" slot="reference">移除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!questionLoading && (!questionList || !questionList.length)" class="empty-tip" style="margin-top:20px;">
                <i class="el-icon-collection-tag"></i>
                <p>暂无私有题目，点击"新建题目"或"从题库选题"开始添加</p>
              </div>
            </el-tab-pane>
          </el-tabs>

          <!-- 学生侧：题目列表without answer -->
          <el-table v-else :data="questionList" size="small" border style="margin-top:10px;">
            <el-table-column type="index" width="60" label="#" />
            <el-table-column prop="contentCn" label="题目内容" min-width="350" show-overflow-tooltip />
            <el-table-column prop="difficulty" label="难度" width="100" />
            <!-- <el-table-column prop="knowledge" label="知识点" width="180" show-overflow-tooltip /> -->
            <el-table-column prop="year" label="年份" width="100" />
            <el-table-column label="操作" width="150">
              <template slot-scope="{ row }">
                <el-button type="primary" size="mini" @click="startAnswering(row)">开始答题</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="!questionLoading && (!questionList || !questionList.length)" class="empty-tip" style="margin-top:20px;">
            <i class="el-icon-collection-tag"></i>
            <p>{{ isTeacher ? '暂无题目，点击新建题目开始添加' : '暂无题目' }}</p>
          </div>

          <!-- 从题库选题对话框 -->
          <el-dialog title="从题库选题" :visible.sync="selectLibraryVisible" width="900px">
            <div style="margin-bottom:12px;">
              <el-input v-model="librarySearchKeyword" placeholder="搜索题目内容、知识点" style="width:300px;" clearable @clear="loadLibraryQuestions">
                <el-button slot="append" icon="el-icon-search" @click="loadLibraryQuestions"></el-button>
              </el-input>
              <el-button style="margin-left:12px;" @click="loadLibraryQuestions" :loading="libraryLoading">刷新</el-button>
            </div>
            <el-table :data="libraryQuestionList" size="small" border max-height="450" @selection-change="handleLibrarySelectionChange">
              <el-table-column type="selection" width="55" />
              <el-table-column type="index" width="60" label="#" />
              <el-table-column prop="contentCn" label="题目内容" min-width="300" show-overflow-tooltip />
              <el-table-column prop="answer" label="答案" width="80" />
              <el-table-column prop="difficulty" label="难度" width="80" />
              <!-- <el-table-column prop="knowledge" label="知识点" width="120" show-overflow-tooltip /> -->
            </el-table>
            <div v-if="!libraryLoading && (!libraryQuestionList || !libraryQuestionList.length)" class="empty-tip" style="margin-top:20px;">
              <i class="el-icon-collection-tag"></i>
              <p>公共题库暂无题目</p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="selectLibraryVisible=false">取 消</el-button>
              <el-button type="primary" @click="confirmSelectQuestions" :disabled="selectedLibraryQuestions.length === 0">
                添加到我的题库 ({{ selectedLibraryQuestions.length }})
              </el-button>
            </span>
          </el-dialog>

          <!-- 查看题目详情对话框 -->
          <el-dialog title="题目详情" :visible.sync="viewQuestionVisible" width="720px">
            <div v-if="viewingQuestion">
              <p><b>题目内容(中)：</b><span v-html="renderLatex(viewingQuestion.contentCn)"></span></p>
              <p v-if="viewingQuestion.contentEn"><b>题目内容(英)：</b><span v-html="renderLatex(viewingQuestion.contentEn)"></span></p>
              <div v-if="viewingQuestion.optionsEn || viewingQuestion.optionsCn">
                <p><b>选项：</b></p>
                <div v-for="(opt, idx) in parseOptions(viewingQuestion.optionsEn || viewingQuestion.optionsCn)" :key="idx" style="margin:4px 0 4px 20px;">
                  <span style="font-weight: 600;">{{ opt.key }}.</span>
                  <span v-html="renderLatex(opt.value)"></span>
                </div>
              </div>
              <p><b>答案：</b>{{ viewingQuestion.answer }}</p>
              <p v-if="viewingQuestion.analysisCn"><b>解析(中)：</b><span v-html="renderLatex(viewingQuestion.analysisCn)"></span></p>
              <p v-if="viewingQuestion.analysisEn"><b>解析(英)：</b><span v-html="renderLatex(viewingQuestion.analysisEn)"></span></p>
              <p v-if="viewingQuestion.difficulty"><b>难度：</b>{{ viewingQuestion.difficulty }}</p>
              <p v-if="viewingQuestion.knowledge"><b>知识点：</b>{{ viewingQuestion.knowledge }}</p>
              <p v-if="viewingQuestion.year"><b>年份：</b>{{ viewingQuestion.year }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="viewQuestionVisible=false">关 闭</el-button>
            </span>
          </el-dialog>

          <!-- 学生答题对话框 -->
          <el-dialog
            title="答题练习"
            :visible.sync="answerDialogVisible"
            width="760px"
            @close="closeAnswerDialog"
            :close-on-click-modal="false">
            <div v-if="currentQuestion" class="question-container">
              <!-- 题目内容 -->
              <div class="question-content">
                <div class="question-label">题目</div>
                <div class="question-text" v-html="renderLatex(currentQuestion.contentCn)"></div>
              </div>

              <!-- 选项区域 -->
              <div class="options-area" v-if="(currentQuestion.optionsEn || currentQuestion.optionsCn) && !showResult">
                <div class="options-label">请选择答案：</div>
                <div class="options-grid">
                  <div
                    v-for="(opt, idx) in parseOptions(currentQuestion.optionsEn || currentQuestion.optionsCn)"
                    :key="idx"
                    class="option-card"
                    :class="{ 'option-selected': isOptionSelected(opt.key) }"
                    @click="toggleOption(opt.key)">
                    <div class="option-radio">
                      <i v-if="isOptionSelected(opt.key)" class="el-icon-check"></i>
                    </div>
                    <div class="option-text">
                      <span style="font-weight: 600; margin-right: 8px;">{{ opt.key }}.</span>
                      <span v-html="renderLatex(opt.value)"></span>
                    </div>
                  </div>
                </div>
                <div class="selected-answer" v-if="userAnswer">
                  <span style="color:#909399;">已选择：</span>
                  <span style="color:#409EFF;font-weight:600;">{{ userAnswer }}</span>
                </div>
              </div>

              <!-- 结果展示 -->
              <div v-if="showResult" class="result-area">
                <!-- 正确答案 -->
                <div v-if="isCorrect" class="result-correct">
                  <div class="result-icon">
                    <i class="el-icon-circle-check"></i>
                  </div>
                  <div class="result-content">
                    <div class="result-title">回答正确！</div>
                    <div class="result-desc">恭喜你，答对了！继续加油！</div>
                  </div>
                </div>

                <!-- 错误答案 -->
                <div v-else class="result-wrong">
                  <div class="result-icon">
                    <i class="el-icon-circle-close"></i>
                  </div>
                  <div class="result-content">
                    <div class="result-title">回答错误</div>
                    <div class="result-detail">
                      <div class="answer-line">
                        <span class="label">你的答案：</span>
                        <span class="value wrong">{{ userAnswer }}</span>
                      </div>
                      <div class="answer-line">
                        <span class="label">正确答案：</span>
                        <span class="value correct">{{ currentQuestion.answer }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 解析 -->
                <div v-if="currentQuestion.analysisCn" class="analysis-section">
                  <div class="analysis-title">
                    <i class="el-icon-document"></i> 答案解析
                  </div>
                  <div class="analysis-content" v-html="renderLatex(currentQuestion.analysisCn)"></div>
                </div>
              </div>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="answerDialogVisible=false" size="medium">取 消</el-button>
              <el-button
                v-if="!showResult"
                type="primary"
                size="medium"
                :loading="submittingAnswer"
                :disabled="!userAnswer"
                @click="submitAnswer">
                提交答案
              </el-button>
              <el-button v-else type="success" size="medium" @click="answerDialogVisible=false">完 成</el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'homework'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">{{ isTeacher ? '作业管理' : '我的作业' }}</h3>
            <div>
              <template v-if="isTeacher">
                <el-button type="primary" size="small" @click="openHwDialog">新建作业</el-button>
                <el-button size="small" @click="loadTeacherHomeworks" :loading="homeworkLoading">刷新</el-button>
              </template>

            </div>
          </div>
          <el-table v-if="isTeacher && homeworkList && homeworkList.length" :data="homeworkList" size="small" border style="margin-top:10px;">
            <el-table-column type="index" width="60" label="#" />
            <el-table-column prop="title" label="标题" min-width="220" />
            <el-table-column label="限制时长" width="120">
              <template slot-scope="{ row }">{{ (row.timeLimitMinutes||0) > 0 ? (row.timeLimitMinutes + ' 分钟') : '不限时' }}</template>
            </el-table-column>
            <el-table-column label="开始/截止" min-width="260">
              <template slot-scope="{ row }">{{ (row.startTime||'--') }} ~ {{ (row.endTime||'--') }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="{ row }">{{ row.status===1 ? '已发布' : (row.status===2 ? '已结束' : '草稿') }}</template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="{ row }">
                <el-button type="text" size="mini" @click="openHwStats(row)">统计</el-button>
                <el-button type="text" size="mini" @click="openEditHomework(row)">编辑</el-button>
                <el-popconfirm title="确定删除该作业吗？删除后学生提交记录也会被清理" @onConfirm="removeHomework(row)">
                  <el-button type="text" size="mini" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-else-if="!isTeacher && homeworkList && homeworkList.length" :key="hwStudentTableKey" :data="homeworkList" size="small" border style="margin-top:10px;">
            <el-table-column type="index" width="60" label="#" />
            <el-table-column prop="title" label="标题" min-width="180" />
            <el-table-column label="时限" width="100">
              <template slot-scope="{ row }">{{ (row.timeLimitMinutes||0) > 0 ? (row.timeLimitMinutes + ' 分钟') : '不限时' }}</template>
            </el-table-column>
            <el-table-column label="开始/截止" min-width="200">
              <template slot-scope="{ row }">{{ (row.startTime||'--') }} ~ {{ (row.endTime||'--') }}</template>
            </el-table-column>
            <el-table-column label="得分" width="140" align="center">
              <template slot-scope="{ row }">
                <span v-if="row.submitted && row.scoreInfo">
                  <span :style="{color: getHomeworkScoreColor(row.scoreInfo.score, row.scoreInfo.totalScore), fontWeight: '600', fontSize: '16px'}">
                    {{ row.scoreInfo.score }}
                  </span>
                  <span style="color: #909399;"> / {{ row.scoreInfo.totalScore }}</span>
                  <el-tag
                    :type="getAccuracyTagType(row.scoreInfo.accuracy)"
                    size="mini"
                    style="margin-left: 5px;">
                    {{ row.scoreInfo.accuracy }}%
                  </el-tag>
                </span>
                <span v-else style="color: #909399;">--</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="{ row }">
                <el-tag v-if="row.submitted" type="success" size="mini">已完成</el-tag>
                <el-tag v-else type="info" size="mini">未完成</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="{ row }">
                <el-button
                  v-if="!row.submitted"
                  type="primary"
                  size="mini"
                  @click="openDoHomework(row)"
                  :loading="studentHomeworkLoading">
                  开始
                </el-button>
                <el-button
                  v-else
                  type="success"
                  size="mini"
                  @click="openDoHomework(row)">
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="empty-tip">暂无作业</div>

          <!-- 学生开始作业对话框 -->
          <el-dialog
            :title="hwDoData.homework ? hwDoData.homework.title : '作业'"
            :visible.sync="hwDoDialogVisible"
            width="800px"
            :close-on-click-modal="false"
            @close="closeDoDialog">
            <!-- 作业信息头部 -->
            <div v-if="hwDoData.homework" class="homework-header">
              <div class="hw-info-row">
                <span><i class="el-icon-document"></i> 题目数：{{ hwDoData.questions ? hwDoData.questions.length : 0 }}</span>
                <span v-if="hwDoData.questions && hwDoData.questions.length">
                  <i class="el-icon-edit"></i> 当前：第 {{ hwCurrentQuestionIndex + 1 }} / {{ hwDoData.questions.length }} 题
                </span>
                <span v-if="!hwDoData.isViewOnly && (hwDoData.homework.timeLimitMinutes||0) > 0" class="countdown-timer" :class="{ 'time-warning': hwDoData.remainSeconds !== null && hwDoData.remainSeconds < 300, 'time-danger': hwDoData.remainSeconds !== null && hwDoData.remainSeconds < 60 }">
                  <i class="el-icon-time"></i> 剩余时间：{{ formatCountdown(hwDoData.remainSeconds) }}
                </span>
                <el-tag v-if="hwDoData.isViewOnly" type="success" size="small">
                  <i class="el-icon-circle-check"></i> 已完成
                </el-tag>
              </div>
              <el-progress
                v-if="hwDoData.questions && hwDoData.questions.length"
                :percentage="Math.round((hwCurrentQuestionIndex + 1) / hwDoData.questions.length * 100)"
                :format="() => `${hwCurrentQuestionIndex + 1}/${hwDoData.questions.length}`"
                style="margin-top:10px;"
              />
            </div>

            <!-- 题目内容 -->
            <div v-if="hwCurrentQuestion" class="question-container" style="margin-top:20px;">
              <!-- 题目 -->
              <div class="question-content">
                <div class="question-label">题目 {{ hwCurrentQuestionIndex + 1 }}</div>
                <div class="question-text" v-html="renderLatex(hwCurrentQuestion.contentCn)"></div>
                <!-- 题目图片 -->
                <div v-if="hwCurrentQuestion.imagePaths || hwCurrentQuestion.image" class="question-images" style="margin-top: 12px;">
                  <img
                    v-for="(imgUrl, idx) in getQuestionImages(hwCurrentQuestion)"
                    :key="idx"
                    :src="imgUrl"
                    alt="题目图片"
                    style="max-width: 100%; margin-bottom: 8px; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);"
                    @error="handleQuestionImageError($event)"
                  />
                </div>
              </div>

              <!-- 选项区域 -->
              <div class="options-area" v-if="(hwCurrentQuestion.optionsEn || hwCurrentQuestion.optionsCn) && !hwShowResult">
                <div class="options-label">
                  {{ hwDoData.isViewOnly ? '题目选项：' : '请选择答案：' }}
                  <el-tag v-if="hwDoData.isViewOnly" type="info" size="mini" style="margin-left: 8px;">查看模式</el-tag>
                </div>
                <div class="options-grid">
                  <div
                    v-for="(opt, idx) in parseOptions(hwCurrentQuestion.optionsEn || hwCurrentQuestion.optionsCn)"
                    :key="idx"
                    class="option-card"
                    :class="{ 'option-selected': isHwOptionSelected(opt.key), 'option-disabled': hwDoData.isViewOnly || (hwDoData.remainSeconds === 0 && hwDoData.homework.timeLimitMinutes > 0) }"
                    @click="(hwDoData.isViewOnly || (hwDoData.remainSeconds === 0 && hwDoData.homework.timeLimitMinutes > 0)) ? null : toggleHwOption(opt.key)">
                    <div class="option-radio">
                      <i v-if="isHwOptionSelected(opt.key)" class="el-icon-check"></i>
                    </div>
                    <div class="option-text">
                      <span style="font-weight: 600; margin-right: 8px;">{{ opt.key }}.</span>
                      <span v-html="renderLatex(opt.value)"></span>
                      <!-- 选项图片 -->
                      <div v-if="getOptionImage(hwCurrentQuestion, idx)" style="margin-top: 8px;">
                        <img
                          :src="getOptionImage(hwCurrentQuestion, idx)"
                          alt="选项图片"
                          style="max-width: 100%; max-height: 200px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
                          @error="handleQuestionImageError($event)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selected-answer" v-if="hwCurrentAnswer">
                  <span style="color:#909399;">{{ hwDoData.isViewOnly ? '已提交答案：' : '已选择：' }}</span>
                  <span style="color:#409EFF;font-weight:600;">{{ hwCurrentAnswer }}</span>
                </div>
                <!-- 查看模式下的查看答案按钮 -->
                <div v-if="hwDoData.isViewOnly" style="margin-top: 20px; text-align: center;">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-view"
                    @click="hwShowResult = true">
                    查看答案与解析
                  </el-button>
                </div>
              </div>

              <!-- 答题结果（查看模式下直接显示答案，不显示对错提示） -->
              <div v-if="hwShowResult" class="result-area">
                <!-- 查看模式：直接显示答案 -->
                <div v-if="hwDoData.isViewOnly" class="answer-view-mode">
                  <div class="answer-info-card">
                    <div class="answer-info-row">
                      <span class="info-label">你的答案：</span>
                      <span class="info-value" style="color: #409EFF; font-weight: 600; font-size: 16px;">{{ hwCurrentAnswer || '未作答' }}</span>
                    </div>
                    <div class="answer-info-row" style="margin-top: 12px;">
                      <span class="info-label">正确答案：</span>
                      <span class="info-value" style="color: #67C23A; font-weight: 600; font-size: 16px;">{{ hwCurrentQuestion.answer }}</span>
                    </div>
                  </div>
                </div>

                <!-- 答题模式：显示对错结果 -->
                <div v-if="!hwDoData.isViewOnly && hwIsCorrect" class="result-correct">
                  <div class="result-icon">
                    <i class="el-icon-circle-check"></i>
                  </div>
                  <div class="result-content">
                    <div class="result-title">回答正确！</div>
                    <div class="result-desc">继续加油！</div>
                  </div>
                </div>

                <div v-else-if="!hwDoData.isViewOnly" class="result-wrong">
                  <div class="result-icon">
                    <i class="el-icon-circle-close"></i>
                  </div>
                  <div class="result-content">
                    <div class="result-title">回答错误</div>
                    <div class="result-detail">
                      <div class="answer-line">
                        <span class="label">你的答案：</span>
                        <span class="value wrong">{{ hwCurrentAnswer }}</span>
                      </div>
                      <div class="answer-line">
                        <span class="label">正确答案：</span>
                        <span class="value correct">{{ hwCurrentQuestion.answer }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="hwCurrentQuestion.analysisCn" class="analysis-section">
                  <div class="analysis-title">
                    <i class="el-icon-document"></i> 答案解析
                  </div>
                  <div class="analysis-content" v-html="renderLatex(hwCurrentQuestion.analysisCn)"></div>
                </div>
              </div>
            </div>

            <!-- 空状态 -->
            <div v-else-if="!hwDoData.questions || hwDoData.questions.length === 0" class="empty-tip">
              <i class="el-icon-warning"></i>
              <p>该作业暂无题目</p>
            </div>

            <span slot="footer" class="dialog-footer">
              <!-- 查看模式：显示翻页、隐藏/显示答案和关闭按钮 -->
              <template v-if="hwDoData.isViewOnly">
                <el-button
                  v-if="hwCurrentQuestionIndex > 0"
                  @click="hwCurrentQuestionIndex--; hwCurrentAnswer = ''; hwShowResult = false;">
                  上一题
                </el-button>
                <el-button
                  v-if="hwCurrentQuestionIndex < (hwDoData.questions || []).length - 1"
                  type="primary"
                  @click="hwCurrentQuestionIndex++; hwCurrentAnswer = ''; hwShowResult = false;">
                  下一题
                </el-button>
                <el-button
                  v-if="hwShowResult"
                  @click="hwShowResult = false">
                  隐藏答案
                </el-button>
                <el-button
                  type="success"
                  icon="el-icon-download"
                  @click="exportHomeworkToPDF"
                  :loading="exportingPDF">
                  导出PDF
                </el-button>
                <el-button @click="closeDoDialog">关 闭</el-button>
              </template>

              <!-- 答题模式：显示正常的答题按钮 -->
              <template v-else>
                <el-button @click="closeDoDialog">关 闭</el-button>
                <el-button
                  v-if="hwCurrentQuestion && !hwShowResult"
                  type="primary"
                  :disabled="!hwCurrentAnswer || (hwDoData.remainSeconds === 0 && hwDoData.homework.timeLimitMinutes > 0)"
                  @click="submitHwCurrentAnswer">
                  提交答案
                </el-button>
                <el-button
                  v-if="hwShowResult && hwCurrentQuestionIndex < (hwDoData.questions || []).length - 1"
                  type="success"
                  :disabled="hwDoData.remainSeconds === 0 && hwDoData.homework.timeLimitMinutes > 0"
                  @click="goToNextHwQuestion">
                  下一题
                </el-button>
                <el-button
                  v-if="hwShowResult && hwCurrentQuestionIndex === (hwDoData.questions || []).length - 1"
                  type="success"
                  @click="finishHomework">
                  完成作业
                </el-button>
              </template>
            </span>
          </el-dialog>

          <el-dialog :title="editingHwId ? '编辑作业' : '新建作业'" :visible.sync="hwDialogVisible" width="600px">
            <el-form label-width="96px" size="small">
              <el-form-item label="标题">
                <el-input v-model="hwForm.title" maxlength="200" show-word-limit />
              </el-form-item>
              <el-form-item label="说明">
                <el-input type="textarea" :rows="3" v-model="hwForm.description" />
              </el-form-item>
              <el-form-item label="限制时长">
                <el-input-number v-model="hwForm.timeLimitMinutes" :min="0" :max="600" />
                <span style="margin-left:8px;color:#909399;">分钟（0 表示不限时）</span>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker v-model="hwForm.startTime" type="datetime" placeholder="可选" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
              <el-form-item label="截止时间">
                <el-date-picker v-model="hwForm.endTime" type="datetime" placeholder="可选" value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
              <el-form-item label="发布班级">
                <el-select v-model="hwForm.classIds" multiple placeholder="选择班级" style="width:100%">
                  <el-option v-for="c in classOptions" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
              </el-form-item>
              <el-form-item label="作业题目">
                <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:8px;">
                  <el-button type="primary" size="mini" @click="openHomeworkQuestionSelector">从题库选题</el-button>
                  <el-button type="success" size="mini" @click="openCreateQuestionForHomework">新建题目</el-button>
                  <span v-if="hwForm.questions && hwForm.questions.length">
                    已选 {{ hwForm.questions.length }} 道题，总分：{{ calculateTotalScore() }} 分
                  </span>
                  <span v-else style="color:#909399;">未选择</span>
                </div>
                <div v-if="hwForm.questions && hwForm.questions.length" style="max-height:300px;overflow-y:auto;border:1px solid #e4e7ed;border-radius:4px;padding:8px;">
                  <el-table :data="hwForm.questions" size="mini" border>
                    <el-table-column label="序号" width="60" align="center">
                      <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                    </el-table-column>
                    <el-table-column label="题目ID" prop="id" width="80" align="center" />
                    <el-table-column label="分数" width="120" align="center">
                      <template slot-scope="scope">
                        <el-input-number
                          v-model="scope.row.score"
                          :min="1"
                          :max="100"
                          size="mini"
                          @change="onQuestionScoreChange" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80" align="center">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" icon="el-icon-delete" @click="removeQuestionFromHomework(scope.$index)">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="hwDialogVisible=false">取 消</el-button>
              <el-button type="primary" @click="submitHwDialog">确 定</el-button>
            </span>
          </el-dialog>

          <!-- 作业选择题目对话框 -->
          <el-dialog title="选择作业题目" :visible.sync="hwQuestionSelectorVisible" width="900px" :append-to-body="true" :close-on-click-modal="false">
            <div style="margin-bottom:16px;display:flex;align-items:center;gap:16px;">
              <el-radio-group v-model="hwQuestionSource" @change="loadHomeworkQuestions">
                <el-radio-button label="course">我的题库</el-radio-button>
                <el-radio-button label="public">总题库</el-radio-button>
              </el-radio-group>
              <el-input v-model="hwQuestionSearchKeyword" placeholder="搜索题目内容、知识点" style="width:300px;" clearable>
                <el-button slot="append" icon="el-icon-search" @click="loadHomeworkQuestions"></el-button>
              </el-input>
              <el-cascader
                v-model="hwQuestionKnowledgeFilter"
                placeholder="按知识点筛选"
                clearable
                filterable
                :options="hwKnowledgeOptions"
                :props="hwKnowledgeCascaderProps"
                style="width:220px;"
                @change="applyHomeworkQuestionFilters"
              />
              <el-button @click="loadHomeworkQuestions" :loading="hwQuestionLoading">刷新</el-button>
            </div>
            <el-table :data="hwQuestionList" size="small" border max-height="450" @selection-change="handleHwQuestionSelectionChange">
              <el-table-column type="selection" width="55" />
              <el-table-column type="index" width="60" label="#" />
              <el-table-column label="题目内容" min-width="300">
                <template slot-scope="scope">
                  <el-popover placement="right-start" trigger="hover" width="560" popper-class="hw-question-preview-popper">
                    <div class="hw-question-preview">
                      <div class="hw-question-preview-section">
                        <div class="hw-question-preview-label">题目内容</div>
                        <div class="hw-question-preview-content" v-html="renderLatex(scope.row.contentCn || scope.row.contentEn || '')"></div>
                      </div>
                      <div v-if="getQuestionImages(scope.row).length" class="hw-question-preview-images">
                        <img
                          v-for="(imgUrl, idx) in getQuestionImages(scope.row)"
                          :key="idx"
                          :src="convertMinioUrl(imgUrl)"
                          alt="题目图片"
                          class="hw-question-preview-image"
                          @error="handleQuestionImageError($event)"
                        >
                      </div>
                      <div v-if="scope.row.optionsEn || scope.row.optionsCn" class="hw-question-preview-section">
                        <div class="hw-question-preview-label">选项</div>
                        <div
                          v-for="(opt, idx) in parseOptions(scope.row.optionsEn || scope.row.optionsCn)"
                          :key="idx"
                          class="hw-question-preview-option"
                        >
                          <div>
                            <span class="hw-question-preview-option-key">{{ opt.key }}.</span>
                            <span v-html="renderLatex(opt.value)"></span>
                          </div>
                          <div v-if="getOptionImage(scope.row, idx)" class="hw-question-preview-option-image-wrap">
                            <img
                              :src="convertMinioUrl(getOptionImage(scope.row, idx))"
                              alt="选项图片"
                              class="hw-question-preview-option-image"
                              @error="handleQuestionImageError($event)"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="hw-question-preview-meta">
                        <div><span class="hw-question-preview-label-inline">答案：</span>{{ scope.row.answer || '--' }}</div>
                        <div><span class="hw-question-preview-label-inline">难度：</span>{{ scope.row.difficulty || '--' }}</div>
                        <div><span class="hw-question-preview-label-inline">知识点：</span>{{ scope.row.knowledgeNames || scope.row.knowledge || '--' }}</div>
                      </div>
                    </div>
                    <div slot="reference" class="hw-question-preview-trigger el-table__cell" :title="scope.row.contentCn || scope.row.contentEn || ''">
                      {{ scope.row.contentCn || scope.row.contentEn || '--' }}
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="answer" label="答案" width="80" />
              <el-table-column prop="difficulty" label="难度" width="80" />
              <el-table-column label="知识点" width="150" show-overflow-tooltip>
                <template slot="header">
                  <div style="display:flex;align-items:center;justify-content:space-between;gap:6px;">
                    <span>知识点</span>
                    <el-button type="text" size="mini" @click="focusHomeworkKnowledgeFilter">筛选</el-button>
                  </div>
                </template>
                <template slot-scope="scope">
                  <span v-if="scope.row.knowledgeNames">{{ scope.row.knowledgeNames }}</span>
                  <span v-else-if="scope.row.knowledge" style="color:#999;">{{ scope.row.knowledge }}</span>
                  <span v-else style="color:#ccc;">--</span>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="!hwQuestionLoading && (!hwQuestionList || !hwQuestionList.length)" class="empty-tip" style="margin-top:20px;">
              <i class="el-icon-collection-tag"></i>
              <p>{{ hwQuestionSource === 'course' ? '我的题库暂无题目，请先在"题目管理"中添加题目' : '总题库暂无题目' }}</p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="hwQuestionSelectorVisible=false">取 消</el-button>
              <el-button type="primary" @click="confirmHwQuestionSelection" :disabled="hwSelectedQuestions.length === 0">
                添加到作业 ({{ hwSelectedQuestions.length }})
              </el-button>
            </span>
          </el-dialog>
        </div>
        <div v-show="activeMenu === 'resources'" class="course-section">
          <div class="section-header" style="display:flex;align-items:center;justify-content:space-between;">
            <h3 style="margin:0;">课程资料</h3>
            <div v-if="isTeacher" style="display:flex;gap:8px;align-items:center;">
              <el-input v-model="uploadTitle" placeholder="资料标题(可选)" size="small" style="width:220px;" />
              <el-upload :show-file-list="false" action="/api/amc/material/upload" :data="{ courseId: courseId, title: uploadTitle }" :headers="uploadHeaders" :disabled="false" :on-success="onUploadSuccess" :on-error="onUploadError">
                <el-button type="primary" size="small">上传</el-button>
              </el-upload>
              <el-button size="small" @click="fetchMaterials" :loading="materialsLoading">刷新</el-button>
            </div>
            <div v-else>
              <el-button size="small" @click="fetchMaterials" :loading="materialsLoading">刷新</el-button>
            </div>
          </div>

          <div v-if="materialsLoading" class="loading-container" v-loading="true" element-loading-text="正在加载资料..." style="height:180px;" />
          <template v-else>
            <el-table v-if="materialList && materialList.length" :data="materialList" size="small" border>
              <el-table-column type="index" width="60" label="#" />
              <el-table-column prop="title" label="标题" min-width="200">
                <template slot-scope="{ row }">{{ row.title || row.fileName }}</template>
              </el-table-column>
              <el-table-column prop="fileName" label="文件名" min-width="220" show-overflow-tooltip />
              <el-table-column prop="fileSize" label="大小" width="120">
                <template slot-scope="{ row }">{{ formatSize(row.fileSize) }}</template>
              </el-table-column>
              <el-table-column prop="mimeType" label="类型" width="160" show-overflow-tooltip />
              <el-table-column prop="createdAt" label="上传时间" width="200">
                <template slot-scope="{ row }">{{ formatDateTime(row.createdAt) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="280">
                <template slot-scope="{ row }">
                  <a :href="withApiPrefix(row.url)" target="_blank" rel="noopener noreferrer">
                    <el-button type="text" size="mini">查看</el-button>
                  </a>
                  <el-button type="text" size="mini" @click="downloadMaterial(row)">下载</el-button>
                  <el-popconfirm v-if="isTeacher" title="确定删除该资料吗？" @onConfirm="removeMaterial(row)">
                    <el-button type="text" size="mini" slot="reference">删除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty-tip">
              <i class="el-icon-folder"></i>
              <p>暂无课程资料</p>
            </div>
          </template>
        </div>
        <!-- 隐藏错题集板块 -->
        <div v-if="false" class="course-section">
          <h3>错题集</h3>
          <div class="placeholder-block">此处为错题集内容（占位）</div>
        </div>
        <div v-show="activeMenu === 'analysis'" class="course-section">
          <!-- 老师端学情分析 -->
          <div v-if="isTeacher" style="padding: 8px 0;">
            <div class="section-header" style="display:flex;align-items:center;justify-content:space-between; margin-bottom: 4px;">
              <div>
                <h3 style="margin:0; font-size: 22px; color: #303133;">学情分析</h3>
                <p style="color: #909399; margin-top: 4px; font-size: 13px;">
                  班级整体学习情况统计
                  <span v-if="formattedLastUpdateTime" style="margin-left: 12px; color: #67C23A;">
                    <i class="el-icon-time"></i> {{ formattedLastUpdateTime }}
                  </span>
                </p>
              </div>
              <el-button size="medium" @click="loadLearningAnalysis" :loading="analysisLoading" icon="el-icon-refresh" type="primary">
                {{ analysisLoading ? '加载中...' : '刷新数据' }}
              </el-button>
            </div>

            <!-- 统计卡片 -->
            <el-row :gutter="24" style="margin-top: 24px; margin-bottom: 8px;" v-loading="analysisLoading" element-loading-text="正在统计数据..." element-loading-spinner="el-icon-loading">
              <el-col :xs="12" :sm="12" :md="6" :lg="6" style="margin-bottom: 16px;">
                <el-card class="analysis-card">
                  <div class="card-content">
                    <div class="card-label">学生总数</div>
                    <div class="card-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                      <i class="el-icon-user"></i>
                    </div>
                    <div class="card-value">{{ analysisData.totalStudents || 0 }}</div>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" style="margin-bottom: 16px;">
                <el-card class="analysis-card">
                  <div class="card-content">
                    <div class="card-label">作业完成率</div>
                    <div class="card-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
                      <i class="el-icon-edit"></i>
                    </div>
                    <div class="card-value">{{ analysisData.homeworkCompletionRate || 0 }}%</div>
                  </div>
                </el-card>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="6" style="margin-bottom: 16px;">
                <el-card class="analysis-card">
                  <div class="card-content">
                    <div class="card-label">讨论参与率</div>
                    <div class="card-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
                      <i class="el-icon-chat-dot-square"></i>
                    </div>
                    <div class="card-value">{{ analysisData.discussionParticipationRate || 0 }}%</div>
                  </div>
                </el-card>
              </el-col>
              <!-- 暂时隐藏平均分卡片 -->
              <el-col v-if="false" :xs="12" :sm="12" :md="6" :lg="6" style="margin-bottom: 16px;">
                <el-card class="analysis-card">
                  <div class="card-content">
                    <div class="card-label">平均分</div>
                    <div class="card-icon" style="background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);">
                      <i class="el-icon-star-on"></i>
                    </div>
                    <div class="card-value">{{ analysisData.averageScore || 0 }}</div>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <!-- 学生学情列表 -->
            <el-card style="margin-top: 24px;" v-loading="analysisLoading">
              <div slot="header" class="clearfix" style="padding: 8px 0;">
                <span style="font-weight: 600; font-size: 18px; color: #303133;">学生学情列表</span>
                <el-input
                  v-model="analysisSearchKeyword"
                  placeholder="搜索学生姓名或学号"
                  size="medium"
                  prefix-icon="el-icon-search"
                  style="width: 300px; float: right;"
                  @input="filterStudentAnalysis"
                  clearable />
              </div>

              <div v-if="filteredStudentAnalysisList.length === 0 && !analysisLoading" class="empty-tip" style="padding: 60px 20px; text-align: center;">
                <i class="el-icon-user" style="font-size: 64px; color: #DCDFE6; margin-bottom: 16px;"></i>
                <p style="color: #909399; font-size: 16px;">{{ analysisSearchKeyword ? '未找到匹配的学生' : '暂无学生数据，请先添加学生到班级' }}</p>
              </div>

              <el-table
                v-else
                :data="filteredStudentAnalysisList"
                stripe
                style="width: 100%"
                :default-sort="{prop: 'overallScore', order: 'descending'}"
                :row-style="{height: '70px'}"
                :cell-style="{padding: '16px 0'}">
                <el-table-column type="index" label="#" width="70" align="center" />

                <el-table-column prop="studentName" label="姓名" min-width="100" align="center">
                  <template slot-scope="scope">
                    <div style="font-weight: 600; font-size: 15px; color: #303133;">
                      {{ scope.row.studentName }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column prop="studentId" label="学号" min-width="130" align="center">
                  <template slot-scope="scope">
                    <div style="color: #606266;">{{ scope.row.studentId }}</div>
                  </template>
                </el-table-column>

                <!-- 作业完成率 -->
                <el-table-column label="作业完成" min-width="140" align="center" sortable :sort-method="(a, b) => a.homeworkCompletionRate - b.homeworkCompletionRate">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column; align-items: center; gap: 6px;">
                      <el-tag :type="scope.row.homeworkCompletionRate >= 80 ? 'success' : scope.row.homeworkCompletionRate >= 60 ? 'warning' : 'danger'">
                        {{ scope.row.homeworkCompleted }}/{{ scope.row.homeworkTotal }}
                      </el-tag>
                      <span style="font-size: 13px; color: #909399;">{{ scope.row.homeworkCompletionRate }}%</span>
                    </div>
                  </template>
                </el-table-column>

                <!-- 作业平均分 - 暂时隐藏 -->
                <el-table-column v-if="false" label="平均分" min-width="100" align="center" sortable prop="homeworkAvgScore">
                  <template slot-scope="scope">
                    <div :style="{fontSize: '18px', fontWeight: '600', color: getScoreColorByPercentage(scope.row.homeworkAvgScore)}">
                      {{ scope.row.homeworkAvgScore }}
                    </div>
                  </template>
                </el-table-column>

                <!-- 讨论参与 -->
                <el-table-column label="讨论参与" min-width="120" align="center">
                  <template slot-scope="scope">
                    <div style="font-size: 14px;">
                      <i class="el-icon-chat-dot-round" style="color: #409EFF;"></i>
                      <span style="margin: 0 4px;">{{ scope.row.topicCount }}</span>
                      <i class="el-icon-chat-line-round" style="color: #67C23A; margin-left: 8px;"></i>
                      <span style="margin-left: 4px;">{{ scope.row.commentCount }}</span>
                    </div>
                  </template>
                </el-table-column>

                <!-- 正确率 - 暂时隐藏 -->
                <el-table-column v-if="false" prop="accuracyRate" label="正确率" min-width="140" align="center" sortable>
                  <template slot-scope="scope">
                    <div style="padding: 0 12px;">
                      <el-progress
                        :percentage="scope.row.accuracyRate"
                        :color="customProgressColor"
                        :stroke-width="14"
                        :show-text="true" />
                    </div>
                  </template>
                </el-table-column>

                <!-- 综合评分 -->
                <el-table-column prop="overallScore" label="综合评分" min-width="130" align="center" sortable>
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
                      <div :style="{fontSize: '22px', fontWeight: 'bold', color: getScoreColorByPercentage(scope.row.overallScore)}">
                        {{ scope.row.overallScore }}
                      </div>
                      <el-rate
                        v-model="scope.row.performanceLevel"
                        disabled
                        text-color="#ff9900"
                        style="margin-top: 2px;" />
                    </div>
                  </template>
                </el-table-column>

                <!-- 操作 -->
                <el-table-column label="操作" width="100" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="viewStudentDetail(scope.row)" icon="el-icon-view" plain>
                      详情
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>

          <!-- 学生端学情分析 -->
          <div v-else style="padding: 8px 0;">
            <div class="section-header" style="display:flex;align-items:center;justify-content:space-between; margin-bottom: 24px;">
              <div>
                <h3 style="margin:0; font-size: 22px; color: #303133;">我的学情</h3>
                <p style="color: #909399; margin-top: 8px;">
                  查看你的学习进度和表现
                  <span v-if="formattedLastUpdateTime" style="margin-left: 12px; color: #67C23A;">
                    <i class="el-icon-time"></i> {{ formattedLastUpdateTime }}
                  </span>
                </p>
              </div>
              <el-button size="medium" @click="loadStudentStats" :loading="analysisLoading" icon="el-icon-refresh" type="primary">
                {{ analysisLoading ? '加载中...' : '刷新数据' }}
              </el-button>
            </div>

            <!-- 学生统计卡片 -->
            <el-row :gutter="20" style="margin-bottom: 24px;" v-loading="analysisLoading" element-loading-text="正在加载学情数据..." element-loading-spinner="el-icon-loading">
              <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 16px;">
                <el-card class="student-stat-card">
                  <div class="stat-content">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
                      <i class="el-icon-edit-outline"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">作业完成情况</div>
                      <div class="stat-value">{{ studentStats.homeworkCompleted || 0 }}/{{ studentStats.homeworkTotal || 0 }}</div>
                      <div class="stat-desc">完成率 {{ studentStats.homeworkCompletionRate || 0 }}%</div>
                    </div>
                  </div>
                </el-card>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 16px;">
                <el-card class="student-stat-card">
                  <div class="stat-content">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                      <i class="el-icon-trophy"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">作业平均分</div>
                      <div class="stat-value" :style="{color: getScoreColorByPercentage(studentStats.avgScore || 0)}">
                        {{ studentStats.avgScore || 0 }}
                      </div>
                      <div class="stat-desc">继续努力，追求更高分数</div>
                    </div>
                  </div>
                </el-card>
              </el-col>

              <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 16px;">
                <el-card class="student-stat-card">
                  <div class="stat-content">
                    <div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
                      <i class="el-icon-chat-dot-round"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">讨论参与</div>
                      <div class="stat-value">{{ (studentStats.topicCount || 0) + (studentStats.commentCount || 0) }}</div>
                      <div class="stat-desc">发帖 {{ studentStats.topicCount || 0 }} · 回复 {{ studentStats.commentCount || 0 }}</div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <!-- 学习进度详情 -->
            <el-row :gutter="20" v-loading="analysisLoading" element-loading-text="正在分析数据...">
              <!-- 作业完成详情 -->
              <el-col :xs="24" :md="12" style="margin-bottom: 20px;">
                <el-card>
                  <div slot="header">
                    <i class="el-icon-notebook-2"></i>
                    <span style="margin-left: 8px; font-weight: 600;">作业完成详情</span>
                  </div>
                  <div style="padding: 20px;">
                    <div class="progress-item">
                      <div class="progress-label">
                        <span>完成率</span>
                        <span style="font-weight: 600;">{{ studentStats.homeworkCompletionRate || 0 }}%</span>
                      </div>
                      <el-progress
                        :percentage="studentStats.homeworkCompletionRate || 0"
                        :color="customProgressColor"
                        :stroke-width="16" />
                    </div>

                    <div class="progress-item" style="margin-top: 24px;">
                      <div class="progress-label">
                        <span>答题正确率</span>
                        <span style="font-weight: 600;">{{ studentStats.accuracyRate || 0 }}%</span>
                      </div>
                      <el-progress
                        :percentage="studentStats.accuracyRate || 0"
                        :color="customProgressColor"
                        :stroke-width="16" />
                    </div>

                    <div class="stat-summary" style="margin-top: 24px; padding: 16px; background: #f5f7fa; border-radius: 8px;">
                      <div style="display: flex; justify-content: space-around; text-align: center;">
                        <div>
                          <div style="font-size: 24px; font-weight: 600; color: #409EFF;">{{ studentStats.totalAnswered || 0 }}</div>
                          <div style="font-size: 13px; color: #909399; margin-top: 4px;">已答题数</div>
                        </div>
                        <div>
                          <div style="font-size: 24px; font-weight: 600; color: #67C23A;">{{ studentStats.correctAnswered || 0 }}</div>
                          <div style="font-size: 13px; color: #909399; margin-top: 4px;">答对题数</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>

              <!-- 综合表现 -->
              <el-col :xs="24" :md="12" style="margin-bottom: 20px;">
                <el-card>
                  <div slot="header">
                    <i class="el-icon-data-line"></i>
                    <span style="margin-left: 8px; font-weight: 600;">综合表现</span>
                  </div>
                  <div style="padding: 20px; text-align: center;">
                    <div class="overall-score-display">
                      <div class="score-circle" :style="{background: getScoreGradient(studentStats.overallScore || 0)}">
                        <div class="score-number">{{ studentStats.overallScore || 0 }}</div>
                        <div class="score-label">综合评分</div>
                      </div>
                      <el-rate
                        v-model="studentStats.performanceLevel"
                        disabled
                        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        style="margin-top: 20px;" />
                      <div class="performance-text" style="margin-top: 16px; font-size: 16px; color: #606266;">
                        {{ getPerformanceText(studentStats.overallScore || 0) }}
                      </div>
                    </div>

                    <el-divider></el-divider>

                    <div class="score-breakdown">
                      <div class="breakdown-item">
                        <span class="breakdown-label">作业表现</span>
                        <el-progress
                          :percentage="Math.round((studentStats.avgScore || 0))"
                          :color="getScoreColorByPercentage(studentStats.avgScore || 0)"
                          :format="() => `${studentStats.avgScore || 0}分`" />
                      </div>
                      <div class="breakdown-item" style="margin-top: 16px;">
                        <span class="breakdown-label">讨论参与</span>
                        <el-progress
                          :percentage="Math.min(((studentStats.topicCount || 0) + (studentStats.commentCount || 0)) * 5, 100)"
                          color="#4facfe"
                          :format="() => `${(studentStats.topicCount || 0) + (studentStats.commentCount || 0)}次`" />
                      </div>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>

            <!-- 学习建议 -->
            <el-card style="margin-top: 20px;">
              <div slot="header">
                <i class="el-icon-reading"></i>
                <span style="margin-left: 8px; font-weight: 600;">学习建议</span>
              </div>
              <div class="learning-tips">
                <el-alert
                  v-if="studentStats.homeworkCompletionRate < 80"
                  title="作业完成率较低"
                  type="warning"
                  description="建议按时完成作业，这样能更好地巩固所学知识。"
                  :closable="false"
                  show-icon
                  style="margin-bottom: 12px;">
                </el-alert>
                <el-alert
                  v-if="studentStats.avgScore < 70"
                  title="作业平均分有待提高"
                  type="info"
                  description="可以多复习课程内容，遇到不懂的问题及时向老师请教。"
                  :closable="false"
                  show-icon
                  style="margin-bottom: 12px;">
                </el-alert>
                <el-alert
                  v-if="(studentStats.topicCount || 0) + (studentStats.commentCount || 0) < 5"
                  title="建议多参与讨论"
                  type="info"
                  description="积极参与课程讨论能帮助你更好地理解知识点，并与同学交流学习心得。"
                  :closable="false"
                  show-icon
                  style="margin-bottom: 12px;">
                </el-alert>
                <el-alert
                  v-if="studentStats.overallScore >= 85"
                  title="表现优秀！"
                  type="success"
                  description="你的学习态度和成绩都很棒，继续保持！可以尝试帮助其他同学一起进步。"
                  :closable="false"
                  show-icon>
                </el-alert>
              </div>
            </el-card>
          </div>
        </div>

        <!-- 数据收集（仅教师） -->
        <div v-show="activeMenu === 'data-collection'" class="course-section">
          <DataCollection :course-id="courseId" />
        </div>

        <div v-show="activeMenu === 'discussion'" class="course-section">
          <div class="section-header">
            <h3>课程讨论</h3>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateTopicDialog">发布话题</el-button>
          </div>

          <!-- 话题列表 -->
          <el-card v-loading="discussionLoading" class="discussion-container">
            <div v-if="topicList.length === 0" class="empty-tip">
              <i class="el-icon-chat-line-square"></i>
              <p>还没有讨论话题，快来发布第一个话题吧！</p>
            </div>

            <div v-else class="topic-list">
              <div
                v-for="topic in topicList"
                :key="topic.id"
                class="topic-item"
                :class="{ 'topic-pinned': topic.isPinned }"
                @click="viewTopicDetail(topic)">
                <div class="topic-header">
                  <el-tag v-if="topic.isPinned" type="warning" size="mini">置顶</el-tag>
                  <span class="topic-title">{{ topic.title }}</span>
                  <span class="topic-author">{{ topic.creatorName }}</span>
                  <span class="topic-time">{{ formatDateTime(topic.createTime) }}</span>
                </div>
                <div class="topic-content" v-if="topic.content">{{ topic.content }}</div>
                <div class="topic-stats">
                  <span><i class="el-icon-view"></i> {{ topic.viewCount || 0 }}</span>
                  <span><i class="el-icon-chat-dot-round"></i> {{ topic.commentCount || 0 }}</span>
                  <span><i class="el-icon-star-off"></i> {{ topic.likeCount || 0 }}</span>
                </div>
                <div v-if="isTeacher || isMyTopic(topic)" class="topic-actions" @click.stop>
                  <!-- 只有老师可以置顶 -->
                  <el-button v-if="isTeacher" size="mini" type="text" @click="togglePinTopic(topic)">
                    {{ topic.isPinned ? '取消置顶' : '置顶' }}
                  </el-button>
                  <!-- 老师和作者本人可以编辑 -->
                  <el-button size="mini" type="text" @click="editTopic(topic)">编辑</el-button>
                  <!-- 老师和作者本人可以删除 -->
                  <el-popconfirm
                    title="确定删除这个话题吗？"
                    @onConfirm="removeTopicConfirm(topic.id)">
                    <el-button slot="reference" size="mini" type="text" style="color:#F56C6C;">删除</el-button>
                  </el-popconfirm>
                </div>
              </div>
            </div>

            <!-- 分页 -->
            <el-pagination
              v-if="topicTotal > 0"
              @size-change="handleTopicSizeChange"
              @current-change="handleTopicPageChange"
              :current-page="topicPageNum"
              :page-sizes="[10, 20, 50]"
              :page-size="topicPageSize"
              :total="topicTotal"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin-top:20px;text-align:right;">
            </el-pagination>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 发布/编辑话题对话框 -->
    <el-dialog
      :title="topicEditingId ? '编辑话题' : '发布话题'"
      :visible.sync="topicDialogVisible"
      width="700px"
      @close="closeTopicDialog">
      <el-form :model="topicForm" label-width="80px">
        <el-form-item label="话题标题" required>
          <el-input v-model="topicForm.title" placeholder="请输入话题标题" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="话题内容">
          <el-input
            type="textarea"
            v-model="topicForm.content"
            :rows="6"
            placeholder="请输入话题内容"
            maxlength="2000"
            show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="topicDialogVisible=false">取 消</el-button>
        <el-button type="primary" :loading="savingTopic" @click="submitTopic">发 布</el-button>
      </span>
    </el-dialog>

    <!-- 话题详情对话框 -->
    <el-dialog
      title="话题详情"
      :visible.sync="topicDetailVisible"
      width="900px"
      @close="closeTopicDetail">
      <div v-if="currentTopic" v-loading="loadingTopicDetail">
        <!-- 话题内容 -->
        <div class="topic-detail-header">
          <h2>{{ currentTopic.title }}</h2>
          <div class="topic-detail-meta">
            <span class="author">{{ currentTopic.creatorName }}</span>
            <span class="time">{{ formatDateTime(currentTopic.createTime) }}</span>
          </div>
          <div class="topic-detail-content">{{ currentTopic.content }}</div>
          <div class="topic-detail-actions">
            <el-button
              :type="topicLiked ? 'danger' : ''"
              size="small"
              icon="el-icon-star-off"
              @click="toggleTopicLike">
              {{ topicLiked ? '已点赞' : '点赞' }} ({{ currentTopic.likeCount || 0 }})
            </el-button>
          </div>
        </div>

        <el-divider></el-divider>

        <!-- 评论区 -->
        <div class="comments-section">
          <h3>评论 ({{ commentList.length }})</h3>

          <!-- 发表评论 -->
          <div class="comment-input-wrapper">
            <el-input
              type="textarea"
              v-model="newComment"
              :rows="3"
              placeholder="写下你的评论..."
              maxlength="500"
              show-word-limit />
            <el-button
              type="primary"
              size="small"
              :loading="postingComment"
              @click="postComment"
              style="margin-top:10px;">
              发表评论
            </el-button>
          </div>

          <!-- 评论列表 -->
          <div class="comment-list" v-loading="loadingComments">
            <div v-if="commentList.length === 0" class="empty-tip">
              <i class="el-icon-chat-line-square"></i>
              <p>还没有评论，快来发表第一条评论吧！</p>
            </div>
            <div v-else>
              <div v-for="comment in commentList" :key="comment.id" class="comment-item">
                <div class="comment-header">
                  <span class="comment-author">{{ comment.userName }}</span>
                  <span class="comment-time">{{ formatDateTime(comment.createTime) }}</span>
                </div>
                <div class="comment-content">
                  <span v-if="comment.replyToName" class="reply-to">回复 @{{ comment.replyToName }}: </span>
                  {{ comment.content }}
                </div>
                <div class="comment-actions">
                  <el-button
                    :type="comment.liked ? 'warning' : ''"
                    :plain="!comment.liked"
                    size="mini"
                    :icon="comment.liked ? 'el-icon-star-on' : 'el-icon-star-off'"
                    @click="toggleCommentLike(comment)">
                    <span v-if="comment.likeCount && comment.likeCount > 0">{{ comment.likeCount }}</span>
                    <span v-else>点赞</span>
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    icon="el-icon-chat-dot-round"
                    @click="startReply(comment)">
                    回复
                  </el-button>
                  <el-popconfirm
                    v-if="isTeacher || (currentUser && comment.userId === currentUser.id)"
                    title="确定删除这条评论吗？"
                    @onConfirm="deleteCommentConfirm(comment.id)">
                    <el-button
                      slot="reference"
                      size="mini"
                      type="text"
                      style="color:#F56C6C;">
                      删除
                    </el-button>
                  </el-popconfirm>
                </div>

                <!-- 回复输入框 -->
                <div v-if="replyingTo && replyingTo.id === comment.id" class="reply-input-wrapper">
                  <el-input
                    type="textarea"
                    v-model="replyContent"
                    :rows="2"
                    :placeholder="`回复 @${comment.userName}...`"
                    maxlength="500"
                    show-word-limit />
                  <div style="margin-top:8px;">
                    <el-button
                      type="primary"
                      size="mini"
                      :loading="postingComment"
                      @click="postReply">
                      发表回复
                    </el-button>
                    <el-button
                      size="mini"
                      @click="cancelReply">
                      取消
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 全局对话框：老师新建/编辑题目 -->
    <el-dialog
      :title="questionEditingId ? '编辑题目' : '新建题目'"
      :visible.sync="questionDialogVisible"
      width="720px"
      @close="closeQuestionDialog">
      <el-form :model="questionForm" ref="questionForm" label-width="120px" size="small">
        <el-form-item label="题目内容(中)" prop="contentCn">
          <el-input v-model="questionForm.contentCn" type="textarea" rows="3" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="题目内容(英)">
          <el-input v-model="questionForm.contentEn" type="textarea" rows="3" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="选项(中文)">
          <el-input v-model="questionForm.optionsCn" type="textarea" rows="2" placeholder="用竖线|或分号;分隔，例如: (A)选项1;(B)选项2;(C)选项3 或 A.选项1|B.选项2|C.选项3" />
        </el-form-item>
        <el-form-item label="选项(英文)">
          <el-input v-model="questionForm.optionsEn" type="textarea" rows="2" placeholder="用竖线|或分号;分隔，例如: (A)Option1;(B)Option2;(C)Option3" />
        </el-form-item>
        <el-form-item label="答案" prop="answer">
          <el-input v-model="questionForm.answer" maxlength="50" placeholder="例如: A 或 ABC" />
        </el-form-item>
        <el-form-item label="解析(中文)">
          <el-input v-model="questionForm.analysisCn" type="textarea" rows="2" />
        </el-form-item>
        <el-form-item label="解析(英文)">
          <el-input v-model="questionForm.analysisEn" type="textarea" rows="2" />
        </el-form-item>
        <el-form-item label="难度">
          <el-select v-model="questionForm.difficulty" placeholder="请选择">
            <el-option label="简单" value="简单" />
            <el-option label="中等" value="中等" />
            <el-option label="困难" value="困难" />
          </el-select>
        </el-form-item>
        <!-- 隐藏知识点字段 -->
        <!-- <el-form-item label="知识点">
          <el-input v-model="questionForm.knowledge" maxlength="100" />
        </el-form-item> -->
        <el-form-item label="年份">
          <el-input v-model="questionForm.year" maxlength="20" placeholder="例如: 2023" />
        </el-form-item>
        <el-form-item label="题目编号">
          <el-input v-model="questionForm.number" maxlength="50" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionDialogVisible=false">取 消</el-button>
        <el-button type="primary" :loading="savingQuestion" @click="submitQuestion">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCourseById } from '@/api/course'
import { getTeachingPlans, createTeachingPlan, updateTeachingPlan, deleteTeachingPlan } from '@/api/amcPlan'
import { pageNotices, pageNewNotices, createNotice, updateNotice, deleteNotice } from '@/api/amcCourseNotice'
import { listTopics, getTopicDetail, createTopic, updateTopic, deleteTopic, pinTopic, listComments, createComment, deleteComment, likeTopicToggle, likeCommentToggle, getUserLikeStatus } from '@/api/amcDiscussion'
import { getCourseProfile, saveCourseProfile } from '@/api/amcCourseProfile'
import { pageObjectives, pageNewObjectives, createObjective, updateObjective, deleteObjective } from '@/api/amcCourseObjective'
import { pageChapters, pageNewChapters, listChapters, createChapter, updateChapter, deleteChapter } from '@/api/amcCourseChapter'
import { listSectionsByChapter, getSectionDetail, createSection, updateSection, deleteSection, addResource, deleteResource, getVideoOptimizeTask, updateProgress, markAsCompleted } from '@/api/amcChapterSection'
import { logVideoVisit, updateVideoVisitExit } from '@/api/amcVideoVisitLog'
import { listAllGeneralKnowledge, listGeneralKnowledgeTree, batchGetGeneralKnowledgeNames } from '@/api/knowledge'
import { listClasses, createClass, updateClass, deleteClass, addStudentByUsername, joinByInviteCode, listStudents, removeStudent } from '@/api/courseClass'
import { pageStudentCandidates } from '@/api/user'
import { listMaterials, uploadMaterial, deleteMaterial } from '@/api/amcCourseMaterial'
import { qbFolderTree, qbCreateFolder, qbRenameFolder, qbDeleteFolder, qbListFiles, qbUploadFile, qbDeleteFile, qbMoveFile, qbMoveFolder, qbPublishToCourse } from '@/api/amcQb'
import { qbShareFile, qbShareList } from '@/api/amcQbShare'
import { getRole, getTokenInfo } from '@/utils/jwtUtils'
import { createHomework, updateHomework, deleteHomework, getHomeworkDetail, teacherHomeworkList, studentHomeworkList, startHomework, submitHomework, getHomeworkStats, submitHomeworkAnswers, getMyHomeworkAnswers } from '@/api/amcHomework'
import { quAdd, quUpdate, quDel, quPaging, quDetail, getQuestionsByRepoId } from '@/api/amcquestion'
import { addRecord } from '@/api/userQuestionRecord'
import { addQuestionsToCourse, removeQuestionFromCourse, getCourseQuestions } from '@/api/amcCourseQuestion'
import { getCourseAnalysis } from '@/api/learningAnalysis'
import { getVideoMarkers, getVideoQuestions, submitVideoAnswer } from '@/api/amcVideoEnhancement'
import VideoMarkerManager from '@/components/course/VideoMarkerManager.vue'
import VideoQuestionManager from '@/components/course/VideoQuestionManager.vue'
import VideoAnswerRecordsDialog from '@/components/course/VideoAnswerRecordsDialog.vue'
import StudentVideoAnswerRecords from '@/components/course/StudentVideoAnswerRecords.vue'
import DataCollection from '@/components/course/DataCollection.vue'
import PptPreviewDialog from '@/components/course/PptPreviewDialog.vue'
import Hls from 'hls.js'
import katex from 'katex'
import 'katex/dist/katex.min.css'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  name: 'AMCTeacherCourseDetail',
  components: {
    VideoMarkerManager,
    VideoQuestionManager,
    VideoAnswerRecordsDialog,
    StudentVideoAnswerRecords,
    DataCollection,
    PptPreviewDialog
  },
  data() {
    return {
      courseId: Number(this.$route.params.id),
      activeMenu: 'chapter',
      course: {
        image: '',
        course_name: '',
        teacher_name: '',
        organization: '',
        term: '',
        repoId: null,
        profile: '',
        target: ''
      },
      hwStatsVisible: false,
      hwStatsLoading: false,
      hwStats: null,
      // 角色
      isTeacher: false,
      currentUser: null,

      // 学情分析相关
      analysisLoading: false,
      analysisLastUpdateTime: null,
      analysisData: {
        totalStudents: 0,
        homeworkCompletionRate: 0,
        discussionParticipationRate: 0,
        averageScore: 0
      },
      studentAnalysisList: [],
      filteredStudentAnalysisList: [],
      analysisSearchKeyword: '',
      studentDetailVisible: false,
      currentStudentDetail: null,

      // 学生端学情统计
      studentStats: {
        homeworkCompleted: 0,
        homeworkTotal: 0,
        homeworkCompletionRate: 0,
        avgScore: 0,
        topicCount: 0,
        commentCount: 0,
        accuracyRate: 0,
        totalAnswered: 0,
        correctAnswered: 0,
        overallScore: 0,
        performanceLevel: 0
      },

      // 讨论相关
      discussionLoading: false,
      topicList: [],
      topicPageNum: 1,
      topicPageSize: 10,
      topicTotal: 0,
      topicDialogVisible: false,
      topicEditingId: null,
      topicForm: {
        title: '',
        content: ''
      },
      savingTopic: false,
      topicDetailVisible: false,
      currentTopic: null,
      topicLiked: false,
      loadingTopicDetail: false,
      commentList: [],
      loadingComments: false,
      newComment: '',
      postingComment: false,
      replyingTo: null, // 当前正在回复的评论
      replyContent: '', // 回复内容

      // 教学计划
      plansLoading: false,
      plans: [],
      // 新建/编辑对话框
      planDialogVisible: false,
      editingId: null,
      planForm: {
        planName: '',
        academicYear: '',
        semester: '',
        description: '',
        status: 0
      },
      planDateRange: [],
      planRules: {
        planName: [{ required: true, message: '请输入计划名称', trigger: 'blur' }]
      },
      savingPlan: false,
      noticeLoading: false,
      noticeList: [],
      noticePage: 1,
      noticePageSize: 10,
      noticeTotal: 0,
      noticeDialogVisible: false,
      noticeEditingId: null,
      noticeForm: { title: '', content: '' },
      noticeRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      savingNotice: false,
      // 课程简介
      profileContent: '',
      profileLoading: false,
      profileSaving: false,
      // 教学目标
      objectiveLoading: false,
      objectiveList: [],
      objectivePage: 1,
      objectivePageSize: 10,
      objectiveTotal: 0,
      objectiveDialogVisible: false,
      objectiveEditingId: null,
      objectiveForm: { title: '', content: '' },
      objectiveRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      savingObjective: false,
      // 课程章节
      chapterLoading: false,
      chapterList: [],
      sectionAccessLimit: 0,
      chapterPage: 1,
      chapterPageSize: 10,
      chapterTotal: 0,
      chapterDialogVisible: false,
      chapterEditingId: null,
      chapterForm: { title: '', content: '', sort: 0 },
      chapterRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
      },
      savingChapter: false,
      chapterSortMode: false,
      savingChapterSort: false,
      chapterOrderSnapshot: [],
      activeChaptersSnapshot: [],
      dragChapterId: null,
      dragSectionId: null,
      dragSectionChapterId: null,
      activeChapters: [], // 展开的章节
      // 小节管理
      sectionDialogVisible: false,
      sectionEditingId: null,
      currentChapterId: null,
      sectionForm: { title: '', description: '', durationMinutes: 0, sort: 0, chapterId: null },
      savingSection: false,
      // 资源管理
      uploadResourceVisible: false,
      currentSectionId: null,
      resourceForm: { resourceType: 'video', resourceName: '', description: '', sectionId: null, homeworkId: null },
      resourceFileList: [],
      resourceUploadStatus: '',
      resourceUploadPercent: 0,
      resourceUploadingFileName: '',
      uploadedResourceUrl: '',
      uploadedFileSize: 0,
      resourceOptimizeTaskId: '',
      resourceOptimizeProgress: 0,
      resourceOptimizeMessage: '',
      resourceOptimizePollTimer: null,
      resourceOptimizeTaskMap: {},
      uploadingResource: false,
      uploadAction: process.env.VUE_APP_BASE_API + '/file/uploadTo/course-sections', // 文件上传接口
      // 视频播放
      videoPlayerVisible: false,
      currentVideoUrl: '',
      currentVideoFallbackUrl: '',
      currentVideoSourceType: 'mp4',
      currentVideoSectionId: null,
      currentVideoVisitLogId: null,
      currentVideoChapterId: null,
      currentVideoChapterTitle: '',
      currentVideoSectionTitle: '',
      videoStartTime: 0,
      videoWatchStartTime: null,
      currentVideoDuration: 0, // 当前视频时长（秒）
      isVideoFullscreen: false, // 视频是否全屏
      videoControlsVisible: true, // 全屏时控件是否可见
      videoControlsTimer: null, // 全屏控件隐藏定时器
      videoLoadError: '', // 视频加载错误信息
      // 视频增强功能
      videoPlayMode: 'review', // 'interactive'=随堂学习, 'review'=课后复习
      videoMarkers: [], // 视频时间标签
      videoQuestions: [], // 视频关联题目
      answeredQuestions: new Set(), // 已回答的题目ID
      lastVideoTime: 0, // 上一次的视频播放时间
      questionPopVisible: false, // 弹题对话框
      currentQuestion: null, // 当前弹出的题目
      questionCountdown: 0, // 答题倒计时
      countdownTimer: null, // 倒计时定时器
      questionStartTime: 0, // 开始答题时间
      studentAnswer: '', // 学生选择的答案
      studentMultiAnswer: [], // 多选投票选中的答案数组
      questionResult: null, // 答题结果
      showCoursewarePrompt: true, // 是否显示课件下载提示
      currentSectionResources: [], // 当前小节资源列表
      hlsPlayer: null,
      // 小节详情
      sectionDetailVisible: false,
      currentSection: null,
      // 视频标签管理
      markerManagerVisible: false,
      currentMarkerSectionId: null,
      currentMarkerVideoUrl: '',
      // 视频问题管理
      questionManagerVisible: false,
      currentQuestionSectionId: null,
      currentQuestionVideoUrl: '',
      // 视频答题记录（老师端）
      answerRecordsVisible: false,
      currentAnswerRecordSectionId: null,
      classStudents: [], // 班级学生列表
      videoQuestions: [], // 视频题目列表
      // 学生答题记录（学生端）
      studentAnswerRecordsVisible: false,
      // PPT预览
      pptPreviewVisible: false,
      pptPreviewResourceId: null,
      pptPreviewResourceName: '',
      // 课程知识点
      knowledgeLoading: false,
      knowledgeTree: [],
      knowledgeFilter: '',
      knowledgeExpandedKeys: [],
      knowledgeProps: { label: 'label', children: 'children' },
      knowledgeViewMode: 'tree',
      // 班级管理
      classLoading: false,
      classList: [],
      classDialogVisible: false,
      classEditingId: null,
      classForm: { name: '', inviteCode: '', description: '' },
      classRules: { name: [{ required: true, message: '请输入班级名称', trigger: 'blur' }] },
      classSaving: false,
      addStudentVisible: false,
      addStudentTargetId: null,
      addStudentLoading: false,
      addStudentKeyword: '',
      addStudentCandidates: [],
      addStudentCandidatesLoading: false,
      addStudentCandidatePage: 1,
      addStudentCandidatePageSize: 10,
      addStudentCandidateTotal: 0,
      addStudentJoinedMap: {},
      joinInviteCode: '',
      joinLoading: false,
      // 成员管理
      membersVisible: false,
      membersLoading: false,
      membersClassId: null,
      membersList: [],
      // 课程资料
      materialsLoading: false,
      materialList: [],
      uploadTitle: '',
      uploading: false,
      uploadHeaders: {},
      // 题库
      qbLoading: false,
      qbTree: [],
      qbSelectedFolder: null,
      qbFilesLoading: false,
      qbFiles: [],
      qbUploadTitle: '',
      qbCurrentRow: null,
      // 学生我的题库（共享）
      sharedQbFiles: [],
      sharedQbLoading: false,
      // 作业管理（教师）
      homeworkLoading: false,
      homeworkList: [],
      hwDialogVisible: false,
      hwForm: {
        title: '',
        description: '',
        timeLimitMinutes: 0,
        startTime: '',
        endTime: '',
        classIds: [],
        qbFileIds: [],
        questions: [] // [{id: xxx, score: 10}, ...]
      },
      editingHwId: null,
      classOptions: [],
      // 作业-题目选择器
      hwQuestionSelectorVisible: false,
      hwQuestionSource: 'course', // 题库来源: 'course'-我的题库, 'public'-公共题库
      hwQuestionSearchKeyword: '',
      hwQuestionKnowledgeFilter: '',
      hwQuestionLoading: false,
      hwQuestionRawList: [],
      hwQuestionList: [],
      hwSelectedQuestions: [],
      hwKnowledgeOptions: [],
      hwKnowledgeCascaderProps: {
        value: 'id',
        label: 'content',
        children: 'children',
        emitPath: false,
        checkStrictly: true
      },
      // 作业-学生作答
      studentHomeworkLoading: false,
      studentRefreshLoading: false,
      hwStudentTableKey: 0,
      hwDoDialogVisible: false,
      hwDoData: {
        homework: null,
        qbFileIds: [],
        questions: [], // 作业题目列表
        startTime: '',
        remainSeconds: 0,
        timerId: null,
        isViewOnly: false // 是否为查看模式（已完成作业）
      },
      // 作业答题状态
      hwCurrentQuestionIndex: 0, // 当前题目索引
      hwCurrentAnswer: '', // 当前题目的答案
      hwShowResult: false, // 是否显示答题结果
      hwIsCorrect: false, // 当前题答对了吗
      hwAllAnswers: [], // 所有答题记录 [{questionId, userAnswer, isCorrect}]
      exportingPDF: false, // PDF导出中
      // 题目管理
      questionTab: 'private', // 'private' | 'public'
      questionLoading: false,
      questionList: [], // 我的题库（私有）
      publicQuestionList: [], // 公共题库
      publicQuestionLoading: false,
      questionDialogVisible: false,
      questionEditingId: null,
      creatingForHomework: false, // 标记是否为作业创建题目
      questionForm: {
        contentCn: '',
        contentEn: '',
        optionsCn: '',
        optionsEn: '',
        answer: '',
        analysisCn: '',
        analysisEn: '',
        difficulty: '',
        knowledge: '',
        year: '',
        number: '',
        repoId: null
      },
      savingQuestion: false,
      // 从题库选题
      selectLibraryVisible: false,
      librarySearchKeyword: '',
      libraryLoading: false,
      libraryQuestionList: [],
      selectedLibraryQuestions: [],
      // 查看题目详情
      viewQuestionVisible: false,
      viewingQuestion: null,
      // 学生答题
      answerDialogVisible: false,
      currentQuestion: null,
      userAnswer: '',
      showResult: false,
      isCorrect: false,
      submittingAnswer: false
    }
  },

  // 合并到下方的 computed/watch 中，避免重复定义

  methods: {
    isChapterExpanded(chapterId) {
      return Array.isArray(this.activeChapters) && this.activeChapters.includes(chapterId)
    },
    cloneChapterOrderState(list) {
      return (Array.isArray(list) ? list : []).map(chapter => ({
        ...chapter,
        sections: Array.isArray(chapter.sections) ? chapter.sections.map(section => ({ ...section })) : []
      }))
    },
    enterChapterSortMode() {
      this.chapterOrderSnapshot = this.cloneChapterOrderState(this.chapterList)
      this.activeChaptersSnapshot = Array.isArray(this.activeChapters) ? [...this.activeChapters] : []
      this.chapterSortMode = true
    },
    cancelChapterSort() {
      this.chapterList = this.cloneChapterOrderState(this.chapterOrderSnapshot)
      this.activeChapters = Array.isArray(this.activeChaptersSnapshot) ? [...this.activeChaptersSnapshot] : []
      this.chapterSortMode = false
      this.savingChapterSort = false
      this.chapterOrderSnapshot = []
      this.activeChaptersSnapshot = []
      this.dragChapterId = null
      this.dragSectionId = null
      this.dragSectionChapterId = null
    },
    onChapterDragStart(chapterId) {
      if (!this.chapterSortMode) return
      this.dragChapterId = chapterId
    },
    onChapterDragOver(chapterId) {
      if (!this.chapterSortMode || !this.dragChapterId || this.dragChapterId === chapterId) return
      const fromIndex = this.chapterList.findIndex(item => item.id === this.dragChapterId)
      const toIndex = this.chapterList.findIndex(item => item.id === chapterId)
      if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return
      const list = [...this.chapterList]
      const moved = list.splice(fromIndex, 1)[0]
      list.splice(toIndex, 0, moved)
      this.chapterList = list
    },
    onChapterDrop(chapterId) {
      this.onChapterDragOver(chapterId)
      this.onChapterDragEnd()
    },
    onChapterDragEnd() {
      this.dragChapterId = null
    },
    onSectionDragStart(chapterId, sectionId) {
      if (!this.chapterSortMode) return
      this.dragSectionChapterId = chapterId
      this.dragSectionId = sectionId
    },
    onSectionDragOver(chapterId, sectionId) {
      if (!this.chapterSortMode || !this.dragSectionId || this.dragSectionChapterId !== chapterId || this.dragSectionId === sectionId) return
      const chapter = (this.chapterList || []).find(item => item.id === chapterId)
      if (!chapter || !Array.isArray(chapter.sections)) return
      const fromIndex = chapter.sections.findIndex(item => item.id === this.dragSectionId)
      const toIndex = chapter.sections.findIndex(item => item.id === sectionId)
      if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return
      const sections = [...chapter.sections]
      const moved = sections.splice(fromIndex, 1)[0]
      sections.splice(toIndex, 0, moved)
      chapter.sections = sections
      this.chapterList = [...this.chapterList]
    },
    onSectionDrop(chapterId, sectionId) {
      this.onSectionDragOver(chapterId, sectionId)
      this.onSectionDragEnd()
    },
    onSectionDragEnd() {
      this.dragSectionId = null
      this.dragSectionChapterId = null
    },
    async saveChapterSort() {
      try {
        this.savingChapterSort = true
        ;(this.chapterList || []).forEach((chapter, chapterIndex) => {
          this.$set(chapter, 'sort', chapterIndex + 1)
          ;(chapter.sections || []).forEach((section, sectionIndex) => {
            this.$set(section, 'sort', sectionIndex + 1)
          })
        })
        const chapterRequests = (this.chapterList || []).map((chapter, chapterIndex) => updateChapter(chapter.id, {
          title: chapter.title,
          content: chapter.content,
          sort: chapter.sort,
          courseId: Number(this.courseId)
        }))
        const sectionRequests = []
        ;(this.chapterList || []).forEach(chapter => {
          ;(chapter.sections || []).forEach((section, sectionIndex) => {
            sectionRequests.push(updateSection(section.id, {
              title: section.title,
              description: section.description || '',
              durationMinutes: section.durationMinutes || 0,
              sort: section.sort,
              chapterId: chapter.id
            }))
          })
        })
        const responses = await Promise.all([...chapterRequests, ...sectionRequests])
        const failed = responses.find(res => res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000))
        if (failed) {
          this.$message.error(failed.msg || '保存排序失败')
          return
        }
        this.$message.success('排序保存成功')
        this.chapterSortMode = false
        this.chapterOrderSnapshot = []
        this.activeChaptersSnapshot = []
        this.dragChapterId = null
        this.dragSectionId = null
        this.dragSectionChapterId = null
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('保存章节排序失败', e)
        this.$message.error('保存排序失败')
      } finally {
        this.savingChapterSort = false
      }
    },
    // 转换MinIO URL
    convertMinioUrl(url) {
      if (!url) return url
      const minioBase = (process.env.VUE_APP_MINIO_URL || '').replace(/\/$/, '')
      try {
        const parsed = new URL(url, window.location.origin)
        if (parsed.hostname === '127.0.0.1' || parsed.hostname === 'localhost') {
          if (process.env.NODE_ENV === 'production') {
            return `/minio${parsed.pathname}${parsed.search}`
          }
          return parsed.pathname + parsed.search
        }
        if (parsed.pathname.startsWith('/minio/')) {
          return parsed.pathname + parsed.search
        }
      } catch (e) {
        if (url.startsWith('/minio/')) {
          return url
        }
      }
      if (minioBase && !/^https?:\/\//i.test(url)) {
        return url.startsWith('/') ? `${minioBase}${url}` : `${minioBase}/${url}`
      }
      if (process.env.NODE_ENV === 'production' && /^\/[A-Za-z0-9_-]+\//.test(url)) {
        return `/minio${url}`
      }
      return url
    },

    getResourcePreviewUrl(url) {
      if (!url) return url
      try {
        const parsed = new URL(url, window.location.origin)
        if (parsed.pathname.startsWith('/api/file/preview')) {
          return parsed.pathname + parsed.search
        }
      } catch (e) {}
      const normalizedUrl = this.convertMinioUrl(url)
      if (!normalizedUrl) return normalizedUrl
      try {
        const parsed = new URL(normalizedUrl, window.location.origin)
        const previewPath = parsed.pathname.startsWith('/minio/')
          ? parsed.pathname.replace(/^\/minio/, '')
          : parsed.pathname
        return `/api/file/preview?path=${encodeURIComponent(previewPath + parsed.search)}`
      } catch (e) {
        return `/api/file/preview?path=${encodeURIComponent(normalizedUrl)}`
      }
    },

    getResourceHlsPreviewUrl(url) {
      if (!url) return url
      const previewUrl = this.getResourcePreviewUrl(url)
      try {
        const parsed = new URL(previewUrl, window.location.origin)
        const path = parsed.searchParams.get('path') || ''
        const decodedPath = decodeURIComponent(path)
        if (!/\.mp4(\?.*)?$/i.test(decodedPath)) {
          return previewUrl
        }
        const hlsPath = decodedPath.replace(/\.mp4(\?.*)?$/i, '/hls/index.m3u8')
        return `/api/file/preview?path=${encodeURIComponent(hlsPath)}`
      } catch (e) {
        return previewUrl.replace(/\.mp4(\?.*)?$/i, '/hls/index.m3u8')
      }
    },

    destroyHlsPlayer() {
      if (this.hlsPlayer) {
        try {
          this.hlsPlayer.destroy()
        } catch (e) {
          console.error('销毁 HLS 播放器失败', e)
        }
        this.hlsPlayer = null
      }
    },

    initVideoPlayback() {
      this.$nextTick(() => {
        const videoEl = this.$refs.videoPlayer
        if (!videoEl || !this.currentVideoUrl) {
          return
        }

        this.destroyHlsPlayer()

        if (this.currentVideoSourceType === 'hls') {
          if (videoEl.canPlayType('application/vnd.apple.mpegurl')) {
            videoEl.src = this.currentVideoUrl
            return
          }

          if (Hls.isSupported()) {
            const hls = new Hls({
              enableWorker: true,
              lowLatencyMode: false,
              backBufferLength: 30,
              maxBufferLength: 20,
              maxMaxBufferLength: 30
            })
            hls.loadSource(this.currentVideoUrl)
            hls.attachMedia(videoEl)
            hls.on(Hls.Events.ERROR, (event, data) => {
              console.error('HLS 播放失败', data)
              if (this.currentVideoFallbackUrl && this.currentVideoUrl !== this.currentVideoFallbackUrl) {
                this.destroyHlsPlayer()
                this.currentVideoSourceType = 'mp4'
                this.currentVideoUrl = this.currentVideoFallbackUrl
                this.$nextTick(() => {
                  const fallbackVideo = this.$refs.videoPlayer
                  if (fallbackVideo) {
                    fallbackVideo.src = this.currentVideoUrl
                    fallbackVideo.load()
                  }
                })
              }
            })
            this.hlsPlayer = hls
            return
          }
        }

        videoEl.src = this.currentVideoUrl
      })
    },

    // 获取课程详情
    async fetchCourseDetail() {
      try {
        const res = await getCourseById(this.courseId)
        if (res && res.data) {
          this.course.course_name = res.data.courseName || res.data.course_name || '课程名称'
          this.course.teacher_name = res.data.teacherName || res.data.teacher_name || res.data.teacherUserName || '教师'
          this.course.image = res.data.image || res.data.courseImage || ''
          this.course.organization = res.data.organization || ''
          this.course.term = res.data.term || ''
          this.course.repoId = res.data.repoId || res.data.repo_id || null
        }
      } catch (e) {
        console.error('获取课程详情失败', e)
      }
    },

    getHomeworkKnowledgeRepoId() {
      if (this.course && this.course.repoId) {
        return this.course.repoId
      }
      const firstCourseQuestion = Array.isArray(this.hwQuestionRawList)
        ? this.hwQuestionRawList.find(item => item && (item.repoId || item.repo_id))
        : null
      return firstCourseQuestion ? (firstCourseQuestion.repoId || firstCourseQuestion.repo_id || null) : null
    },

    resolveCourseName() {
      try {
        const q = this.$route.query || {}
        const p = this.$route.params || {}
        const ls = (k) => (localStorage.getItem(k) || '').trim()
        const candidates = [
          this.course.course_name,
          q.courseName, q.course_name, q.name, q.title,
          p.courseName, p.course_name, p.name, p.title,
          ls('currentCourseName'), ls('courseName'), ls('course_title')
        ].filter(Boolean)
        if (candidates.length) this.course.course_name = candidates[0]
      } catch (e) { /* ignore */ }
    },
    handleMenuSelect(key) {
      this.activeMenu = key
      if (key === 'teaching-plan') {
        this.fetchPlans()
      } else if (key === 'inform') {
        this.fetchNotices()
      } else if (key === 'profile') {
        this.fetchProfile()
      } else if (key === 'homework') {
        if (this.isTeacher) this.loadTeacherHomeworks(); else this.loadStudentHomeworks()
      } else if (key === 'target') {
        this.fetchObjectives()
      } else if (key === 'chapter') {
        this.fetchChaptersWithSections()
      } else if (key === 'knowledge') {
        this.fetchKnowledgeTree()
      } else if (key === 'resources') {
        this.fetchMaterials()
      } else if (key === 'question-bank') {
        this.loadQuestions()
      } else if (key === 'class-management') {
        this.fetchClasses()
      } else if (key === 'discussion') {
        this.fetchTopics()
      } else if (key === 'analysis') {
        if (this.isTeacher) {
          this.loadLearningAnalysis()
        } else {
          this.loadStudentStats()
        }
      }
    },
    // 学生端：刷新“我的作业”
    async onStudentRefresh() {
      try {
        this.studentRefreshLoading = true
        await this.loadStudentHomeworks()
      } finally {
        this.studentRefreshLoading = false
      }
    },
    // 学生端：加载作业列表
    async loadStudentHomeworks() {
      try {
        this.homeworkLoading = true
        const res = await studentHomeworkList(this.courseId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '加载作业失败')
          this.homeworkList = []
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        let homeworkList = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])

        console.log('========== 学生作业列表数据 ==========')
        console.log('作业总数:', homeworkList.length)

        // 解析每个作业的得分信息
        homeworkList = homeworkList.map(hw => {
          console.log(`作业【${hw.title}】:`, {
            submitted: hw.submitted,
            hasAnswerContent: !!hw.answerContent,
            answerContent: hw.answerContent,
            submitTime: hw.submitTime
          })

          if (hw.submitted && hw.answerContent) {
            try {
              const contentObj = JSON.parse(hw.answerContent)
              console.log('解析后的得分信息:', contentObj)
              hw.scoreInfo = {
                score: contentObj.score || 0,
                totalScore: contentObj.totalScore || 100,
                accuracy: contentObj.accuracy || 0,
                correct: contentObj.correct || 0,
                total: contentObj.total || 0
              }
              console.log('设置scoreInfo:', hw.scoreInfo)
            } catch (e) {
              console.error('解析作业得分失败:', e)
              hw.scoreInfo = null
            }
          } else {
            hw.scoreInfo = null
          }
          return hw
        })

        console.log('======================================')

        this.homeworkList = homeworkList
      } catch (e) {
        this.$message.error('加载作业失败')
        this.homeworkList = []
      } finally {
        this.homeworkLoading = false
      }
    },
    // 老师端：删除作业
    async removeHomework(row) {
      if (!this.isTeacher || !row || !row.id) return
      try {
        this.homeworkLoading = true
        const res = await deleteHomework(row.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.loadTeacherHomeworks()
      } catch (e) {
        this.$message.error('删除失败')
      } finally {
        this.homeworkLoading = false
      }
    },

    // ===== 作业题目选择 Methods =====
    openHomeworkQuestionSelector() {
      this.hwQuestionSelectorVisible = true
      this.hwQuestionSource = 'course' // 默认选择我的题库
      this.hwQuestionSearchKeyword = ''
      this.hwQuestionKnowledgeFilter = ''
      this.hwSelectedQuestions = []
      this.hwKnowledgeOptions = []
      this.loadHomeworkKnowledgeOptions()
      this.loadHomeworkQuestions()
    },

    async loadHomeworkQuestions() {
      try {
        this.hwQuestionLoading = true
        let res

        if (this.hwQuestionSource === 'course') {
          // 从我的题库加载（课程关联的题目）
          res = await getCourseQuestions(this.courseId)
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) {
            this.hwQuestionList = []
            return
          }
          let allQuestions = Array.isArray(res.data) ? res.data : (res.data?.records || res.data?.list || res || [])

          // 客户端搜索过滤
          if (this.hwQuestionSearchKeyword) {
            const keyword = this.hwQuestionSearchKeyword.toLowerCase()
            allQuestions = allQuestions.filter(q =>
              (q.contentCn && q.contentCn.toLowerCase().includes(keyword)) ||
              (q.knowledge && q.knowledge.toLowerCase().includes(keyword))
            )
          }
          this.hwQuestionRawList = allQuestions
        } else {
          // 从总题库加载（根据课程级别过滤的题目）
          const params = {
            pageNum: 1,
            pageSize: 1000,
            courseId: this.courseId
          }
          if (this.hwQuestionSearchKeyword) {
            params.content = this.hwQuestionSearchKeyword
          }
          res = await quPaging(params)
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) {
            this.hwQuestionList = []
            return
          }
          const data = (res && res.data !== undefined) ? res.data : res
          this.hwQuestionRawList = Array.isArray(data) ? data : (data?.records || data?.list || [])
        }

        // 加载知识点名称
        await this.enrichQuestionKnowledgeNames(this.hwQuestionRawList)
        this.applyHomeworkQuestionFilters()
      } catch (e) {
        console.error('加载作业题目失败', e)
        this.hwQuestionRawList = []
        this.hwQuestionList = []
      } finally {
        this.hwQuestionLoading = false
      }
    },

    async loadHomeworkKnowledgeOptions() {
      try {
        if (this.hwKnowledgeOptions && this.hwKnowledgeOptions.length) {
          return
        }
        const repoId = this.getHomeworkKnowledgeRepoId()
        if (!repoId) {
          this.hwKnowledgeOptions = []
          return
        }
        const res = await listGeneralKnowledgeTree(repoId)
        const data = (res && res.data !== undefined) ? res.data : res
        this.hwKnowledgeOptions = Array.isArray(data) ? data : (data?.records || data?.list || [])
      } catch (e) {
        console.error('加载知识点筛选选项失败', e)
        this.hwKnowledgeOptions = []
      }
    },

    findHomeworkKnowledgeNode(nodes, targetId) {
      if (!Array.isArray(nodes) || !targetId) return null
      for (const node of nodes) {
        if (!node) continue
        if (String(node.id) === String(targetId)) {
          return node
        }
        if (node.children && node.children.length) {
          const found = this.findHomeworkKnowledgeNode(node.children, targetId)
          if (found) return found
        }
      }
      return null
    },

    applyHomeworkQuestionFilters() {
      let filteredQuestions = Array.isArray(this.hwQuestionRawList) ? [...this.hwQuestionRawList] : []

      if (this.hwQuestionSearchKeyword) {
        const keyword = this.hwQuestionSearchKeyword.toLowerCase()
        filteredQuestions = filteredQuestions.filter(q =>
          (q.contentCn && q.contentCn.toLowerCase().includes(keyword)) ||
          (q.knowledge && q.knowledge.toLowerCase().includes(keyword)) ||
          (q.knowledgeNames && q.knowledgeNames.toLowerCase().includes(keyword))
        )
      }

      if (this.hwQuestionKnowledgeFilter) {
        const selectedId = String(this.hwQuestionKnowledgeFilter)
        const selectedOption = this.findHomeworkKnowledgeNode(this.hwKnowledgeOptions, selectedId)
        const selectedName = String((selectedOption && (selectedOption.label || selectedOption.content || selectedOption.name)) || '').trim().toLowerCase()
        filteredQuestions = filteredQuestions.filter(q => {
          const knowledgeValue = String(q.knowledge || '').trim()
          const knowledgeNames = String(q.knowledgeNames || '').trim().toLowerCase()

          if (!knowledgeValue && !knowledgeNames) {
            return false
          }

          const segments = knowledgeValue.split(',').map(id => String(id || '').trim()).filter(Boolean)
          const matchById = segments.includes(selectedId)
          const matchByName = selectedName && (
            knowledgeNames.includes(selectedName) ||
            knowledgeValue.toLowerCase().includes(selectedName)
          )

          return matchById || matchByName
        })
      }

      this.hwQuestionList = filteredQuestions
    },

    focusHomeworkKnowledgeFilter() {
      this.$message.info('请使用上方“按知识点筛选”级联选择器进行筛选')
    },

    // 为题目列表添加知识点名称
    async enrichQuestionKnowledgeNames(questions) {
      if (!questions || questions.length === 0) {
        console.log('📋 题目列表为空，跳过知识点名称加载')
        return
      }

      console.log(`📋 开始为 ${questions.length} 道题目加载知识点名称`)

      // 收集所有知识点ID
      const knowledgeIdSet = new Set()
      questions.forEach(q => {
        if (q.knowledge) {
          const ids = String(q.knowledge).split(',').map(id => id.trim()).filter(id => /^\d+$/.test(id))
          ids.forEach(id => knowledgeIdSet.add(id))
        }
      })

      console.log(`🔢 收集到 ${knowledgeIdSet.size} 个不同的知识点ID:`, Array.from(knowledgeIdSet))

      if (knowledgeIdSet.size === 0) {
        questions.forEach(q => {
          q.knowledgeNames = q.knowledge ? String(q.knowledge) : ''
        })
        console.log('⚠️ 没有题目包含知识点ID，直接使用原始知识点文本')
        return
      }

      // 批量加载知识点名称
      const knowledgeNameMap = await this.loadKnowledgeNames(Array.from(knowledgeIdSet))

      // 为每个题目添加knowledgeNames字段
      questions.forEach(q => {
        if (q.knowledge) {
          const parts = String(q.knowledge).split(',').map(id => id.trim()).filter(Boolean)
          const names = parts.map(id => {
            if (/^\d+$/.test(id)) {
              return knowledgeNameMap[id] || id
            }
            return id
          })
          q.knowledgeNames = names.join(', ')
        }
      })

      console.log('✅ 知识点名称加载完成')
    },

    handleHwQuestionSelectionChange(selection) {
      this.hwSelectedQuestions = selection
    },

    confirmHwQuestionSelection() {
      if (this.hwSelectedQuestions.length === 0) {
        this.$message.warning('请选择题目')
        return
      }

      // 转换为{id, score}格式，默认每题10分
      const selectedQuestions = this.hwSelectedQuestions.map(q => ({
        id: q.id,
        score: 10
      }))

      // 合并到现有题目，去重（基于id）
      const existing = this.hwForm.questions || []
      const existingIds = existing.map(q => q.id)
      const newQuestions = selectedQuestions.filter(q => !existingIds.includes(q.id))

      this.hwForm.questions = [...existing, ...newQuestions]
      this.$message.success(`已添加 ${newQuestions.length} 道题目，默认每题10分`)
      this.hwQuestionSelectorVisible = false
    },

    openCreateQuestionForHomework() {
      console.log('========= 点击新建题目按钮 =========')
      console.log('调用openQuestionDialog方法...')
      // 打开新建题目对话框
      this.openQuestionDialog()
      // 标记是为作业创建
      this.creatingForHomework = true
      console.log('creatingForHomework设置为:', this.creatingForHomework)
      console.log('questionDialogVisible:', this.questionDialogVisible)
      console.log('====================================')
    },

    removeQuestionFromHomework(index) {
      if (!this.hwForm.questions) return
      this.hwForm.questions.splice(index, 1)
      this.$message.success('已移除')
    },

    calculateTotalScore() {
      if (!this.hwForm.questions || this.hwForm.questions.length === 0) {
        return 0
      }
      return this.hwForm.questions.reduce((sum, q) => sum + (q.score || 0), 0)
    },

    onQuestionScoreChange() {
      // 分数改变时触发，用于刷新总分显示
      this.$forceUpdate()
    },

    // ===== 题目管理 Methods =====
    async loadQuestions() {
      if (this.isTeacher) {
        // 老师加载私有题库和公共题库
        await Promise.all([
          this.loadPrivateQuestions(),
          this.loadPublicQuestions()
        ])
      } else {
        // 学生只加载本课程的题目
        await this.loadPrivateQuestions()
      }
    },

    // 加载私有题库（本课程的题目）- 使用关联表
    async loadPrivateQuestions() {
      try {
        this.questionLoading = true
        console.log('📚 开始加载课程题目，courseId:', this.courseId)
        const res = await getCourseQuestions(this.courseId)
        console.log('📚 getCourseQuestions响应:', res)

        // 检查响应是否有效
        // 响应码为0且有错误信息时，显示错误但不阻止继续
        if (res && res.code === 0 && res.msg) {
          console.warn('⚠️ 后端返回警告:', res.msg)
          // 如果有数据，仍然尝试使用
          if (!res.data || (Array.isArray(res.data) && res.data.length === 0)) {
            this.$message.warning(res.msg + '，课程题库为空')
            this.questionList = []
            return
          }
        }

        // 正常的错误检查（排除code=0的情况）
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000 || res.code === 0
        if (!ok) {
          console.error('❌ 加载题目失败，响应码:', res.code, '错误信息:', res.msg)
          this.$message.error(res.msg || '加载我的题库失败')
          this.questionList = []
          return
        }

        const data = (res && res.data !== undefined) ? res.data : res
        this.questionList = Array.isArray(data) ? data : []
        console.log('📚 成功加载题目数量:', this.questionList.length)

        // 加载知识点名称
        if (this.questionList.length > 0) {
          await this.enrichQuestionKnowledgeNames(this.questionList)
        }
      } catch (e) {
        console.error('❌ 加载题目异常:', e)
        console.error('❌ 错误详情:', e.response || e.message || e)
        this.$message.error('加载我的题库失败: ' + (e.message || e.response?.data?.msg || ''))
        this.questionList = []
      } finally {
        this.questionLoading = false
      }
    },

    // 加载公共题库（repoId为null或0的题目）
    async loadPublicQuestions() {
      try {
        this.publicQuestionLoading = true
        console.log('📚 开始加载公共题库，courseId:', this.courseId)
        // 传入 courseId 参数，后端会根据课程级别过滤题目
        const params = {
          pageNum: 1,
          pageSize: 1000,
          courseId: this.courseId
        }
        console.log('📚 调用 quPaging，传递的参数:', JSON.stringify(params))
        const res = await quPaging(params)
        console.log('📚 quPaging响应:', res)
        console.log('📚 响应数据数量:', res?.data?.records?.length || res?.data?.length || 0)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          console.error('❌ 加载公共题库失败，响应码:', res.code, '错误信息:', res.msg)
          this.publicQuestionList = []
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        const allQuestions = Array.isArray(data) ? data : (data?.records || data?.list || [])
        console.log('📚 公共题库数量:', allQuestions.length)

        // 后端已根据课程级别过滤题目，直接使用返回的结果
        this.publicQuestionList = allQuestions
        console.log('📚 加载公共题库成功，题目数量:', this.publicQuestionList.length)
      } catch (e) {
        console.error('❌ 加载公共题库异常:', e)
        console.error('❌ 错误详情:', e.response || e.message || e)
        this.publicQuestionList = []
      } finally {
        this.publicQuestionLoading = false
      }
    },

    openQuestionDialog(row) {
      console.log('openQuestionDialog被调用，参数row:', row)

      if (row && row.id) {
        // 编辑模式
        console.log('进入编辑模式')
        this.questionEditingId = row.id
        this.questionForm = {
          contentCn: row.contentCn || '',
          contentEn: row.contentEn || '',
          optionsCn: row.optionsCn || '',
          optionsEn: row.optionsEn || '',
          answer: row.answer || '',
          analysisCn: row.analysisCn || '',
          analysisEn: row.analysisEn || '',
          difficulty: row.difficulty || '',
          knowledge: row.knowledge || '',
          year: row.year || '',
          number: row.number || '',
          repoId: row.repoId || this.courseId
        }
      } else {
        // 新建模式
        console.log('进入新建模式')
        this.questionEditingId = null
        this.questionForm = {
          contentCn: '',
          contentEn: '',
          optionsCn: '',
          optionsEn: '',
          answer: '',
          analysisCn: '',
          analysisEn: '',
          difficulty: '',
          knowledge: '',
          year: '',
          number: '',
          repoId: this.courseId
        }
      }

      console.log('设置questionDialogVisible = true')
      this.questionDialogVisible = true
      console.log('当前questionDialogVisible值:', this.questionDialogVisible)
    },

    closeQuestionDialog() {
      // 重置标记
      this.creatingForHomework = false
      this.questionEditingId = null
    },

    async submitQuestion() {
      const formRef = this.$refs.questionForm
      if (!formRef) return

      if (!this.questionForm.contentCn || !this.questionForm.contentCn.trim()) {
        this.$message.error('请输入题目内容')
        return
      }
      if (!this.questionForm.answer || !this.questionForm.answer.trim()) {
        this.$message.error('请输入答案')
        return
      }

      try {
        this.savingQuestion = true
        const payload = {
          ...this.questionForm,
          repoId: null // 新建题目到公共题库，repoId设为null
        }

        let res
        if (this.questionEditingId) {
          // 更新题目
          res = await quUpdate(this.questionEditingId, payload)
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) {
            this.$message.error(res.msg || '更新失败')
            return
          }
          this.$message.success('更新成功')
        } else {
          // 新建题目
          res = await quAdd(payload)
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) {
            this.$message.error(res.msg || '创建失败')
            return
          }

          // 获取新建题目的ID
          const newQuestionId = Number(res.data?.id || res.data || res.msg)
          if (newQuestionId) {
            // 自动添加到当前课程
            await addQuestionsToCourse(this.courseId, [newQuestionId])

            // 如果是为作业创建的，自动添加到作业题目列表
            if (this.creatingForHomework) {
              if (!this.hwForm.questions) {
                this.hwForm.questions = []
              }
              const existingIds = this.hwForm.questions.map(q => q.id)
              if (!existingIds.includes(newQuestionId)) {
                this.hwForm.questions.push({
                  id: newQuestionId,
                  score: 10 // 默认10分
                })
              }
            }
          }

          this.$message.success('创建成功')
        }

        this.questionDialogVisible = false

        // 如果不是为作业创建，刷新题目列表
        if (!this.creatingForHomework) {
          await this.loadQuestions()
        }
      } catch (e) {
        this.$message.error('保存失败：' + (e.message || ''))
      } finally {
        this.savingQuestion = false
      }
    },

    // 从题库选题
    openSelectFromLibrary() {
      this.selectLibraryVisible = true
      this.librarySearchKeyword = ''
      this.selectedLibraryQuestions = []
      this.loadLibraryQuestions()
    },

    async loadLibraryQuestions() {
      try {
        this.libraryLoading = true
        const params = {
          pageNum: 1,
          pageSize: 1000,
          courseId: this.courseId
        }
        if (this.librarySearchKeyword) {
          params.content = this.librarySearchKeyword
        }
        const res = await quPaging(params)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.libraryQuestionList = []
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        const allQuestions = Array.isArray(data) ? data : (data?.records || data?.list || [])
        // 显示所有题目（使用关联表后，题目可以被多个课程共享）
        this.libraryQuestionList = allQuestions
      } catch (e) {
        this.libraryQuestionList = []
      } finally {
        this.libraryLoading = false
      }
    },

    handleLibrarySelectionChange(selection) {
      this.selectedLibraryQuestions = selection
    },

    async confirmSelectQuestions() {
      if (this.selectedLibraryQuestions.length === 0) {
        this.$message.warning('请选择题目')
        return
      }

      try {
        this.libraryLoading = true
        // 批量添加题目关联到当前课程（不复制题目，只建立关联）
        const questionIds = this.selectedLibraryQuestions.map(q => q.id)
        const res = await addQuestionsToCourse(this.courseId, questionIds)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '添加题目失败')
          return
        }

        this.$message.success(`成功添加 ${this.selectedLibraryQuestions.length} 道题目到我的题库`)
        this.selectLibraryVisible = false
        await this.loadQuestions()
      } catch (e) {
        this.$message.error('添加题目失败：' + (e.message || ''))
      } finally {
        this.libraryLoading = false
      }
    },

    // 查看题目详情
    viewQuestionDetail(question) {
      this.viewingQuestion = question
      this.viewQuestionVisible = true
    },

    // 从我的题库移除题目（不删除题目本身）
    async removeQuestionFromMyCourse(questionId) {
      if (!questionId) return
      try {
        this.questionLoading = true
        const res = await removeQuestionFromCourse(this.courseId, questionId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '移除失败')
          return
        }
        this.$message.success('移除成功')
        await this.loadQuestions()
      } catch (e) {
        this.$message.error('移除失败：' + (e.message || ''))
      } finally {
        this.questionLoading = false
      }
    },

    // 删除题目（真正删除题目本身，谨慎使用）
    async deleteQuestion(questionId) {
      if (!questionId) return
      try {
        this.questionLoading = true
        const res = await quDel(questionId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.loadQuestions()
      } catch (e) {
        this.$message.error('删除失败')
      } finally {
        this.questionLoading = false
      }
    },

    // ===== 学生答题 Methods =====
    startAnswering(question) {
      if (!question) return
      this.currentQuestion = question
      this.userAnswer = ''
      this.showResult = false
      this.isCorrect = false
      this.answerDialogVisible = true
    },

    parseOptions(optionsStr) {
      if (!optionsStr) return []
      // 支持多种分隔符：| 或 ; 或换行
      let separator = '|'
      if (optionsStr.includes(';')) {
        separator = ';'
      } else if (optionsStr.includes('\n')) {
        separator = '\n'
      }
      return optionsStr.split(separator).map(o => o.trim()).filter(Boolean)
    },

    // 渲染LaTeX公式
    renderLatex(text) {
      // 确保输入是字符串
      if (!text) return ''
      if (typeof text !== 'string') {
        return String(text)
      }

      try {
        // 匹配 $...$ 格式的LaTeX公式
        return text.replace(/\$([^$]+)\$/g, (match, formula) => {
          try {
            return katex.renderToString(formula, {
              throwOnError: false,
              displayMode: false
            })
          } catch (e) {
            return match // 如果渲染失败，返回原文
          }
        })
      } catch (e) {
        return text
      }
    },

    // 获取题目图片列表
    getQuestionImages(question) {
      if (!question) return []

      const images = []
      const minioUrl = process.env.VUE_APP_MINIO_URL || 'http://localhost:9000'

      // 处理 imagePaths (JSON数组格式)
      if (question.imagePaths) {
        try {
          const paths = JSON.parse(question.imagePaths)
          if (Array.isArray(paths)) {
            paths.forEach(path => {
              if (path) {
                // 如果已经是完整URL，直接使用
                if (path.startsWith('http')) {
                  images.push(path)
                } else {
                  // 否则拼接MinIO URL
                  const formattedPath = path.startsWith('/') ? path : `/${path}`
                  images.push(`${minioUrl}${formattedPath}`)
                }
              }
            })
          }
        } catch (e) {
          console.warn('解析imagePaths失败:', e)
        }
      }

      // 处理单个 image 字段
      if (question.image && images.length === 0) {
        if (question.image.startsWith('http')) {
          images.push(question.image)
        } else {
          const formattedPath = question.image.startsWith('/') ? question.image : `/${question.image}`
          images.push(`${minioUrl}${formattedPath}`)
        }
      }

      return images
    },

    // 处理图片加载错误
    handleQuestionImageError(event) {
      console.error('题目图片加载失败:', event.target.src)
      event.target.style.display = 'none'
    },

    // 获取选项图片
    getOptionImage(question, optionIndex) {
      if (!question || !question.optionImages) return null

      const minioUrl = process.env.VUE_APP_MINIO_URL || 'http://localhost:9000'

      // optionImages 是分号分隔的字符串
      const images = question.optionImages.split(';').map(img => img.trim()).filter(img => img)

      if (optionIndex >= images.length) return null

      const imagePath = images[optionIndex]
      if (!imagePath) return null

      // 如果已经是完整URL，直接返回
      if (imagePath.startsWith('http')) {
        return imagePath
      }

      // 否则拼接MinIO URL
      const formattedPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`
      return `${minioUrl}${formattedPath}`
    },

    // 检查选项是否被选中
    isOptionSelected(optionKey) {
      if (!optionKey || !this.userAnswer) return false
      return this.userAnswer.includes(optionKey)
    },

    // 切换选项选择
    toggleOption(optionKey) {
      if (this.showResult) return // 已提交后不能修改
      if (!optionKey) return

      // 判断是单选还是多选（根据答案判断）
      const correctAnswer = (this.currentQuestion.answer || '').trim().toUpperCase()
      const isMultiple = correctAnswer.length > 1

      if (isMultiple) {
        // 多选模式
        if (!this.userAnswer) {
          this.userAnswer = optionKey
        } else if (this.userAnswer.includes(optionKey)) {
          // 取消选择
          this.userAnswer = this.userAnswer.split('').filter(l => l !== optionKey).join('')
        } else {
          // 添加选择（按字母顺序）
          const letters = (this.userAnswer + optionKey).split('').sort()
          this.userAnswer = letters.join('')
        }
      } else {
        // 单选模式
        this.userAnswer = optionKey
      }
    },

    async submitAnswer() {
      if (!this.userAnswer || !this.userAnswer.trim()) {
        this.$message.error('请输入答案')
        return
      }

      try {
        this.submittingAnswer = true

        const correctAnswer = (this.currentQuestion.answer || '').trim().toUpperCase()
        const userAns = this.userAnswer.trim().toUpperCase()
        this.isCorrect = userAns === correctAnswer
        this.showResult = true

        // 记录到后端
        const userId = localStorage.getItem('userId') || sessionStorage.getItem('userId')
        if (userId) {
          await addRecord({
            userId: Number(userId),
            quesId: this.currentQuestion.id,
            quesContent: this.currentQuestion.contentCn,
            userAnswer: this.userAnswer,
            answer: this.currentQuestion.answer,
            judge: this.isCorrect ? '正确' : '错误',
            isRight: this.isCorrect ? 1 : 0,
            knowledge: this.currentQuestion.knowledge,
            repoId: this.currentQuestion.repoId || this.courseId
          })
        }

        if (this.isCorrect) {
          this.$message.success('回答正确！')
        } else {
          this.$message.error('回答错误，请查看解析')
        }
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.submittingAnswer = false
      }
    },

    closeAnswerDialog() {
      this.currentQuestion = null
      this.userAnswer = ''
      this.showResult = false
      this.isCorrect = false
    },

    // ===== 作业统计 Methods =====
    async openHwStats(row) {
      try {
        if (!row || !row.id) return
        this.$message.info('正在加载统计...')
        this.hwStatsVisible = true
        this.hwStatsLoading = true
        const res = await getHomeworkStats(row.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '加载统计失败')
          this.hwStats = null
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        this.hwStats = data || null
      } catch (e) {
        this.$message.error('加载统计失败')
        this.hwStats = null
      } finally {
        this.hwStatsLoading = false
      }
    },
    formatDuration(sec) {
      const s = Number(sec || 0)
      if (!s || s <= 0) return '--'
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      const ss = s % 60
      const pad = n => String(n).padStart(2, '0')
      return (h > 0 ? `${h}:` : '') + `${pad(m)}:${pad(ss)}`
    },
    formatPercent(v) {
      const x = Number(v)
      if (isNaN(x) || x <= 0) return '0%'
      return Math.round(x * 100) + '%'
    },
    statusText(st) {
      if (st === 1) return '进行中'
      if (st === 2) return '已完成'
      return '草稿'
    },
    formatDateTime(v) {
      if (!v) return ''
      try {
        const s = String(v)
        if (s.includes('T')) return s.replace('T', ' ').slice(0, 19)
        return s.slice(0, 19)
      } catch (e) { return '' }
    },
    formatCountdown(seconds) {
      if (seconds === null || seconds === undefined) return '--:--'
      const totalSeconds = Math.max(0, Math.floor(seconds))
      const minutes = Math.floor(totalSeconds / 60)
      const secs = totalSeconds % 60
      return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    },
    formatSize(bytes) {
      const b = Number(bytes || 0)
      if (b < 1024) return b + ' B'
      const kb = b / 1024
      if (kb < 1024) return kb.toFixed(1) + ' KB'
      const mb = kb / 1024
      if (mb < 1024) return mb.toFixed(1) + ' MB'
      const gb = mb / 1024
      return gb.toFixed(1) + ' GB'
    },
    getHomeworkScoreColor(score, totalScore) {
      const percentage = totalScore > 0 ? (score / totalScore) * 100 : 0
      if (percentage >= 90) return '#67C23A'
      if (percentage >= 80) return '#409EFF'
      if (percentage >= 60) return '#E6A23C'
      return '#F56C6C'
    },
    getAccuracyTagType(accuracy) {
      if (accuracy >= 80) return 'success'
      if (accuracy >= 60) return ''
      return 'danger'
    },
    async fetchPlans() {
      if (!this.courseId) return
      this.plansLoading = true
      try {
        const res = await getTeachingPlans(this.courseId)
        // 调试日志
        // eslint-disable-next-line no-console
        console.log('fetchPlans resp =', res)
        let list = []
        // 放宽对返回码的判断：1、20000、0、200 视为成功
        const successCodes = new Set([1, 20000, 0, 200])
        if (typeof res?.code !== 'undefined' && !successCodes.has(res.code)) {
          this.$message.error(res.msg || '加载教学计划失败')
        }
        // 无论返回码如何，都尽量解析数据结构
        const data = (res && res.data !== undefined) ? res.data : res
        if (Array.isArray(data)) {
          list = data
        } else if (Array.isArray(data?.records)) {
          list = data.records
        } else if (Array.isArray(data?.list)) {
          list = data.list
        } else if (Array.isArray(res?.records)) {
          list = res.records
        } else if (Array.isArray(res?.list)) {
          list = res.list
        }
        // 将后端字段映射为前端使用的字段，并做容错
        this.plans = (list || []).map(it => {
          const rawStatus = it.status != null ? it.status : (it.state != null ? it.state : it.publishStatus)
          const statusNum = typeof rawStatus === 'string' ? parseInt(rawStatus, 10) : rawStatus
          return {
            ...it,
            planName: it.planName || it.title || it.name || '',
            status: Number.isFinite(statusNum) ? statusNum : 0,
            startDate: it.startDate || it.start || it.beginDate || it.start_time || it.start_time_str || it.startAt || it.fromDate || '',
            endDate: it.endDate || it.end || it.finishDate || it.end_time || it.end_time_str || it.endAt || it.toDate || ''
          }
        })
      } catch (e) {
        this.$message.error('加载教学计划失败')
      } finally {
        this.plansLoading = false
      }
    },
    openCreatePlan() {
      this.editingId = null
      this.planForm = { planName: '', academicYear: '', semester: '', description: '', status: 0 }
      this.planDateRange = []
      this.planDialogVisible = true
    },
    openEditPlan(row) {
      this.editingId = row.id
      this.planForm = {
        planName: row.planName || row.title || '',
        academicYear: row.academicYear || '',
        semester: row.semester || '',
        description: row.description || '',
        status: typeof row.status === 'number' ? row.status : 0
      }
      this.planDateRange = [row.startDate || '', row.endDate || ''].filter(Boolean)
      this.planDialogVisible = true
    },
    async submitPlan() {
      this.$refs.planForm.validate(async valid => {
        if (!valid) return
        const payload = {
          courseId: Number(this.courseId),
          // 后端使用 title 字段存储计划名
          title: this.planForm.planName,
          academicYear: this.planForm.academicYear,
          semester: this.planForm.semester,
          description: this.planForm.description,
          startDate: this.planDateRange?.[0] || null,
          endDate: this.planDateRange?.[1] || null,
          status: this.planForm.status
        }
        try {
          this.savingPlan = true
          if (this.editingId) {
            const res = await updateTeachingPlan(this.editingId, payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '更新失败')
              return
            }
            this.$message.success('更新成功')
            // 乐观更新：替换本地项
            const idx = this.plans.findIndex(p => p.id === this.editingId)
            if (idx !== -1) {
              this.$set(this.plans, idx, { ...this.plans[idx], ...payload, planName: payload.title })
            }
          } else {
            // 前置重复校验：同一课程下标题(title/planName)重复则阻止提交
            const newTitle = (this.planForm.planName || '').trim().toLowerCase()
            const duplicated = (this.plans || []).some(p => (p.planName || p.title || '').trim().toLowerCase() === newTitle)
            if (duplicated) {
              this.$message.warning('该课程下已存在相同名称的教学计划，请更换名称')
              return
            }
            const res = await createTeachingPlan(payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '创建失败')
              return
            }
            this.$message.success('创建成功')
            // 若后端返回新建实体，追加；否则刷新
            // eslint-disable-next-line no-console
            console.log('create plan resp =', res)
            const created = (res && res.data && res.data.id) ? res.data
                             : (res && res.data && res.data.plan) ? res.data.plan
                             : (res && res.data && res.data.created) ? res.data.created
                             : (res && res.id) ? res
                             : null
            if (created && (created.id || created.title || created.planName)) {
              this.plans = [{ ...created, planName: created.planName || created.title }, ...this.plans]
            }
          }
          this.planDialogVisible = false
          // 最终刷新一次，确保与服务端一致
          await this.fetchPlans()
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.savingPlan = false
        }
      })
    },
    async togglePublish(row) {
      // 没有专门的发布接口，直接更新 status: 0<->1
      const next = row.status === 1 ? 0 : 1
      try {
        const res = await updateTeachingPlan(row.id, { status: next })
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '操作失败')
          return
        }
        this.$message.success(next === 1 ? '已发布' : '已取消发布')
        // 乐观更新
        const idx = this.plans.findIndex(p => p.id === row.id)
        if (idx !== -1) {
          this.$set(this.plans, idx, { ...this.plans[idx], status: next })
        }
        // 仍然刷新确保一致
        this.fetchPlans()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    async removePlan(row) {
      try {
        const res = await deleteTeachingPlan(row.id)
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        // 本地移除
        this.plans = (this.plans || []).filter(p => p.id !== row.id)
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async fetchMaterials() {
      if (!this.courseId) return
      this.materialsLoading = true
      try {
        const res = await listMaterials(this.courseId)
        const successCodes = new Set([1, 20000, 0, 200])
        if (typeof res?.code !== 'undefined' && !successCodes.has(res.code)) {
          this.$message.error(res.msg || '加载资料失败')
        }
        const data = (res && res.data !== undefined) ? res.data : res
        if (Array.isArray(data)) {
          this.materialList = data
        } else if (Array.isArray(data?.records)) {
          this.materialList = data.records
        } else if (Array.isArray(res?.records)) {
          this.materialList = res.records
        } else {
          this.materialList = []
        }
      } catch (e) {
        this.$message.error('加载资料失败')
      } finally {
        this.materialsLoading = false
      }
    },
    onUploadSuccess(resp) {
      try {
        const item = resp && resp.data ? resp.data : null
        if (item) {
          this.materialList = [item, ...(this.materialList || [])]
        }
      } catch (e) {}
      this.$message.success('上传成功')
      this.uploadTitle = ''
      this.fetchMaterials()
    },
    onUploadError() {
      this.$message.error('上传失败')
    },
    withApiPrefix(url) {
      const u = String(url || '')
      if (!u) return '/api/uploads/'
      if (u.startsWith('/api/')) return u
      if (u.startsWith('/')) return '/api' + u
      return '/api/' + u
    },

    async loadTeacherHomeworks() {
      if (!this.isTeacher) return
      try {
        this.homeworkLoading = true
        const res = await teacherHomeworkList(this.courseId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '加载作业失败')
          this.homeworkList = []
          return
        }
        this.homeworkList = (res && res.data) ? res.data : []
      } catch (e) {
        this.$message.error('加载作业失败')
        this.homeworkList = []
      } finally {
        this.homeworkLoading = false
      }
    },

    async openHwDialog() {
      if (!this.isTeacher) return
      try {
        const r = await listClasses(this.courseId)
        this.classOptions = (r && r.data) ? r.data : []
      } catch (e) {
        this.classOptions = []
      }
      this.hwForm = {
        title: '',
        description: '',
        timeLimitMinutes: 0,
        startTime: '',
        endTime: '',
        classIds: [],
        questions: []
      }
      this.editingHwId = null
      this.hwDialogVisible = true
    },

    async openEditHomework(row) {
      if (!this.isTeacher || !row || !row.id) return
      try {
        const r = await getHomeworkDetail(row.id)
        const ok = !r || typeof r.code === 'undefined' || r.code === 1 || r.code === 20000
        if (!ok) return this.$message.error(r.msg || '获取作业详情失败')
        const data = (r && r.data) ? r.data : {}
        const hw = data.homework || row
        const classes = Array.isArray(data.classes) ? data.classes : []
        const qbfiles = Array.isArray(data.qbFiles) ? data.qbFiles : []
        // 提取题目和分数
        const questions = (data.questions || []).map(q => ({
          id: q.questionId || q.id,
          score: q.score || 10 // 如果没有分数，默认10分
        })).filter(q => q.id)

        this.hwForm = {
          title: hw.title || '',
          description: hw.description || '',
          timeLimitMinutes: Number(hw.timeLimitMinutes) || 0,
          startTime: hw.startTime || '',
          endTime: hw.endTime || '',
          classIds: classes.map(c => c.classId || c.id).filter(Boolean),
          questions: questions
        }
        // 班级选项
        try {
          const rr = await listClasses(this.courseId)
          this.classOptions = (rr && rr.data) ? rr.data : []
        } catch (e) { this.classOptions = [] }
        this.editingHwId = hw.id || row.id
        this.hwDialogVisible = true
      } catch (e) {
        this.$message.error('获取作业详情失败')
      }
    },

    async submitHwDialog() {
      if (!this.isTeacher) return
      if (!this.hwForm.title || !this.hwForm.title.trim()) {
        this.$message.error('请填写作业标题')
        return
      }
      if (!this.hwForm.classIds || this.hwForm.classIds.length === 0) {
        this.$message.error('请选择发布到的班级')
        return
      }
      try {
        this.homeworkLoading = true
        const payload = {
          courseId: this.courseId,
          title: this.hwForm.title.trim(),
          description: this.hwForm.description || '',
          timeLimitMinutes: Number(this.hwForm.timeLimitMinutes) || 0,
          startTime: this.hwForm.startTime || '',
          endTime: this.hwForm.endTime || '',
          classIds: this.hwForm.classIds,
          // 发送题目ID和分数映射
          questionIds: Array.isArray(this.hwForm.questions) ? this.hwForm.questions.map(q => q.id) : [],
          questionScores: Array.isArray(this.hwForm.questions)
            ? this.hwForm.questions.reduce((obj, q) => {
                obj[q.id] = q.score || 10
                return obj
              }, {})
            : {}
        }
        const res = this.editingHwId ? await updateHomework(this.editingHwId, payload) : await createHomework(payload)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '保存失败')
          return
        }
        this.$message.success('保存成功')
        this.hwDialogVisible = false
        await this.loadTeacherHomeworks()
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.homeworkLoading = false
      }
    },

    async openDoHomework(row) {
      if (!row || !row.id) return
      try {
        this.studentHomeworkLoading = true
        const res = await startHomework(row.id)
        console.log('========= 开始作业返回数据 =========')
        console.log('完整响应：', res)
        console.log('res.data：', res && res.data)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        const data = (res && res.data !== undefined) ? res.data : res

        console.log('解析后的data：', data)
        console.log('题目列表：', data && data.questions)
        console.log('题目数量：', data && data.questions ? data.questions.length : 0)
        console.log('===================================')

        if (!ok || !data || !data.homework) {
          this.$message.error((res && res.msg) || '无法开始作业')
          return
        }

        // 设置作业数据
        this.hwDoData.homework = data.homework
        this.hwDoData.qbFileIds = data.qbFileIds || []
        this.hwDoData.questions = data.questions || [] // 题目列表
        this.hwDoData.startTime = new Date().toISOString()
        this.hwDoData.isViewOnly = row.submitted || false // 标记是否为查看模式

        console.log('=== 开始作业 ===')
        console.log('作业ID:', data.homework.id)
        console.log('查看模式:', this.hwDoData.isViewOnly)
        console.log('题目列表:', this.hwDoData.questions.map(q => ({ id: q.id, title: q.contentCn })))

        // 重置答题状态
        this.hwCurrentQuestionIndex = 0
        this.hwCurrentAnswer = ''
        this.hwShowResult = false
        this.hwIsCorrect = false
        this.hwAllAnswers = []

        // 如果是查看模式，加载已提交的答题记录
        if (this.hwDoData.isViewOnly) {
          try {
            const answerRes = await getMyHomeworkAnswers(row.id)
            console.log('=== 查看作业答题记录 ===')
            console.log('1. 后端返回原始数据：', JSON.stringify(answerRes, null, 2))

            const answerOk = !answerRes || typeof answerRes.code === 'undefined' || answerRes.code === 1 || answerRes.code === 20000
            const answerData = (answerRes && answerRes.data !== undefined) ? answerRes.data : answerRes
            console.log('2. 解析后的答案数据：', JSON.stringify(answerData, null, 2))

            if (answerOk && answerData && Array.isArray(answerData)) {
              // 将答题记录映射到hwAllAnswers
              this.hwAllAnswers = answerData.map(answer => {
                console.log('3. 映射答题记录：', {
                  原始: answer,
                  questionId: answer.questionId,
                  questionId类型: typeof answer.questionId,
                  userAnswer: answer.userAnswer,
                  userAnswer类型: typeof answer.userAnswer,
                  isCorrect: answer.isCorrect,
                  isCorrect类型: typeof answer.isCorrect
                })
                return {
                  questionId: answer.questionId,
                  userAnswer: answer.userAnswer || '',
                  isCorrect: answer.isCorrect === 1 || answer.isCorrect === true
                }
              })
              console.log('4. 映射后的hwAllAnswers：', JSON.stringify(this.hwAllAnswers, null, 2))

              // 设置第一题的答案
              if (this.hwDoData.questions.length > 0 && this.hwAllAnswers.length > 0) {
                const firstQuestion = this.hwDoData.questions[0]
                console.log('5. 第一题信息：', { id: firstQuestion.id, title: firstQuestion.contentCn })

                const firstAnswer = this.hwAllAnswers.find(a => a.questionId == firstQuestion.id)
                console.log('6. 找到的第一题答案：', firstAnswer)

                if (firstAnswer) {
                  this.hwCurrentAnswer = firstAnswer.userAnswer || ''
                  console.log('7. 设置hwCurrentAnswer为：', this.hwCurrentAnswer)
                } else {
                  console.warn('7. 未找到第一题的答案记录！')
                }
              }
            }
          } catch (e) {
            console.error('加载答题记录失败：', e)
          }
          // 查看模式不显示计时器
          this.hwDoData.remainSeconds = 0
        } else {
          // 计时器
          const limit = Number(this.hwDoData.homework.timeLimitMinutes) || 0
          this.hwDoData.remainSeconds = limit > 0 ? limit * 60 : null // 不限时用null，而不是0
          if (this.hwDoData.timerId) clearInterval(this.hwDoData.timerId)
          if (limit > 0) {
            this.hwDoData.timerId = setInterval(async () => {
              if (this.hwDoData.remainSeconds > 0) {
                this.hwDoData.remainSeconds -= 1
              } else if (this.hwDoData.timerId) {
                clearInterval(this.hwDoData.timerId)
                this.hwDoData.timerId = null
                // 时间到了，直接提交并关闭
                this.$message.warning('答题时间已到，系统已自动提交您的作业')
                await this.finishHomework()
              }
            }, 1000)
          }
        }

        this.hwDoDialogVisible = true
      } catch (e) {
        this.$message.error('无法开始作业')
      } finally {
        this.studentHomeworkLoading = false
      }
    },

    closeDoDialog() {
      if (this.hwDoData && this.hwDoData.timerId) {
        clearInterval(this.hwDoData.timerId)
        this.hwDoData.timerId = null
      }
      this.hwDoDialogVisible = false
      this.hwDoData.homework = null
      this.hwDoData.qbFileIds = []
      this.hwDoData.questions = []
      this.hwDoData.startTime = ''
      this.hwDoData.remainSeconds = 0
      this.hwDoData.isViewOnly = false
      this.hwCurrentQuestionIndex = 0
      this.hwCurrentAnswer = ''
      this.hwShowResult = false
      this.hwIsCorrect = false
      this.hwAllAnswers = []
    },

    async submitDoHomework() {
      if (!this.hwDoData || !this.hwDoData.homework) return
      try {
        this.studentHomeworkLoading = true
        const hw = this.hwDoData.homework
        let elapsedSeconds = 0
        const limit = Number(hw.timeLimitMinutes) || 0
        if (limit > 0) {
          const total = limit * 60
          elapsedSeconds = Math.max(0, total - (this.hwDoData.remainSeconds || 0))
        } else if (this.hwDoData.startTime) {
          elapsedSeconds = Math.floor((Date.now() - new Date(this.hwDoData.startTime).getTime()) / 1000)
        }
        const res = await submitHomework(hw.id, { elapsedSeconds, answerContent: '' })
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error((res && res.msg) || '提交失败')
          return
        }
        this.$message.success('提交成功')
        this.closeDoDialog()
        await this.loadStudentHomeworks()
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.studentHomeworkLoading = false
      }
    },

    // ===== 作业答题 Methods =====
    // 检查作业选项是否被选中
    isHwOptionSelected(optionKey) {
      if (!optionKey || !this.hwCurrentAnswer) return false
      return this.hwCurrentAnswer.includes(optionKey)
    },

    // 切换作业选项选择
    toggleHwOption(optionKey) {
      if (this.hwShowResult) return // 已提交后不能修改
      if (!optionKey) return

      // 判断是单选还是多选（根据答案判断）
      const correctAnswer = (this.hwCurrentQuestion.answer || '').trim().toUpperCase()
      const isMultiple = correctAnswer.length > 1

      if (isMultiple) {
        // 多选模式
        if (!this.hwCurrentAnswer) {
          this.hwCurrentAnswer = optionKey
        } else if (this.hwCurrentAnswer.includes(optionKey)) {
          // 取消选择
          this.hwCurrentAnswer = this.hwCurrentAnswer.split('').filter(l => l !== optionKey).join('')
        } else {
          // 添加选择（按字母顺序）
          const letters = (this.hwCurrentAnswer + optionKey).split('').sort()
          this.hwCurrentAnswer = letters.join('')
        }
      } else {
        // 单选模式
        this.hwCurrentAnswer = optionKey
      }
    },

    // 提交当前题目答案
    submitHwCurrentAnswer() {
      if (!this.hwCurrentQuestion || !this.hwCurrentAnswer) return

      // 判断对错（大小写不敏感）
      const userAnswer = this.hwCurrentAnswer.trim().toUpperCase()
      const correctAnswer = (this.hwCurrentQuestion.answer || '').trim().toUpperCase()
      this.hwIsCorrect = userAnswer === correctAnswer

      // 记录答案
      this.hwAllAnswers.push({
        questionId: this.hwCurrentQuestion.id,
        userAnswer: this.hwCurrentAnswer,
        isCorrect: this.hwIsCorrect
      })

      // 显示结果
      this.hwShowResult = true
    },

    // 下一题
    goToNextHwQuestion() {
      this.hwCurrentQuestionIndex++
      this.hwCurrentAnswer = ''
      this.hwShowResult = false
      this.hwIsCorrect = false
    },

    // 导出作业为PDF
    async exportHomeworkToPDF() {
      if (!this.hwDoData.homework || !this.hwDoData.questions || this.hwDoData.questions.length === 0) {
        this.$message.warning('无可导出内容')
        return
      }

      try {
        this.exportingPDF = true
        this.$message.info('正在生成PDF，请稍候...')

        const homework = this.hwDoData.homework
        const questions = this.hwDoData.questions
        const userName = this.currentUser ? this.currentUser.userName || this.currentUser.username : '学生'

        // 创建临时容器
        const container = document.createElement('div')
        container.style.position = 'absolute'
        container.style.left = '-9999px'
        container.style.top = '0'
        container.style.width = '800px'
        container.style.padding = '30px'
        container.style.background = 'white'
        container.style.fontFamily = 'Microsoft YaHei, SimSun, sans-serif'
        container.style.fontSize = '14px'
        container.style.lineHeight = '1.8'
        container.style.color = '#333'

        // 复制katex样式到容器
        const katexLinks = document.querySelectorAll('link[href*="katex"]')
        katexLinks.forEach(link => {
          const clonedLink = link.cloneNode(true)
          container.appendChild(clonedLink)
        })

        // 添加额外的katex样式
        const katexStyle = document.createElement('style')
        katexStyle.textContent = `
          .katex { font-size: 1.1em; }
          .katex-display { margin: 1em 0; }
        `
        container.appendChild(katexStyle)

        // 构建HTML内容
        let htmlContent = `
          <div style="text-align: center; margin-bottom: 30px; border-bottom: 2px solid #409EFF; padding-bottom: 20px;">
            <h1 style="font-size: 28px; color: #409EFF; margin-bottom: 15px;">${homework.title}</h1>
            <div style="font-size: 14px; color: #666; margin: 5px 0;">学生姓名：${userName}</div>
            <div style="font-size: 14px; color: #666; margin: 5px 0;">导出时间：${new Date().toLocaleString('zh-CN')}</div>
            ${homework.description ? `<div style="font-size: 14px; color: #666; margin: 5px 0;">作业说明：${homework.description}</div>` : ''}
          </div>
        `

        // 添加每道题目
        for (let index = 0; index < questions.length; index++) {
          const q = questions[index]
          const myAnswer = this.hwAllAnswers[index] ? this.hwAllAnswers[index].userAnswer : '未作答'
          const correctAnswer = q.answer || '无'
          const isCorrect = this.hwAllAnswers[index] ? this.hwAllAnswers[index].isCorrect : false

          htmlContent += `
            <div style="margin: 25px 0; padding: 20px; border: 1px solid #EBEEF5; border-radius: 8px; background: #F9FAFB;">
              <div style="font-size: 16px; font-weight: bold; color: #303133; margin-bottom: 15px; padding: 10px; background: #E6F7FF; border-left: 4px solid #409EFF;">
                第 ${index + 1} 题：<span class="question-content">${this.renderLatex(q.contentCn || q.contentEn || '')}</span>
              </div>
              
              ${(q.optionsCn || q.optionsEn) ? `
                <div style="margin: 15px 0; padding-left: 10px;">
                  ${this.parseOptions(q.optionsCn || q.optionsEn).map(opt =>
                    `<div style="padding: 8px 12px; margin: 6px 0; border-radius: 4px; background: white; border: 1px solid #E4E7ED;">${this.renderLatex(opt)}</div>`
                  ).join('')}
                </div>
              ` : ''}
              
              <div style="margin-top: 15px; padding: 15px; background: white; border-radius: 6px;">
                <div style="padding: 10px 0;">
                  <span style="font-weight: 600; color: #606266;">我的答案：</span>
                  <span style="font-size: 15px; font-weight: 600; color: ${isCorrect ? '#409EFF' : '#F56C6C'};">${myAnswer}</span>
                </div>
                <div style="padding: 10px 0;">
                  <span style="font-weight: 600; color: #606266;">正确答案：</span>
                  <span style="font-size: 15px; font-weight: 600; color: #67C23A;">${correctAnswer}</span>
                </div>
              </div>
              
              ${q.analysisCn || q.analysisEn ? `
                <div style="margin-top: 15px; padding: 15px; background: #FFF9E6; border-left: 4px solid #E6A23C; border-radius: 4px;">
                  <div style="font-weight: bold; color: #E6A23C; margin-bottom: 10px;">📝 答案解析</div>
                  <div style="color: #666; line-height: 1.8;">${this.renderLatex(q.analysisCn || q.analysisEn || '')}</div>
                </div>
              ` : ''}
            </div>
          `
        }

        htmlContent += `
          <div style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #DCDFE6; text-align: center; color: #909399; font-size: 12px;">
            <p>本作业报告由系统自动生成</p>
          </div>
        `

        container.innerHTML = htmlContent
        document.body.appendChild(container)

        // 等待渲染完成和katex加载
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))

        // 使用html2canvas转换为canvas
        const canvas = await html2canvas(container, {
          scale: 2,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff'
        })

        // 创建PDF
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        })

        const imgWidth = 210 // A4宽度（mm）
        const pageHeight = 297 // A4高度（mm）
        const imgHeight = (canvas.height * imgWidth) / canvas.width
        let heightLeft = imgHeight
        let position = 0

        // 添加第一页
        const imgData = canvas.toDataURL('image/jpeg', 1.0)
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
        heightLeft -= pageHeight

        // 如果内容超过一页，添加更多页
        while (heightLeft > 0) {
          position = heightLeft - imgHeight
          pdf.addPage()
          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight)
          heightLeft -= pageHeight
        }

        // 下载PDF
        const fileName = `${homework.title}-${userName}-${new Date().getTime()}.pdf`
        pdf.save(fileName)

        // 清理临时容器
        document.body.removeChild(container)

        this.$message.success('PDF导出成功！')
        this.exportingPDF = false
      } catch (e) {
        console.error('导出PDF失败:', e)
        this.$message.error('导出失败：' + (e.message || '未知错误'))
        this.exportingPDF = false
      }
    },

    // 移除HTML标签（用于PDF导出）
    stripHtml(html) {
      if (!html) return ''
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    },

    // 完成作业
    async finishHomework() {
      if (!this.hwDoData.homework) return

      try {
        this.studentHomeworkLoading = true

        console.log('=== 提交答题记录 ===')
        console.log('作业ID:', this.hwDoData.homework.id)
        console.log('答题记录数量:', this.hwAllAnswers.length)
        console.log('答题记录详情:', JSON.stringify(this.hwAllAnswers, null, 2))

        // 1. 提交所有答题记录到后端
        const res1 = await submitHomeworkAnswers(this.hwDoData.homework.id, this.hwAllAnswers)
        console.log('后端返回结果:', res1)

        const ok1 = !res1 || typeof res1.code === 'undefined' || res1.code === 1 || res1.code === 20000
        if (!ok1) {
          this.$message.error((res1 && res1.msg) || '提交答题记录失败')
          console.error('提交答题记录失败:', res1)
          return
        }
        console.log('答题记录提交成功')

        // 2. 计算得分和统计信息
        const hw = this.hwDoData.homework
        const totalQuestions = this.hwDoData.questions.length
        const correctCount = this.hwAllAnswers.filter(a => a.isCorrect).length
        const accuracy = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0

        // 计算实际得分（基于题目分数）
        let actualScore = 0
        let totalPossibleScore = 0

        // 构建题目ID到分数的映射
        const questionScoreMap = {}
        this.hwDoData.questions.forEach(q => {
          questionScoreMap[q.id] = q.score || 10 // 默认10分
          totalPossibleScore += (q.score || 10)
        })

        // 计算答对题目的得分
        this.hwAllAnswers.forEach(answer => {
          if (answer.isCorrect) {
            actualScore += (questionScoreMap[answer.questionId] || 10)
          }
        })

        console.log('作业完成统计:', {
          totalQuestions,
          correctCount,
          accuracy: accuracy + '%',
          actualScore,
          totalPossibleScore
        })

        // 计算用时
        let elapsedSeconds = 0
        const limit = Number(hw.timeLimitMinutes) || 0
        if (limit > 0) {
          const total = limit * 60
          elapsedSeconds = Math.max(0, total - (this.hwDoData.remainSeconds || 0))
        } else if (this.hwDoData.startTime) {
          elapsedSeconds = Math.floor((Date.now() - new Date(this.hwDoData.startTime).getTime()) / 1000)
        }

        // 3. 提交作业完成状态
        const res2 = await submitHomework(hw.id, {
          elapsedSeconds,
          answerContent: JSON.stringify({
            total: totalQuestions,
            correct: correctCount,
            accuracy: accuracy,
            score: actualScore,
            totalScore: totalPossibleScore
          })
        })

        const ok2 = !res2 || typeof res2.code === 'undefined' || res2.code === 1 || res2.code === 20000
        if (!ok2) {
          this.$message.warning('答题记录已保存，但状态更新失败')
        }

        // 显示完成提示
        this.$message({
          type: 'success',
          duration: 5000,
          message: `作业完成！答对 ${correctCount} / ${totalQuestions} 题，正确率：${accuracy}%，得分：${actualScore}/${totalPossibleScore}分`,
          showClose: true
        })

        // 4. 分析错题知识点并提醒练习（在关闭对话框之前）
        await this.analyzeWrongQuestionKnowledge()

        // 5. 重新加载作业列表
        await this.loadStudentHomeworks()
      } catch (e) {
        this.$message.error('提交失败：' + (e.message || ''))
      } finally {
        this.studentHomeworkLoading = false
        // 无论成功或失败，都关闭对话框
        this.closeDoDialog()
      }
    },

    // 分析错题知识点
    async analyzeWrongQuestionKnowledge() {
      console.log('🎯 开始分析错题知识点')

      // 获取错题
      const wrongAnswers = this.hwAllAnswers.filter(a => !a.isCorrect)

      console.log(`❌ 错题数量: ${wrongAnswers.length}`)

      if (wrongAnswers.length === 0) {
        console.log('✅ 全部答对，不需要提醒')
        // 全对，不需要提醒
        return
      }

      // 收集所有知识点ID
      const knowledgeIds = new Set()
      wrongAnswers.forEach(answer => {
        const question = this.hwDoData.questions.find(q => q.id === answer.questionId)
        console.log(`题目 ${answer.questionId} 的knowledge字段:`, question?.knowledge)
        if (question && question.knowledge) {
          // 知识点可能是多个ID，用逗号分隔
          const ids = question.knowledge.split(',').map(id => id.trim()).filter(Boolean)
          ids.forEach(id => knowledgeIds.add(id))
        }
      })

      console.log(`🔢 收集到的知识点ID:`, Array.from(knowledgeIds))

      if (knowledgeIds.size === 0) {
        console.log('⚠️ 错题没有知识点信息，不显示提醒')
        return
      }

      // 加载知识点名称映射
      const knowledgeNameMap = await this.loadKnowledgeNames(Array.from(knowledgeIds))
      console.log('📚 知识点名称映射:', knowledgeNameMap)

      // 统计错题的知识点
      const knowledgeMap = new Map()

      console.log('📊 开始统计知识点...')
      console.log('📚 作业题目列表:', this.hwDoData.questions)
      console.log('❌ 错题答案列表:', wrongAnswers)

      wrongAnswers.forEach((answer, idx) => {
        const question = this.hwDoData.questions.find(q => q.id === answer.questionId)
        console.log(`统计第${idx + 1}题，题目ID: ${answer.questionId}，question对象:`, question)

        if (question && question.knowledge) {
          const ids = question.knowledge.split(',').map(id => id.trim()).filter(Boolean)
          console.log(`  知识点ID列表:`, ids)

          ids.forEach(knowledgeId => {
            const knowledgeName = knowledgeNameMap[knowledgeId]
            console.log(`  ID ${knowledgeId} → 名称: ${knowledgeName}`)

            const finalName = knowledgeName || `知识点${knowledgeId}`

            if (!knowledgeMap.has(finalName)) {
              console.log(`  ✨ 新增知识点: ${finalName}`)
              knowledgeMap.set(finalName, {
                knowledge: finalName,
                count: 0,
                questionIds: []
              })
            }
            const item = knowledgeMap.get(finalName)
            item.count++
            if (!item.questionIds.includes(question.id)) {
              item.questionIds.push(question.id)
            }
            console.log(`  ✅ ${finalName} 错误次数: ${item.count}`)
          })
        } else {
          console.log(`  ⚠️ 题目没有knowledge字段或题目不存在`)
        }
      })

      console.log('📋 知识点统计Map:', knowledgeMap)

      // 如果没有知识点信息，不显示提醒
      if (knowledgeMap.size === 0) {
        console.log('⚠️ 知识点统计为空，不显示提醒')
        return
      }

      // 按错题数量降序排序
      const weakKnowledgeList = Array.from(knowledgeMap.values())
        .sort((a, b) => b.count - a.count)

      console.log('📊 薄弱知识点统计:', weakKnowledgeList)

      // 显示提醒对话框
      this.showWeakKnowledgeAlert(weakKnowledgeList, wrongAnswers.length)
    },

    // 加载知识点名称映射
    async loadKnowledgeNames(knowledgeIds) {
      if (!knowledgeIds || knowledgeIds.length === 0) {
        return {}
      }

      try {
        console.log('🔍 开始加载知识点名称，ID列表:', knowledgeIds)

        // 调用API获取知识点列表
        const res = await batchGetGeneralKnowledgeNames(knowledgeIds)

        console.log('📥 API返回结果:', res)

        // 兼容多种返回格式
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (ok && res.data) {
          // 构建ID到名称的映射（同时支持数字和字符串key）
          const nameMap = {}
          const dataList = Array.isArray(res.data) ? res.data : (res.data.records || res.data.list || [])
          dataList.forEach(item => {
            // 同时存储数字和字符串版本的key
            nameMap[item.id] = item.content // 数字key
            nameMap[String(item.id)] = item.content // 字符串key
          })
          console.log('✅ 知识点名称映射:', nameMap)
          return nameMap
        } else {
          console.warn('⚠️ API返回数据格式不正确或失败:', res)
        }
      } catch (e) {
        console.error('❌ 加载知识点名称失败:', e)
      }

      return {}
    },

    // 显示薄弱知识点提醒
    showWeakKnowledgeAlert(weakKnowledgeList, wrongCount) {
      const knowledgeHtml = weakKnowledgeList.map(item =>
        `<div style="padding:8px 12px;margin:6px 0;background:#FFF7E6;border-left:3px solid #FFA940;border-radius:4px;">
          <span style="font-weight:600;color:#D46B08;">${item.knowledge}</span>
          <span style="color:#8C8C8C;margin-left:8px;">错误 ${item.count} 题</span>
        </div>`
      ).join('')

      this.$alert(
        `<div style="padding:10px;">
          <div style="margin-bottom:12px;font-size:15px;color:#595959;">
            本次作业您答错了 <span style="color:#F5222D;font-weight:600;">${wrongCount}</span> 题，
            涉及以下知识点：
          </div>
          ${knowledgeHtml}
          <div style="margin-top:16px;padding:12px;background:#E6F7FF;border-radius:4px;font-size:13px;color:#0050B3;">
            <i class="el-icon-info"></i> 建议您到"知识点精炼"中针对性地练习这些知识点的题目，巩固薄弱环节！
          </div>
        </div>`,
        '💡 学习建议',
        {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'weak-knowledge-dialog'
        }
      )
    },

    // ===== 作业题目选择 Methods =====
    async openQbSelector() {
      try {
        this.hwQbSelectorVisible = true
        this.hwQbSelectedIdArr = Array.isArray(this.hwForm.qbFileIds) ? [...this.hwForm.qbFileIds] : []
        await this.loadHwQbTree()
      } catch (e) {}
    },
    async loadHwQbTree() {
      try {
        const res = await qbFolderTree()
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) return this.$message.error(res.msg || '加载题库目录失败')
        const data = (res && res.data !== undefined) ? res.data : res
        this.hwQbTree = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])
        const first = this.hwQbTree && this.hwQbTree.length ? this.hwQbTree[0] : null
        if (first) {
          this.hwQbSelectedFolder = first
          await this.loadHwQbFiles()
        } else {
          this.hwQbFiles = []
        }
      } catch (e) {
        this.$message.error('加载题库目录失败')
      }
    },
    async onHwQbNodeClick(data) {
      this.hwQbSelectedFolder = data
      await this.loadHwQbFiles()
    },
    async loadHwQbFiles() {
      if (!this.hwQbSelectedFolder) return
      this.hwQbFilesLoading = true
      try {
        const res = await qbListFiles(this.hwQbSelectedFolder.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) this.$message.error(res.msg || '加载文件失败')
        const data = (res && res.data !== undefined) ? res.data : res
        this.hwQbFiles = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])
        this.$nextTick(() => {
          const table = this.$refs.hwQbTableRef
          if (table && typeof table.clearSelection === 'function') table.clearSelection()
          if (table && Array.isArray(this.hwQbFiles)) {
            this.hwQbFiles.forEach(row => {
              if (this.hwQbSelectedIdArr.includes(row.id) && typeof table.toggleRowSelection === 'function') {
                table.toggleRowSelection(row, true)
              }
            })
          }
        })
      } catch (e) {
        this.$message.error('加载文件失败')
      } finally {
        this.hwQbFilesLoading = false
      }
    },
    onHwQbSelectionChange(selection) {
      try {
        const ids = Array.isArray(selection) ? selection.map(s => s.id).filter(id => id != null) : []
        const set = new Set(this.hwQbSelectedIdArr)
        ids.forEach(id => set.add(id))
        const currentIds = new Set(ids)
        if (Array.isArray(this.hwQbFiles)) {
          this.hwQbFiles.forEach(row => { if (!currentIds.has(row.id)) set.delete(row.id) })
        }
        this.hwQbSelectedIdArr = Array.from(set)
      } catch (e) {}
    },
    confirmQbSelection() {
      this.hwForm.qbFileIds = Array.isArray(this.hwQbSelectedIdArr) ? [...this.hwQbSelectedIdArr] : []
      this.hwQbSelectorVisible = false
    },
    clearQbSelection() {
      this.hwForm.qbFileIds = []
      this.hwQbSelectedIdArr = []
    },
    async removeMaterial(row) {
      try {
        const res = await deleteMaterial(row.id)
        const ok = res && (res.code === 1 || res.code === 20000)
        if (!ok) {
          this.$message.error((res && res.msg) || '删除失败')
          return
        }
        this.$message.success('已删除')
        this.fetchMaterials()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async downloadMaterial(row) {
      try {
        const url = this.withApiPrefix(row.url)
        const headers = {}
        try {
          const t = localStorage.getItem('token') || sessionStorage.getItem('token') || ''
          if (t) headers['Authorization'] = t.startsWith('Bearer ') ? t : `Bearer ${t}`
        } catch (e) {}
        const resp = await fetch(url, { headers })
        if (!resp.ok) {
          this.$message.error('下载失败')
          return
        }
        const blob = await resp.blob()
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = row.fileName || 'download'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      } catch (e) {
        this.$message.error('下载失败')
      }
    },
    openCreateNotice() {
      this.noticeEditingId = null
      this.noticeForm = { title: '', content: '' }
      this.noticeDialogVisible = true
    },
    openEditNotice(row) {
      this.noticeEditingId = row.id
      this.noticeForm = { title: row.title || '', content: row.content || '' }
      this.noticeDialogVisible = true
    },
    async submitNotice() {
      this.$refs.noticeForm.validate(async valid => {
        if (!valid) return
        const payload = { title: this.noticeForm.title, content: this.noticeForm.content, courseId: Number(this.courseId) }
        try {
          this.savingNotice = true
          if (this.noticeEditingId) {
            const res = await updateNotice(this.noticeEditingId, payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '更新失败')
              return
            }
            this.$message.success('更新成功')
          } else {
            const res = await createNotice(payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '创建失败')
              return
            }
            this.$message.success('创建成功')
          }
          this.noticeDialogVisible = false
          await this.fetchNotices()
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.savingNotice = false
        }
      })
    },
    async removeNotice(row) {
      try {
        const id = row.id
        const res = await deleteNotice(id)
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.fetchNotices()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async handleNoticePageChange(p) {
      this.noticePage = p
      await this.fetchNotices()
    },

    async fetchNotices() {
      if (!this.courseId) {
        console.log('fetchNotices: courseId为空，跳过加载')
        return
      }

      console.log('fetchNotices: 开始加载通知，courseId=', this.courseId)
      this.noticeLoading = true

      try {
        const res = await pageNotices({
          courseId: Number(this.courseId),
          pageNum: this.noticePage,
          pageSize: this.noticePageSize
        })

        console.log('fetchNotices: 响应数据=', res)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          console.warn('fetchNotices: 响应状态不正常', res)
          this.$message.error(res.msg || '加载通知失败')
          this.noticeList = []
          this.noticeTotal = 0
          return
        }

        const data = (res && res.data !== undefined) ? res.data : res
        console.log('fetchNotices: 解析后的数据=', data)

        if (data && Array.isArray(data.records)) {
          this.noticeList = data.records
          this.noticeTotal = data.total || 0
          console.log(`fetchNotices: 加载成功，共${this.noticeTotal}条通知`)
        } else if (Array.isArray(data)) {
          this.noticeList = data
          this.noticeTotal = data.length
          console.log(`fetchNotices: 加载成功(数组格式)，共${this.noticeTotal}条通知`)
        } else {
          this.noticeList = []
          this.noticeTotal = 0
          console.log('fetchNotices: 数据格式不符合预期，已清空列表')
        }
      } catch (e) {
        console.error('fetchNotices: 发生错误', e)
        this.$message.error('加载通知失败：' + (e.message || e.toString()))
        this.noticeList = []
        this.noticeTotal = 0
      } finally {
        this.noticeLoading = false
      }
    },

    async fetchProfile() {
      if (!this.courseId) return
      this.profileLoading = true
      try {
        const res = await getCourseProfile(Number(this.courseId))
        const data = res && res.data ? res.data : null
        this.profileContent = (data && data.content) ? data.content : ''
      } catch (e) {
        this.$message.error('加载课程简介失败')
      } finally {
        this.profileLoading = false
      }
    },
    async saveProfile() {
      try {
        this.profileSaving = true
        const res = await saveCourseProfile(Number(this.courseId), this.profileContent || '')
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '保存失败')
          return
        }
        this.$message.success('已保存')
        await this.fetchProfile()
      } catch (e) {
        this.$message.error('保存失败')
      } finally {
        this.profileSaving = false
      }
    },
    async fetchObjectives() {
      if (!this.courseId) return
      this.objectiveLoading = true
      try {
        let res
        if (this.isTeacher) {
          res = await pageObjectives(this.objectivePage, this.objectivePageSize, Number(this.courseId), '')
        } else {
          res = await pageNewObjectives(this.objectivePage, this.objectivePageSize, Number(this.courseId))
        }
        let records = []
        let total = 0
        if (res && res.data) {
          const page = res.data
          records = page.records || page.list || []
          total = page.total || 0
        }
        this.objectiveList = records
        this.objectiveTotal = total
      } catch (e) {
        this.$message.error('加载教学目标失败')
      } finally {
        this.objectiveLoading = false
      }
    },
    openCreateObjective() {
      this.objectiveEditingId = null
      this.objectiveForm = { title: '', content: '' }
      this.objectiveDialogVisible = true
    },
    openEditObjective(row) {
      this.objectiveEditingId = row.id
      this.objectiveForm = { title: row.title || '', content: row.content || '' }
      this.objectiveDialogVisible = true
    },
    async submitObjective() {
      this.$refs.objectiveForm.validate(async valid => {
        if (!valid) return
        const payload = { title: this.objectiveForm.title, content: this.objectiveForm.content, courseId: Number(this.courseId) }
        try {
          this.savingObjective = true
          if (this.objectiveEditingId) {
            const res = await updateObjective(this.objectiveEditingId, payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '更新失败')
              return
            }
            this.$message.success('更新成功')
          } else {
            const res = await createObjective(payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '创建失败')
              return
            }
            this.$message.success('创建成功')
          }
          this.objectiveDialogVisible = false
          await this.fetchObjectives()
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.savingObjective = false
        }
      })
    },
    async removeObjective(row) {
      try {
        const id = row.id
        const res = await deleteObjective(id)
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.fetchObjectives()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async handleObjectivePageChange(p) {
      this.objectivePage = p
      await this.fetchObjectives()
    },
    async fetchChapters() {
      if (!this.courseId) return
      this.chapterLoading = true
      try {
        let res
        if (this.isTeacher) {
          // 使用不分页接口
          res = await listChapters(Number(this.courseId), '')
        } else {
          res = await pageNewChapters(this.chapterPage, this.chapterPageSize, Number(this.courseId))
        }
        let records = []
        if (res && res.data) {
          // 不分页接口直接返回数组
          records = Array.isArray(res.data) ? res.data : (res.data.records || res.data.list || [])
        }
        this.chapterList = records
        this.chapterTotal = records.length
      } catch (e) {
        console.error('❌ 加载课程章节失败:', e)
        console.error('错误详情:', e.response || e.message)
        this.$message.error('加载课程章节失败: ' + (e.message || '未知错误'))
      } finally {
        this.chapterLoading = false
      }
    },
    openCreateChapter() {
      this.chapterEditingId = null
      this.chapterForm = { title: '', content: '', sort: 0 }
      this.chapterDialogVisible = true
    },
    openEditChapter(row) {
      this.chapterEditingId = row.id
      this.chapterForm = { title: row.title || '', content: row.content || '', sort: row.sort || 0 }
      this.chapterDialogVisible = true
    },
    async submitChapter() {
      const formRef = this.$refs.chapterForm
      if (!formRef) return
      formRef.validate(async valid => {
        if (!valid) return
        const payload = { title: this.chapterForm.title, content: this.chapterForm.content, sort: this.chapterForm.sort || 0, courseId: Number(this.courseId) }
        if (!this.chapterEditingId && this.currentUser && (this.currentUser.id || this.currentUser.userId)) {
          payload.creatorId = this.currentUser.id || this.currentUser.userId
        }
        try {
          this.savingChapter = true
          if (this.chapterEditingId) {
            const res = await updateChapter(this.chapterEditingId, payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '更新失败')
              return
            }
            this.$message.success('更新成功')
          } else {
            const res = await createChapter(payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '创建失败')
              return
            }
            this.$message.success('创建成功')
          }
          this.chapterDialogVisible = false
          await this.fetchChaptersWithSections()
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.savingChapter = false
        }
      })
    },
    async removeChapter(row) {
      try {
        const id = row.id
        const res = await deleteChapter(id)
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.fetchChaptersWithSections()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    async handleChapterPageChange(p) {
      this.chapterPage = p
      await this.fetchChaptersWithSections()
    },

    // 加载章节及其小节（新版本）
    async fetchChaptersWithSections() {
      if (!this.courseId) return
      this.chapterLoading = true
      try {
        console.log('📚 开始加载章节列表，courseId:', this.courseId)

        // 先加载章节列表
        let res
        if (this.isTeacher) {
          // 使用不分页接口
          res = await listChapters(Number(this.courseId), '')
        } else {
          res = await pageNewChapters(this.chapterPage, this.chapterPageSize, Number(this.courseId))
        }

        console.log('📚 章节API响应:', res)

        let chapters = []
        if (res && res.data) {
          // 不分页接口直接返回数组
          chapters = Array.isArray(res.data) ? res.data : (res.data.records || res.data.list || [])
        }

        console.log('📚 解析后的章节数量:', chapters.length, chapters)

        // 为每个章节加载小节
        for (let chapter of chapters) {
          try {
            const studentId = this.isTeacher ? null : (this.currentUser ? this.currentUser.id : null)
            const sectionsRes = await listSectionsByChapter(chapter.id, studentId)
            if (sectionsRes && sectionsRes.data) {
              chapter.sections = Array.isArray(sectionsRes.data) ? sectionsRes.data : []
            } else {
              chapter.sections = []
            }
            console.log(`📚 章节[${chapter.title}]加载了 ${chapter.sections.length} 个小节`)
          } catch (sectionError) {
            console.error(`❌ 加载章节[${chapter.title}]的小节失败:`, sectionError)
            chapter.sections = []
          }
        }

        console.log('📚 最终章节列表:', chapters)
        this.chapterList = chapters
        this.chapterTotal = chapters.length
        this.activeChapters = chapters.map(chapter => chapter.id)

        // 强制刷新视图
        this.$forceUpdate()
      } catch (e) {
        console.error('❌ 加载课程章节失败:', e)
        console.error('错误详情:', e.response || e.message)
        this.$message.error('加载课程章节失败: ' + (e.message || '未知错误'))
      } finally {
        this.chapterLoading = false
      }
    },

    // 小节管理
    openCreateSection(chapter) {
      this.sectionEditingId = null
      this.currentChapterId = chapter.id
      this.sectionForm = {
        title: '',
        description: '',
        durationMinutes: 0,
        sort: 0,
        chapterId: chapter.id,
        status: 1
      }
      this.sectionDialogVisible = true
    },

    openEditSection(section) {
      this.sectionEditingId = section.id
      this.currentChapterId = section.chapterId
      this.sectionForm = {
        title: section.title || '',
        description: section.description || '',
        durationMinutes: section.durationMinutes || 0,
        sort: section.sort || 0,
        chapterId: section.chapterId
      }
      this.sectionDialogVisible = true
    },

    async submitSection() {
      if (!this.sectionForm.title) {
        this.$message.warning('请输入小节标题')
        return
      }

      try {
        this.savingSection = true
        const payload = {
          ...this.sectionForm,
          chapterId: this.currentChapterId
        }
        if (!this.sectionEditingId && this.currentUser && (this.currentUser.id || this.currentUser.userId)) {
          payload.creatorId = this.currentUser.id || this.currentUser.userId
        }

        console.log('📝 提交小节数据:', payload)
        console.log('📝 当前章节ID:', this.currentChapterId)
        console.log('📝 是否编辑模式:', !!this.sectionEditingId)

        if (this.sectionEditingId) {
          const res = await updateSection(this.sectionEditingId, payload)
          console.log('📝 更新小节响应:', res)
          if (res && res.code !== 1 && res.code !== 20000) {
            console.error('❌ 更新小节失败，响应码:', res.code, '错误信息:', res.msg)
            this.$message.error(res.msg || '更新失败')
            return
          }
          this.$message.success('更新成功')
        } else {
          const res = await createSection(payload)
          console.log('📝 创建小节响应:', res)
          if (res && res.code !== 1 && res.code !== 20000) {
            console.error('❌ 创建小节失败，响应码:', res.code, '错误信息:', res.msg)
            this.$message.error(res.msg || '创建失败: ' + (res.msg || '未知错误'))
            return
          }
          this.$message.success('创建成功')
        }

        this.sectionDialogVisible = false
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('❌ 保存小节异常:', e)
        console.error('❌ 错误详情:', e.response || e.message || e)
        this.$message.error('保存失败: ' + (e.message || e.response?.data?.msg || '网络错误'))
      } finally {
        this.savingSection = false
      }
    },

    async removeSection(section) {
      try {
        const res = await deleteSection(section.id)
        if (res && res.code !== 1 && res.code !== 20000) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('删除小节失败', e)
        this.$message.error('删除失败')
      }
    },

    // 资源管理
    openUploadResource(section) {
      this.currentSectionId = section.id
      this.resourceForm = {
        resourceType: 'video',
        resourceName: '',
        description: '',
        sectionId: section.id,
        homeworkId: null
      }
      this.resourceFileList = []
      this.resourceUploadStatus = ''
      this.resourceUploadPercent = 0
      this.resourceUploadingFileName = ''
      this.uploadedResourceUrl = ''
      this.uploadedFileSize = 0
      if (this.isTeacher) {
        this.loadTeacherHomeworks()
      }
      this.uploadResourceVisible = true
    },

    handleHomeworkResourceChange(homeworkId) {
      const selectedHomework = Array.isArray(this.homeworkList)
        ? this.homeworkList.find(item => String(item.id) === String(homeworkId))
        : null
      if (selectedHomework) {
        this.resourceForm.resourceName = this.resourceForm.resourceName || selectedHomework.title || ''
        this.resourceForm.description = this.resourceForm.description || selectedHomework.description || ''
      }
    },

    beforeResourceUpload(file) {
      this.resourceUploadStatus = 'uploading'
      this.resourceUploadPercent = 0
      this.resourceUploadingFileName = file.name
      this.uploadedResourceUrl = ''
      this.uploadedFileSize = 0
      this.resourceOptimizeTaskId = ''
      this.resourceOptimizeProgress = 0
      this.resourceOptimizeMessage = ''
      this.clearResourceOptimizePolling()
      return true
    },

    customResourceUpload({ file }) {
      const xhr = new XMLHttpRequest()
      const formData = new FormData()
      formData.append('file', file)

      const isMp4 = file.name && file.name.toLowerCase().endsWith('.mp4')

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          this.resourceUploadPercent = Math.round((e.loaded / e.total) * 100)
        }
        this.resourceUploadStatus = 'uploading'
      }

      xhr.upload.onloadend = () => {
        if (isMp4 && this.resourceForm.resourceType === 'video') {
          this.resourceUploadStatus = 'optimizing'
        }
      }

      xhr.onload = () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText)
            this.handleResourceUploadSuccess(response, file)
          } catch (e) {
            this.handleResourceUploadError(e, file)
          }
        } else {
          this.handleResourceUploadError(new Error('HTTP ' + xhr.status), file)
        }
      }

      xhr.onerror = () => {
        this.handleResourceUploadError(new Error('网络请求失败'), file)
      }

      xhr.open('POST', this.uploadAction, true)

      const token = localStorage.getItem('token') || sessionStorage.getItem('token') || ''
      if (token) {
        xhr.setRequestHeader('Authorization', token.startsWith('Bearer ') ? token : 'Bearer ' + token)
      }

      xhr.send(formData)
      return xhr
    },

    handleResourceUploadSuccess(response, file) {
      console.log('上传响应:', response)
      if (response && (response.code === 1 || response.code === 20000)) {
        // FileController 返回格式: { code: 1, data: { path: '...', url: '...' } }
        if (response.data) {
          this.resourceUploadingFileName = file.name
          this.uploadedResourceUrl = response.data.url || response.data.path || response.data
          this.uploadedFileSize = file.size || 0
          this.resourceForm.resourceName = this.resourceForm.resourceName || file.name
          if (response.data.taskId) {
            this.resourceOptimizeTaskId = response.data.taskId
            this.resourceOptimizeProgress = Number(response.data.taskProgress || 0)
            this.resourceOptimizeMessage = response.data.taskMessage || '视频优化处理中，请耐心等待...'
            this.resourceUploadStatus = 'optimizing'
            this.syncCurrentResourceOptimizeTask('processing')
            this.persistResourceOptimizeTask()
            this.startResourceOptimizePolling()
          } else {
            this.resourceUploadStatus = 'success'
          }
          this.$message.success('文件上传成功')
        } else {
          this.resourceUploadStatus = 'error'
          this.$message.error('上传失败：未返回文件地址')
        }
      } else {
        this.resourceUploadStatus = 'error'
        this.$message.error(response.msg || '文件上传失败')
      }
    },

    handleResourceUploadError(err, file) {
      console.error('上传失败', err)
      this.resourceUploadStatus = 'error'
      this.resourceUploadingFileName = file && file.name ? file.name : this.resourceUploadingFileName
      this.uploadedResourceUrl = ''
      this.uploadedFileSize = 0
      this.resourceOptimizeTaskId = ''
      this.resourceOptimizeProgress = 0
      this.resourceOptimizeMessage = ''
      this.clearResourceOptimizePolling()
      this.clearPersistedResourceOptimizeTask()
      this.$message.error('文件上传失败')
    },

    startResourceOptimizePolling() {
      this.clearResourceOptimizePolling()
      if (!this.resourceOptimizeTaskId) {
        return
      }
      this.pollResourceOptimizeTask()
      this.resourceOptimizePollTimer = setInterval(() => {
        this.pollResourceOptimizeTask()
      }, 3000)
    },

    clearResourceOptimizePolling() {
      if (this.resourceOptimizePollTimer) {
        clearInterval(this.resourceOptimizePollTimer)
        this.resourceOptimizePollTimer = null
      }
    },

    async pollResourceOptimizeTask() {
      if (!this.resourceOptimizeTaskId) {
        return
      }
      try {
        const res = await getVideoOptimizeTask(this.resourceOptimizeTaskId)
        if (!res || (res.code !== 1 && res.code !== 20000) || !res.data) {
          if (res && (res.msg === '任务不存在或已过期' || res.msg === '任务不存在')) {
            this.resourceUploadStatus = ''
            this.resourceOptimizeMessage = ''
            this.resourceOptimizeProgress = 0
            this.resourceOptimizeTaskId = ''
            this.clearResourceOptimizePolling()
            this.clearPersistedResourceOptimizeTask()
          }
          return
        }
        const task = res.data
        this.resourceOptimizeProgress = Number(task.progress || 0)
        this.resourceOptimizeMessage = task.message || ''

        if (task.status === 'success') {
          this.resourceUploadStatus = 'success'
          this.resourceOptimizeProgress = 100
          this.resourceOptimizeMessage = '视频优化完成'
          this.syncCurrentResourceOptimizeTask('success')
          this.clearResourceOptimizePolling()
          this.clearPersistedResourceOptimizeTask()
        } else if (task.status === 'failed') {
          this.resourceUploadStatus = 'error'
          this.resourceOptimizeMessage = task.message || '视频优化失败'
          this.syncCurrentResourceOptimizeTask('failed')
          this.clearResourceOptimizePolling()
          this.clearPersistedResourceOptimizeTask()
          this.$message.error(this.resourceOptimizeMessage)
        } else {
          this.resourceUploadStatus = 'optimizing'
          this.syncCurrentResourceOptimizeTask('processing')
          this.persistResourceOptimizeTask()
        }
      } catch (e) {
        console.error('查询视频优化任务失败', e)
      }
    },

    syncCurrentResourceOptimizeTask(status) {
      if (!this.currentSectionId || !this.uploadedResourceUrl || !this.resourceOptimizeTaskId) {
        return
      }
      const key = this.buildResourceOptimizeKey(this.currentSectionId, this.uploadedResourceUrl)
      this.$set(this.resourceOptimizeTaskMap, key, {
        taskId: this.resourceOptimizeTaskId,
        sectionId: this.currentSectionId,
        fileUrl: this.uploadedResourceUrl,
        fileName: this.resourceUploadingFileName,
        progress: this.resourceOptimizeProgress,
        message: this.resourceOptimizeMessage,
        status
      })
      this.persistAllResourceOptimizeTasks()
    },

    buildResourceOptimizeKey(sectionId, fileUrl) {
      return `${sectionId || 0}__${fileUrl || ''}`
    },

    getResourceOptimizeState(resource) {
      const key = this.buildResourceOptimizeKey(resource.sectionId, resource.fileUrl)
      const task = this.resourceOptimizeTaskMap[key]
      if (!task) {
        return { visible: false, text: '', status: '' }
      }
      if (task.status === 'success') {
        return { visible: true, text: '优化完成', status: 'success' }
      }
      if (task.status === 'failed') {
        return { visible: true, text: task.message || '优化失败', status: 'failed' }
      }
      return {
        visible: true,
        text: task.message || `处理中 ${task.progress || 0}%`,
        status: 'processing'
      }
    },

    persistAllResourceOptimizeTasks() {
      try {
        localStorage.setItem(`course_resource_optimize_map_${this.courseId}`, JSON.stringify(this.resourceOptimizeTaskMap || {}))
      } catch (e) {}
    },

    restoreAllResourceOptimizeTasks() {
      try {
        const raw = localStorage.getItem(`course_resource_optimize_map_${this.courseId}`)
        this.resourceOptimizeTaskMap = raw ? (JSON.parse(raw) || {}) : {}
      } catch (e) {
        this.resourceOptimizeTaskMap = {}
      }
    },

    persistResourceOptimizeTask() {
      if (!this.resourceOptimizeTaskId) {
        return
      }
      try {
        localStorage.setItem(`course_resource_optimize_${this.courseId}_${this.currentSectionId || 0}`, JSON.stringify({
          taskId: this.resourceOptimizeTaskId,
          fileName: this.resourceUploadingFileName,
          progress: this.resourceOptimizeProgress,
          message: this.resourceOptimizeMessage,
          uploadedResourceUrl: this.uploadedResourceUrl,
          uploadedFileSize: this.uploadedFileSize
        }))
      } catch (e) {}
      this.syncCurrentResourceOptimizeTask(this.resourceUploadStatus === 'error' ? 'failed' : (this.resourceUploadStatus === 'success' ? 'success' : 'processing'))
    },

    restoreResourceOptimizeTask() {
      try {
        const raw = localStorage.getItem(`course_resource_optimize_${this.courseId}_${this.currentSectionId || 0}`)
        if (!raw) {
          return
        }
        const task = JSON.parse(raw)
        if (!task || !task.taskId) {
          return
        }
        this.resourceOptimizeTaskId = task.taskId
        this.resourceUploadingFileName = task.fileName || this.resourceUploadingFileName
        this.resourceOptimizeProgress = Number(task.progress || 0)
        this.resourceOptimizeMessage = task.message || '视频优化处理中，请耐心等待...'
        this.uploadedResourceUrl = task.uploadedResourceUrl || this.uploadedResourceUrl
        this.uploadedFileSize = task.uploadedFileSize || this.uploadedFileSize
        this.resourceUploadStatus = 'optimizing'
        this.syncCurrentResourceOptimizeTask('processing')
        this.startResourceOptimizePolling()
      } catch (e) {}
    },

    clearPersistedResourceOptimizeTask() {
      try {
        localStorage.removeItem(`course_resource_optimize_${this.courseId}_${this.currentSectionId || 0}`)
      } catch (e) {}
    },

    async submitResource() {
      if (!this.resourceForm.resourceName) {
        this.$message.warning('请输入资源名称')
        return
      }
      if (this.resourceForm.resourceType === 'homework' && !this.resourceForm.homeworkId) {
        this.$message.warning('请选择作业')
        return
      }
      if (this.resourceForm.resourceType !== 'homework' && !this.uploadedResourceUrl) {
        this.$message.warning('请先上传文件')
        return
      }

      try {
        this.uploadingResource = true
        const fileUrl = this.resourceForm.resourceType === 'homework'
          ? `homework:${this.resourceForm.homeworkId}`
          : this.uploadedResourceUrl
        const fileSize = this.resourceForm.resourceType === 'homework' ? 0 : this.uploadedFileSize
        const fileExtension = this.resourceForm.resourceType === 'homework' ? 'homework' : this.getFileExtension(this.uploadedResourceUrl)
        const payload = {
          ...this.resourceForm,
          sectionId: this.currentSectionId,
          fileUrl,
          fileSize,
          fileExtension,
          sort: 0
        }

        const res = await addResource(payload)
        if (res && res.code !== 1 && res.code !== 20000) {
          this.$message.error(res.msg || '添加失败')
          return
        }

        this.$message.success('添加成功')
        this.uploadResourceVisible = false
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('添加资源失败', e)
        this.$message.error('添加失败')
      } finally {
        this.uploadingResource = false
      }
    },

    async removeResource(resource) {
      try {
        const res = await deleteResource(resource.id)
        if (res && res.code !== 1 && res.code !== 20000) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('删除资源失败', e)
        this.$message.error('删除失败')
      }
    },

    // 查看资源
    async viewResource(resource) {
      if (resource.resourceType === 'homework') {
        const matched = this.extractHomeworkIdFromResource(resource)
        if (!matched) {
          this.$message.warning('未找到关联作业')
          return
        }
        this.activeMenu = 'homework'
        if (this.isTeacher) {
          await this.loadTeacherHomeworks()
          const row = (this.homeworkList || []).find(item => String(item.id) === String(matched))
          if (row) {
            this.openHwStats(row)
          }
        } else {
          await this.loadStudentHomeworks()
          const row = (this.homeworkList || []).find(item => String(item.id) === String(matched))
          if (row) {
            this.openDoHomework(row)
          }
        }
        return
      }
      if (resource.resourceType === 'video') {
        // 1. 获取当前小节的所有资源（从章节列表中查找）
        let section = null
        for (const chapter of this.chapterList) {
          if (chapter.sections) {
            section = chapter.sections.find(s => s.id === resource.sectionId)
            if (section) break
          }
        }

        if (section && section.resources) {
          this.currentSectionResources = section.resources

          // 2. 检查是否有课件（PPT/文档）
          const hasCourseware = section.resources.some(r =>
            r.resourceType === 'ppt' || r.resourceType === 'document'
          )

          // 3. 如果有课件且是学生，显示提示
          if (hasCourseware && !this.isTeacher && this.showCoursewarePrompt) {
            try {
              await this.$confirm(
                '建议先下载打印课件再开始学习，方便记笔记。是否继续播放视频？',
                '学习提示',
                {
                  confirmButtonText: '继续播放',
                  cancelButtonText: '去下载课件',
                  type: 'info',
                  distinguishCancelAndClose: true
                }
              )
            } catch (action) {
              if (action === 'cancel') {
                // 用户选择下载课件，打开第一个课件
                const courseware = section.resources.find(r =>
                  r.resourceType === 'ppt' || r.resourceType === 'document'
                )
                if (courseware) {
                  window.open(courseware.fileUrl, '_blank')
                }
                return
              } else {
                // 用户取消
                return
              }
            }
          }
        }

        // 4. 设置视频URL和相关信息（转换为HTTPS代理地址）
        this.currentVideoFallbackUrl = this.getResourcePreviewUrl(resource.fileUrl)
        this.currentVideoUrl = this.getResourceHlsPreviewUrl(resource.fileUrl)
        this.currentVideoSourceType = this.currentVideoUrl && this.currentVideoUrl !== this.currentVideoFallbackUrl ? 'hls' : 'mp4'
        this.currentVideoSectionId = resource.sectionId

        // 获取章节信息
        let chapterId = null
        let chapterTitle = ''
        let sectionTitle = section ? section.title : ''
        for (const chapter of this.chapterList) {
          if (chapter.sections && chapter.sections.find(s => s.id === resource.sectionId)) {
            chapterId = chapter.id
            chapterTitle = chapter.title
            break
          }
        }
        this.currentVideoChapterId = chapterId
        this.currentVideoChapterTitle = chapterTitle
        this.currentVideoSectionTitle = sectionTitle

        // 5. 加载视频增强数据（标签和题目）
        await this.loadVideoEnhancementData(resource.sectionId)

        // 6. 初始化观看时间追踪和视频状态
        this.videoWatchStartTime = Date.now()
        this.lastVideoTime = 0 // 重置上一次播放时间
        this.answeredQuestions.clear() // 清空已回答题目记录

        // 7. 记录视频访问日志（仅学生）
        if (!this.isTeacher && this.currentUser && this.currentUser.id) {
          try {
            const logRes = await logVideoVisit({
              studentId: this.currentUser.id,
              courseId: this.courseId,
              chapterId: chapterId,
              sectionId: resource.sectionId,
              resourceId: resource.id,
              videoPosition: 0,
              chapterTitle: chapterTitle,
              sectionTitle: sectionTitle
            })
            if (logRes && logRes.data && logRes.data.id) {
              this.currentVideoVisitLogId = logRes.data.id
            }
          } catch (e) {
            console.error('记录视频访问日志失败', e)
          }
        }

        // 8. 打开视频播放器
        this.videoPlayerVisible = true
        this.initVideoPlayback()
      } else if (resource.resourceType === 'ppt' || this.isPptFile(resource.fileExtension)) {
        this.pptPreviewResourceId = resource.id
        this.pptPreviewResourceName = resource.resourceName
        this.pptPreviewVisible = true
      } else {
        // 其他类型资源，直接打开或下载
        window.open(resource.fileUrl, '_blank')
      }
    },

    downloadResource(resource) {
      if (!resource || !resource.fileUrl) {
        this.$message.warning('资源文件地址为空')
        return
      }
      const url = this.getResourcePreviewUrl(resource.fileUrl)
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      link.download = resource.resourceName || ''
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    // 判断是否为PPT文件
    isPptFile(fileExtension) {
      if (!fileExtension) return false
      const ext = fileExtension.toLowerCase()
      return ext === 'ppt' || ext === 'pptx'
    },

    async closeVideoPlayer() {
      let exitPosition = 0
      let watchDuration = 0
      const logId = this.currentVideoVisitLogId
      const videoEl = this.$refs.videoPlayer

      if (videoEl) {
        exitPosition = Math.floor(videoEl.currentTime || 0)
      }
      if (this.videoWatchStartTime) {
        watchDuration = Math.floor((Date.now() - this.videoWatchStartTime) / 1000)
      }

      if (videoEl) {
        try {
          this.destroyHlsPlayer()
          videoEl.pause()
          videoEl.removeAttribute('src')
          videoEl.load()
        } catch (e) {
          console.error('停止视频加载失败', e)
        }
      }

      // 清空倒计时定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      // 重置数据
      this.currentVideoUrl = ''
      this.currentVideoFallbackUrl = ''
      this.currentVideoSourceType = 'mp4'
      this.currentVideoDuration = 0
      this.isVideoFullscreen = false
      this.videoLoadError = ''
      this.videoMarkers = []
      this.videoQuestions = []
      this.answeredQuestions = new Set()
      this.questionPopVisible = false
      this.currentQuestion = null
      this.studentAnswer = ''
      this.questionResult = null
      this.currentVideoVisitLogId = null
      this.currentVideoChapterId = null
      this.currentVideoChapterTitle = ''
      this.currentVideoSectionTitle = ''
      this.videoWatchStartTime = null

      // 更新视频访问日志的退出信息（仅学生）
      if (logId && !this.isTeacher) {
        try {
          await updateVideoVisitExit({
            logId: logId,
            exitPosition: exitPosition,
            watchDuration: watchDuration
          })
        } catch (e) {
          console.error('更新视频访问日志失败', e)
        }
      }
    },

    startFullscreenMouseTracking() {
      this.videoControlsVisible = true
      this.onFullscreenMouseMove = () => {
        this.videoControlsVisible = true
        if (this.videoControlsTimer) {
          clearTimeout(this.videoControlsTimer)
        }
        this.videoControlsTimer = setTimeout(() => {
          this.videoControlsVisible = false
        }, 3000)
      }
      document.addEventListener('mousemove', this.onFullscreenMouseMove)
      this.videoControlsTimer = setTimeout(() => {
        this.videoControlsVisible = false
      }, 3000)
    },

    stopFullscreenMouseTracking() {
      if (this.onFullscreenMouseMove) {
        document.removeEventListener('mousemove', this.onFullscreenMouseMove)
        this.onFullscreenMouseMove = null
      }
      if (this.videoControlsTimer) {
        clearTimeout(this.videoControlsTimer)
        this.videoControlsTimer = null
      }
    },

    // 视频加载错误处理
    onVideoError(e) {
      console.error('视频加载错误:', e)
      const video = e.target
      console.error('视频错误详情:', {
        src: this.currentVideoUrl,
        errorCode: video && video.error ? video.error.code : null,
        errorMessage: video && video.error ? video.error.message : '',
        networkState: video ? video.networkState : null,
        readyState: video ? video.readyState : null
      })
      let errorMsg = '视频加载失败'
      if (video && video.error) {
        switch (video.error.code) {
          case 1:
            errorMsg = '视频加载被中止'
            break
          case 2:
            errorMsg = '网络错误导致视频下载失败'
            break
          case 3:
            errorMsg = '视频解码失败，可能是编码格式不兼容（如H.265/HEVC）。建议使用H.264编码的MP4文件。'
            break
          case 4:
            errorMsg = '视频格式不支持或文件损坏'
            break
          default:
            errorMsg = '未知视频错误'
        }
      }
      this.videoLoadError = errorMsg
    },

    // 在新标签页打开视频
    openVideoInNewTab() {
      if (this.currentVideoUrl) {
        window.open(this.currentVideoUrl, '_blank')
      }
    },

    onVideoTimeUpdate(e) {
      const currentTime = e.target.currentTime

      // 1. 保存学习进度
      if (!this.isTeacher && this.currentUser && this.currentUser.id) {
        if (Math.floor(currentTime) % 10 === 0) {
          this.saveVideoProgress(currentTime)
        }
      }

      // 2. 检查是否需要弹题（随堂学习模式）
      if (this.videoPlayMode === 'interactive' && !this.isTeacher && this.videoQuestions.length > 0) {
        const currentSecond = Math.floor(currentTime)
        const lastSecond = Math.floor(this.lastVideoTime)

        // 只在时间变化时检查(避免同一秒内重复触发)
        if (currentSecond !== lastSecond) {
          const timeDiff = Math.abs(currentSecond - lastSecond)

          // 检查是否刚好经过某个题目的弹出时间点
          for (const question of this.videoQuestions) {
            if (this.answeredQuestions.has(question.questionId)) {
              continue // 已回答过的题目跳过
            }

            const popTime = question.popTimeSeconds

            // 只在接近弹出时间点时触发(时间跳跃不超过5秒)
            // 这样可以避免拖动进度条大幅跳跃时误触发
            if (lastSecond < popTime && currentSecond >= popTime && timeDiff <= 5) {
              console.log(`触发题目弹出: questionId=${question.questionId}, popTime=${popTime}, lastTime=${lastSecond}, currentTime=${currentSecond}`)
              this.triggerQuestion(question)
              break // 一次只弹一个题目
            }
          }
        }
      }

      // 更新上一次的播放时间
      this.lastVideoTime = currentTime
    },

    async saveVideoProgress(currentTime) {
      try {
        // 计算实际观看时长（从开始观看到现在的时间）
        let actualStudyDuration = 0
        if (this.videoWatchStartTime) {
          actualStudyDuration = Math.floor((Date.now() - this.videoWatchStartTime) / 1000)
        }
        await updateProgress({
          studentId: this.currentUser ? this.currentUser.id : null,
          sectionId: this.currentVideoSectionId,
          courseId: this.courseId,
          videoProgress: Math.floor(currentTime),
          studyDuration: actualStudyDuration
        })
      } catch (e) {
        // 静默失败
        console.error('保存进度失败', e)
      }
    },

    // 打开小节详情
    async openSectionDetail(section) {
      this.currentSection = section
      this.sectionDetailVisible = true
    },

    handleSectionClick(chapter, section, idx) {
      if (this.isSectionLocked(chapter, section, idx)) {
        this.showSectionLimitMessage()
        return
      }
      this.openSectionDetail(section)
    },

    handleResourceClick(chapter, section, idx, resource) {
      if (this.isSectionLocked(chapter, section, idx)) {
        this.showSectionLimitMessage()
        return
      }
      this.viewResource(resource)
    },

    handleCurrentSectionResourceClick(resource) {
      if (!this.currentSection) {
        this.viewResource(resource)
        return
      }
      const location = this.findSectionLocation(this.currentSection)
      if (location && this.isSectionLocked(location.chapter, location.section, location.idx)) {
        this.showSectionLimitMessage()
        return
      }
      this.viewResource(resource)
    },

    getSectionRouteLimit() {
      const limit = Number(this.$route?.query?.limit)
      return Number.isFinite(limit) && limit > 0 ? limit : 0
    },

    findSectionLocation(section) {
      const chapters = Array.isArray(this.chapterList) ? this.chapterList : []
      for (const chapter of chapters) {
        const sections = Array.isArray(chapter && chapter.sections) ? chapter.sections : []
        for (let idx = 0; idx < sections.length; idx++) {
          const currentSection = sections[idx]
          if (currentSection === section) {
            return { chapter, section: currentSection, idx }
          }
          if (currentSection && section && currentSection.id && section.id && currentSection.id === section.id) {
            return { chapter, section: currentSection, idx }
          }
        }
      }
      return null
    },

    getSectionGlobalIndex(chapter, section, idx) {
      let current = 0
      const chapters = Array.isArray(this.chapterList) ? this.chapterList : []
      for (const item of chapters) {
        const sections = Array.isArray(item && item.sections) ? item.sections : []
        for (let i = 0; i < sections.length; i++) {
          const currentSection = sections[i]
          if (item === chapter && currentSection === section) {
            return current
          }
          if (item && chapter && item.id === chapter.id && currentSection && section && currentSection.id === section.id) {
            return current
          }
          if (item && chapter && item.id === chapter.id && i === idx) {
            return current
          }
          current += 1
        }
      }
      return current
    },

    isSectionLocked(chapter, section, idx) {
      if (this.isTeacher) return false
      const limit = this.sectionAccessLimit > 0 ? this.sectionAccessLimit : this.getSectionRouteLimit()
      if (limit <= 0) return false
      return this.getSectionGlobalIndex(chapter, section, idx) >= limit
    },

    showSectionLimitMessage() {
      const limit = this.sectionAccessLimit > 0 ? this.sectionAccessLimit : this.getSectionRouteLimit()
      const text = limit > 0
        ? `当前仅可查看前${limit}个小节，开通会员后即可查看全部课程资料`
        : '开通会员后即可查看全部课程资料'
      this.$message.warning(text)
    },

    // 标记小节为已完成
    async markSectionComplete() {
      try {
        await markAsCompleted(this.currentUser ? this.currentUser.id : null, this.currentSection.id)
        this.$message.success('已标记为完成')
        this.sectionDetailVisible = false
        await this.fetchChaptersWithSections()
      } catch (e) {
        console.error('标记失败', e)
        this.$message.error('标记失败')
      }
    },

    // 工具方法
    getResourceIcon(type) {
      const iconMap = {
        video: 'el-icon-video-play',
        document: 'el-icon-document',
        ppt: 'el-icon-document',
        homework: 'el-icon-edit-outline',
        other: 'el-icon-paperclip'
      }
      return iconMap[type] || 'el-icon-paperclip'
    },

    getResourceColor(type) {
      const colorMap = {
        video: '#67C23A',
        document: '#409EFF',
        ppt: '#E6A23C',
        homework: '#F56C6C',
        other: '#909399'
      }
      return colorMap[type] || '#909399'
    },

    extractHomeworkIdFromResource(resource) {
      const fileUrl = String(resource && resource.fileUrl ? resource.fileUrl : '')
      if (fileUrl.startsWith('homework:')) {
        return fileUrl.replace('homework:', '').trim()
      }
      return ''
    },

    formatFileSize(bytes) {
      if (!bytes) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
    },

    getFileExtension(url) {
      if (!url) return ''
      const parts = url.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },
    async fetchKnowledgeTree() {
      this.knowledgeLoading = true
      try {
        const resp = await listAllGeneralKnowledge()
        const list = (resp && resp.data) || resp || []
        const tree = this.buildKnowledgeTree(Array.isArray(list) ? list : [])
        this.knowledgeTree = tree.nodes
        this.knowledgeExpandedKeys = tree.expandIds
      } catch (e) {
        this.$message.error('加载课程知识点失败')
      } finally {
        this.knowledgeLoading = false
      }
    },
    buildKnowledgeTree(items) {
      const byId = {}
      const roots = []
      const expandIds = []
      items.forEach(it => {
        const id = it.id || it.ID
        const pid = it.parentId || it.parent_id || 0
        const label = it.content || it.name || ''
        if (id == null) return
        byId[id] = byId[id] || { id, label, children: [] }
        byId[id].label = label
        byId[id].pid = pid
      })
      Object.keys(byId).forEach(k => {
        const n = byId[k]
        if (!n) return
        if (n.pid && byId[n.pid]) {
          byId[n.pid].children.push(n)
        } else {
          roots.push(n)
        }
      })
      // 展开顶层
      roots.forEach(r => expandIds.push(r.id))
      // 排序：父按 label，子按 label
      const sortFn = (a, b) => String(a.label || '').localeCompare(String(b.label || ''))
      const sortTree = arr => {
        arr.sort(sortFn)
        arr.forEach(ch => ch.children && ch.children.length && sortTree(ch.children))
      }
      sortTree(roots)
      return { nodes: roots, expandIds }
    },
    knowledgeFilterMethod(value, data) {
      if (!value) return true
      return (data.label || '').toLowerCase().includes(String(value).trim().toLowerCase())
    },
    filterKnowledge(nodes, q) {
      if (!q) return nodes
      const kw = String(q).trim().toLowerCase()
      const dfs = arr => {
        const out = []
        arr.forEach(n => {
          const label = String(n.label || '').toLowerCase()
          const children = n.children && n.children.length ? dfs(n.children) : []
          if (label.includes(kw) || children.length) {
            out.push({ ...n, children })
          }
        })
        return out
      }
      return dfs(nodes)
    },
    flattenLabels(node) {
      const list = []
      const walk = n => {
        if (n.children && n.children.length) {
          n.children.forEach(c => {
            list.push(c.label)
            walk(c)
          })
        }
      }
      walk(node)
      return list
    },
    async fetchClasses() {
      if (!this.courseId) return
      this.classLoading = true
      try {
        const res = await listClasses(Number(this.courseId))
        const arr = (res && res.data) || res || []
        this.classList = Array.isArray(arr) ? arr : []
      } catch (e) {
        this.$message.error('加载班级失败')
      } finally {
        this.classLoading = false
      }
    },
    openCreateClass() {
      this.classEditingId = null
      this.classForm = { name: '', inviteCode: '', description: '' }
      this.classDialogVisible = true
    },
    openEditClass(row) {
      this.classEditingId = row.id
      this.classForm = { name: row.name || '', inviteCode: row.inviteCode || '', description: row.description || '' }
      this.classDialogVisible = true
    },
    async submitClass() {
      const form = this.$refs.classForm
      if (!form) return
      form.validate(async valid => {
        if (!valid) return
        const payload = { ...this.classForm, courseId: Number(this.courseId) }
        try {
          this.classSaving = true
          if (this.classEditingId) {
            const res = await updateClass(this.classEditingId, payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '更新失败')
              return
            }
            this.$message.success('更新成功')
          } else {
            const res = await createClass(payload)
            if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
              this.$message.error(res.msg || '创建失败')
              return
            }
            this.$message.success('创建成功')
          }
          this.classDialogVisible = false
          await this.fetchClasses()
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.classSaving = false
        }
      })
    },
    async removeClass(row) {
      try {
        const res = await deleteClass(row.id)
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        this.fetchClasses()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    openAddStudent(row) {
      this.addStudentTargetId = row.id
      this.addStudentVisible = true
      this.addStudentKeyword = ''
      this.addStudentCandidates = []
      this.addStudentCandidatePage = 1
      this.addStudentCandidateTotal = 0
      this.addStudentJoinedMap = {}
      this.fetchStudentCandidates(1)
    },
    async fetchStudentCandidates(pageNum) {
      if (!this.addStudentTargetId) return
      const page = pageNum || this.addStudentCandidatePage || 1
      this.addStudentCandidatesLoading = true
      try {
        const memberRes = await listStudents(this.addStudentTargetId)
        const successCodes = new Set([1, 20000, 0, 200])
        const members = (memberRes && typeof memberRes.code !== 'undefined')
          ? (successCodes.has(memberRes.code) ? (memberRes.data || []) : [])
          : (memberRes && memberRes.data ? memberRes.data : [])
        const joinedMap = {}
        ;(Array.isArray(members) ? members : []).forEach(m => {
          const id = Number(m && (m.id ?? m.userId))
          if (!isNaN(id)) joinedMap[id] = true
        })
        this.addStudentJoinedMap = joinedMap

        const params = {
          pageNum: page,
          pageSize: this.addStudentCandidatePageSize,
          username: this.addStudentKeyword ? String(this.addStudentKeyword).trim() : undefined
        }
        const res = await pageStudentCandidates(params)
        const data = res && res.data ? res.data : null
        const records = data && Array.isArray(data.records) ? data.records : []
        this.addStudentCandidates = records
        this.addStudentCandidateTotal = data && typeof data.total !== 'undefined' ? Number(data.total) : records.length
        this.addStudentCandidatePage = page
      } catch (e) {
        console.error(e)
        this.$message.error('加载学生列表失败')
      } finally {
        this.addStudentCandidatesLoading = false
      }
    },
    handleCandidatePageChange(page) {
      this.fetchStudentCandidates(page)
    },
    resetStudentCandidates() {
      this.addStudentKeyword = ''
      this.fetchStudentCandidates(1)
    },
    async pullStudentToClass(row) {
      if (!this.addStudentTargetId) return
      const username = row && row.userName
      if (!username) {
        this.$message.warning('该用户缺少username')
        return
      }
      try {
        this.addStudentLoading = true
        const res = await addStudentByUsername(this.addStudentTargetId, String(username).trim())
        const successCodes = new Set([1, 20000])
        if (res && typeof res.code !== 'undefined' && !successCodes.has(res.code)) {
          this.$message.error(res.msg || '拉取失败')
          return
        }
        this.$message.success('已加入班级')
        this.$set(this.addStudentJoinedMap, Number(row.id), true)
        await this.fetchMembersIfOpen(this.addStudentTargetId)
      } catch (e) {
        console.error(e)
        this.$message.error('拉取失败')
      } finally {
        this.addStudentLoading = false
      }
    },
    async fetchMembersIfOpen(classId) {
      if (this.membersVisible && this.membersClassId && Number(this.membersClassId) === Number(classId)) {
        await this.fetchMembers()
      }
    },
    async studentJoinByInvite() {
      if (!this.joinInviteCode) {
        this.$message.warning('请输入邀请码')
        return
      }
      try {
        this.joinLoading = true
        const res = await joinByInviteCode(String(this.joinInviteCode).trim())
        if (res && typeof res.code !== 'undefined' && !(res.code === 1 || res.code === 20000)) {
          this.$message.error(res.msg || '加入失败')
          return
        }
        this.$message.success('加入成功')
      } catch (e) {
        this.$message.error('加入失败')
      } finally {
        this.joinLoading = false
      }
    },
    openMembers(row) {
      this.membersClassId = row.id
      this.membersVisible = true
      this.fetchMembers()
    },
    async fetchMembers() {
      if (!this.membersClassId) return
      this.membersLoading = true
      try {
        const res = await listStudents(this.membersClassId)
        // 兼容多种返回结构
        const successCodes = new Set([1, 20000, 0, 200])
        if (typeof res?.code !== 'undefined' && !successCodes.has(res.code)) {
          this.$message.error(res.msg || '加载成员失败')
        }
        const data = (res && res.data !== undefined) ? res.data : res
        this.membersList = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : (Array.isArray(res?.records) ? res.records : []))
      } catch (e) {
        this.$message.error('加载成员失败')
      } finally {
        this.membersLoading = false
      }
    },
    async refreshMembers() {
      await this.fetchMembers()
    },
    async confirmRemoveMember(row) {
      if (!this.membersClassId || !row?.id) return
      try {
        const res = await removeStudent(this.membersClassId, row.id)
        // 仅将 1 或 20000 视为成功，0 视为失败
        const successCodes = new Set([1, 20000])
        if (typeof res?.code !== 'undefined' && !successCodes.has(res.code)) {
          this.$message.error(res.msg || '移除失败')
          return
        }
        this.$message.success('已移除')
        this.fetchMembers()
      } catch (e) {
        this.$message.error('移除失败')
      }
    },
    // ===== 题库管理 Methods =====
    async loadQbTree() {
      this.qbLoading = true
      try {
        const res = await qbFolderTree()
        this.qbTree = (res && res.data) ? res.data : []
      } catch (e) {
        this.$message.error('加载文件夹失败')
      } finally {
        this.qbLoading = false
      }
    },
    onSelectFolder(node) {
      this.qbSelectedFolder = node
      this.loadQbFiles()
    },
    async loadQbFiles() {
      if (!this.qbSelectedFolder) return
      this.qbFilesLoading = true
      try {
        const res = await qbListFiles(this.qbSelectedFolder.id)
        this.qbFiles = (res && res.data) ? res.data : []
      } catch (e) {
        this.$message.error('加载文件失败')
      } finally {
        this.qbFilesLoading = false
      }
    },
    promptCreateFolder() {
      this.$prompt('请输入文件夹名称', '新建文件夹', { inputValidator: v => !!(v && v.trim()), inputErrorMessage: '名称不能为空' })
        .then(async ({ value }) => {
          const parentId = this.qbSelectedFolder ? this.qbSelectedFolder.id : null
          const res = await qbCreateFolder(parentId, value.trim())
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) return this.$message.error(res.msg || '创建失败')
          this.$message.success('已创建')
          await this.loadQbTree()
        }).catch(() => {})
    },
    promptRenameFolder() {
      if (!this.qbSelectedFolder) return
      this.$prompt('请输入新名称', '重命名', { inputValue: this.qbSelectedFolder.name, inputValidator: v => !!(v && v.trim()), inputErrorMessage: '名称不能为空' })
        .then(async ({ value }) => {
          const res = await qbRenameFolder(this.qbSelectedFolder.id, value.trim())
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) return this.$message.error(res.msg || '重命名失败')
          this.$message.success('已重命名')
          await this.loadQbTree()
        }).catch(() => {})
    },
    confirmDeleteFolder() {
      if (!this.qbSelectedFolder) return
      this.$confirm('将删除该文件夹及其子项，确定继续？', '提示', { type: 'warning' })
        .then(async () => {
          const res = await qbDeleteFolder(this.qbSelectedFolder.id)
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) return this.$message.error(res.msg || '删除失败')
          this.$message.success('已删除')
          this.qbSelectedFolder = null
          await this.loadQbTree()
          this.qbFiles = []
        }).catch(() => {})
    },
    // 行内图标点击 -> 使用弹窗输入的方式
    promptCreateSubFolder(data) {
      // 设置选中后沿用已有 promptCreateFolder 逻辑
      if (data && data.id) this.qbSelectedFolder = data
      this.promptCreateFolder()
    },
    renameFolder(data) {
      if (data && data.id) this.qbSelectedFolder = data
      this.promptRenameFolder()
    },
    deleteFolder(data) {
      if (data && data.id) this.qbSelectedFolder = data
      this.confirmDeleteFolder()
    },
    async removeQbFile(row) {
      try {
        const res = await qbDeleteFile(row.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) return this.$message.error(res.msg || '删除失败')
        this.$message.success('已删除')
        this.loadQbFiles()
      } catch (e) {
        this.$message.error('删除失败')
      }
    },
    onQbUploadSuccess() {
      this.$message.success('上传成功')
      this.qbUploadTitle = ''
      this.loadQbFiles()
    },
    onQbUploadError() {
      this.$message.error('上传失败')
    },
    promptMoveSelectedFile() {
      if (!this.qbCurrentRow) return
      this.$prompt('输入目标文件夹ID', '移动文件', { inputValidator: v => !!v, inputErrorMessage: '请输入ID' })
        .then(async ({ value }) => {
          const res = await qbMoveFile(this.qbCurrentRow.id, Number(value))
          const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
          if (!ok) return this.$message.error(res.msg || '移动失败')
          this.$message.success('已移动')
          this.loadQbFiles()
        }).catch(() => {})
    },
    allowQbDrop(draggingNode, dropNode, type) {
      return this.isTeacher && type === 'inner'
    },
    async onQbNodeDrop(draggingNode, dropNode, type) {
      try {
        if (!this.isTeacher || type !== 'inner') return
        const dragId = draggingNode && draggingNode.data && draggingNode.data.id
        const targetId = dropNode && dropNode.data && dropNode.data.id
        if (!dragId || !targetId || dragId === targetId) return
        const res = await qbMoveFolder(dragId, targetId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) return this.$message.error(res.msg || '移动失败')
        this.$message.success('已移动')
        await this.loadQbTree()
      } catch (e) {
        this.$message.error('移动失败')
      }
    },
    async publishQbFileToCourse(row) {
      try {
        if (!this.courseId) return this.$message.error('缺少课程ID')
        const res = await qbPublishToCourse(row.id, this.courseId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) return this.$message.error(res.msg || '发布失败')
        this.$message.success('已发布到课程资料')
      } catch (e) {
        this.$message.error('发布失败')
      }
    },
    async shareQbFileToCourse(row) {
      try {
        if (!this.courseId) return this.$message.error('缺少课程ID')
        const res = await qbShareFile(row.id, this.courseId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) return this.$message.error(res.msg || '共享失败')
        this.$message.success('已共享到本课程（学生在我的题库可见）')
      } catch (e) {
        this.$message.error('共享失败')
      }
    },
    async fetchSharedQbFiles() {
      try {
        if (!this.courseId) return
        this.sharedQbLoading = true
        const res = await qbShareList(this.courseId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) this.$message.error(res.msg || '加载共享题库失败')
        const data = (res && res.data !== undefined) ? res.data : res
        this.sharedQbFiles = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])
      } catch (e) {
        this.$message.error('加载共享题库失败')
      } finally {
        this.sharedQbLoading = false
      }
    },

    // ===== 讨论相关 Methods =====
    async fetchTopics() {
      if (!this.courseId) return
      this.discussionLoading = true
      try {
        const res = await listTopics({
          courseId: this.courseId,
          pageNum: this.topicPageNum,
          pageSize: this.topicPageSize
        })
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '加载话题失败')
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        this.topicList = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])
        this.topicTotal = data?.total || this.topicList.length
      } catch (e) {
        this.$message.error('加载话题失败')
      } finally {
        this.discussionLoading = false
      }
    },

    handleTopicPageChange(page) {
      this.topicPageNum = page
      this.fetchTopics()
    },

    handleTopicSizeChange(size) {
      this.topicPageSize = size
      this.topicPageNum = 1
      this.fetchTopics()
    },

    openCreateTopicDialog() {
      this.topicEditingId = null
      this.topicForm = {
        title: '',
        content: ''
      }
      this.topicDialogVisible = true
    },

    editTopic(topic) {
      this.topicEditingId = topic.id
      this.topicForm = {
        title: topic.title || '',
        content: topic.content || ''
      }
      this.topicDialogVisible = true
    },

    closeTopicDialog() {
      this.topicDialogVisible = false
      this.topicEditingId = null
      this.topicForm = {
        title: '',
        content: ''
      }
    },

    async submitTopic() {
      if (!this.topicForm.title || !this.topicForm.title.trim()) {
        this.$message.warning('请输入话题标题')
        return
      }
      this.savingTopic = true
      try {
        const data = {
          courseId: this.courseId,
          title: this.topicForm.title.trim(),
          content: this.topicForm.content?.trim() || ''
        }
        const res = this.topicEditingId
          ? await updateTopic(this.topicEditingId, data)
          : await createTopic(data)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '保存失败')
          return
        }
        this.$message.success(this.topicEditingId ? '编辑成功' : '发布成功')
        this.closeTopicDialog()
        await this.fetchTopics()
      } catch (e) {
        this.$message.error('保存失败：' + (e.message || ''))
      } finally {
        this.savingTopic = false
      }
    },

    async togglePinTopic(topic) {
      try {
        const res = await pinTopic(topic.id, topic.isPinned ? 0 : 1)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '操作失败')
          return
        }
        this.$message.success(topic.isPinned ? '已取消置顶' : '已置顶')
        await this.fetchTopics()
      } catch (e) {
        this.$message.error('操作失败：' + (e.message || ''))
      }
    },

    // 判断话题是否是当前用户创建的
    isMyTopic(topic) {
      if (!this.currentUser || !topic) return false
      const userId = this.currentUser.id || this.currentUser.userId
      // 支持多种ID字段
      return topic.creatorId === userId ||
             topic.userId === userId ||
             topic.createBy === userId ||
             String(topic.creatorId) === String(userId)
    },

    async removeTopicConfirm(topicId) {
      if (!topicId) {
        this.$message.error('话题ID无效')
        return
      }
      try {
        console.log('删除话题ID:', topicId)
        const res = await deleteTopic(topicId)
        console.log('删除话题响应:', res)

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.fetchTopics()
      } catch (e) {
        console.error('删除话题错误:', e)
        this.$message.error('删除失败：' + (e.message || ''))
      }
    },

    async viewTopicDetail(topic) {
      this.currentTopic = topic
      this.topicDetailVisible = true
      this.loadingTopicDetail = true
      this.topicLiked = false

      try {
        // 加载话题详情
        const res = await getTopicDetail(topic.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (ok) {
          const data = (res && res.data !== undefined) ? res.data : res
          this.currentTopic = data || topic
        }

        // 加载评论列表
        await this.loadComments(topic.id)

        // 加载点赞状态
        await this.loadLikeStatus()
      } catch (e) {
        console.error('加载话题详情失败', e)
      } finally {
        this.loadingTopicDetail = false
      }
    },

    async loadComments(topicId) {
      this.loadingComments = true
      try {
        const res = await listComments({
          topicId: topicId
        })
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '加载评论失败')
          return
        }
        const data = (res && res.data !== undefined) ? res.data : res
        this.commentList = Array.isArray(data) ? data : (Array.isArray(data?.records) ? data.records : [])
      } catch (e) {
        console.error('加载评论失败', e)
      } finally {
        this.loadingComments = false
      }
    },

    async loadLikeStatus() {
      if (!this.currentTopic || !this.currentUser) return
      try {
        const topicIds = [this.currentTopic.id]
        const commentIds = this.commentList.map(c => c.id)

        const res = await getUserLikeStatus({
          topicIds: topicIds.join(','),
          commentIds: commentIds.join(',')
        })

        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (ok) {
          const data = (res && res.data !== undefined) ? res.data : res
          // 设置话题点赞状态
          this.topicLiked = data?.topicLikes?.includes(this.currentTopic.id) || false
          // 设置评论点赞状态
          if (data?.commentLikes && Array.isArray(data.commentLikes)) {
            this.commentList.forEach(comment => {
              comment.liked = data.commentLikes.includes(comment.id)
            })
          }
        }
      } catch (e) {
        console.error('加载点赞状态失败', e)
      }
    },

    async toggleTopicLike() {
      if (!this.currentTopic) return
      try {
        const res = await likeTopicToggle(this.currentTopic.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '操作失败')
          return
        }
        this.topicLiked = !this.topicLiked
        this.currentTopic.likeCount = (this.currentTopic.likeCount || 0) + (this.topicLiked ? 1 : -1)
        this.$message.success(this.topicLiked ? '点赞成功' : '已取消点赞')
      } catch (e) {
        this.$message.error('操作失败：' + (e.message || ''))
      }
    },

    async toggleCommentLike(comment) {
      try {
        const res = await likeCommentToggle(comment.id)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '操作失败')
          return
        }
        comment.liked = !comment.liked
        comment.likeCount = (comment.likeCount || 0) + (comment.liked ? 1 : -1)
        this.$message.success(comment.liked ? '点赞成功' : '已取消点赞')
      } catch (e) {
        this.$message.error('操作失败：' + (e.message || ''))
      }
    },

    async postComment() {
      if (!this.newComment || !this.newComment.trim()) {
        this.$message.warning('请输入评论内容')
        return
      }
      if (!this.currentTopic) return

      this.postingComment = true
      try {
        const res = await createComment({
          topicId: this.currentTopic.id,
          courseId: this.courseId,
          content: this.newComment.trim()
        })
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '发表失败')
          return
        }
        this.$message.success('发表成功')
        this.newComment = ''
        await this.loadComments(this.currentTopic.id)
        // 更新话题评论数
        this.currentTopic.commentCount = (this.currentTopic.commentCount || 0) + 1
      } catch (e) {
        this.$message.error('发表失败：' + (e.message || ''))
      } finally {
        this.postingComment = false
      }
    },

    // 开始回复评论
    startReply(comment) {
      this.replyingTo = comment
      this.replyContent = ''
    },

    // 取消回复
    cancelReply() {
      this.replyingTo = null
      this.replyContent = ''
    },

    // 发表回复
    async postReply() {
      if (!this.replyContent || !this.replyContent.trim()) {
        this.$message.warning('请输入回复内容')
        return
      }
      if (!this.currentTopic || !this.replyingTo) return

      this.postingComment = true
      try {
        // 计算parentId：如果回复的是一级评论，parentId就是该评论的id；如果回复的是子评论，parentId保持不变
        const parentId = (this.replyingTo.parentId && this.replyingTo.parentId !== 0)
          ? this.replyingTo.parentId
          : this.replyingTo.id

        const res = await createComment({
          topicId: this.currentTopic.id,
          courseId: this.courseId,
          content: this.replyContent.trim(),
          parentId: parentId, // 父评论ID
          replyToId: this.replyingTo.id, // 回复的目标评论ID
          replyToName: this.replyingTo.userName // 回复的用户名
        })
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '发表失败')
          return
        }
        this.$message.success('回复成功')
        this.cancelReply()
        await this.loadComments(this.currentTopic.id)
        // 更新话题评论数
        this.currentTopic.commentCount = (this.currentTopic.commentCount || 0) + 1
      } catch (e) {
        this.$message.error('发表失败：' + (e.message || ''))
      } finally {
        this.postingComment = false
      }
    },

    async deleteCommentConfirm(commentId) {
      try {
        const res = await deleteComment(commentId)
        const ok = !res || typeof res.code === 'undefined' || res.code === 1 || res.code === 20000
        if (!ok) {
          this.$message.error(res.msg || '删除失败')
          return
        }
        this.$message.success('删除成功')
        await this.loadComments(this.currentTopic.id)
        // 更新话题评论数
        if (this.currentTopic) {
          this.currentTopic.commentCount = Math.max(0, (this.currentTopic.commentCount || 0) - 1)
        }
      } catch (e) {
        this.$message.error('删除失败：' + (e.message || ''))
      }
    },

    closeTopicDetail() {
      this.topicDetailVisible = false
      this.currentTopic = null
      this.commentList = []
      this.newComment = ''
      this.topicLiked = false
      this.replyingTo = null
      this.replyContent = ''
      // 刷新话题列表（更新评论数等）
      this.fetchTopics()
    },

    // ========== 学情分析方法 ==========
    async loadLearningAnalysis() {
      if (!this.courseId) return
      this.analysisLoading = true

      try {
        // 模拟数据（实际项目中从API获取）
        await new Promise(resolve => setTimeout(resolve, 500))

        // 获取所有班级的学生
        const classRes = await listClasses(this.courseId)
        const classes = Array.isArray(classRes?.data) ? classRes.data : []

        // 获取所有学生
        let allStudents = []
        for (const cls of classes) {
          const studentsRes = await listStudents(cls.id)
          const students = Array.isArray(studentsRes?.data) ? studentsRes.data : []
          allStudents = allStudents.concat(students.map(s => ({
            ...s,
            className: cls.name
          })))
        }

        // 获取作业列表
        const homeworkRes = await teacherHomeworkList(this.courseId)
        const homeworkList = Array.isArray(homeworkRes?.data) ? homeworkRes.data : []

        // 获取讨论话题
        console.log('正在获取讨论话题，courseId:', this.courseId)
        const topicsRes = await listTopics({ courseId: this.courseId, pageNum: 1, pageSize: 1000 })
        console.log('讨论话题API返回:', topicsRes)

        // 检查多种可能的数据结构
        let topics = []
        if (Array.isArray(topicsRes?.data?.records)) {
          // 分页格式：data.records
          topics = topicsRes.data.records
        } else if (Array.isArray(topicsRes?.data?.rows)) {
          // 分页格式：data.rows
          topics = topicsRes.data.rows
        } else if (Array.isArray(topicsRes?.data?.list)) {
          // 分页格式：data.list
          topics = topicsRes.data.list
        } else if (Array.isArray(topicsRes?.data)) {
          // 直接数组格式
          topics = topicsRes.data
        } else if (Array.isArray(topicsRes)) {
          // 直接返回数组
          topics = topicsRes
        }

        console.log('解析后的话题列表:', topics)
        console.log('话题数量:', topics.length)
        if (topics.length > 0) {
          console.log('第一个话题示例:', topics[0])
        }

        // 计算每个学生的学情
        const studentAnalysisList = []
        let totalHomeworkCompleted = 0
        let totalHomeworkAssignments = allStudents.length * homeworkList.length
        let totalScore = 0
        let totalScoreCount = 0
        let studentsWithDiscussion = 0

        console.log('========== 老师端学情统计开始 ==========')
        console.log('学生总数:', allStudents.length)
        console.log('作业总数:', homeworkList.length)

        for (const student of allStudents) {
          console.log(`\n--- 统计学生【${student.realName || student.username}】---`)
          console.log('学生信息:', {
            id: student.id,
            username: student.username,
            realName: student.realName,
            userId: student.userId
          })

          // 获取学生作业统计
          let homeworkCompleted = 0
          let homeworkTotal = homeworkList.length
          let homeworkScoreSum = 0
          let homeworkScoreCount = 0
          let correctAnswers = 0
          let totalAnswers = 0

          for (const homework of homeworkList) {
            const statsRes = await getHomeworkStats(homework.id)
            const stats = statsRes?.data

            // 支持 rows 或 studentRows 字段
            const studentRows = stats?.rows || stats?.studentRows || []

            console.log(`  作业【${homework.title}】统计:`, {
              有数据: !!stats,
              有学生行: studentRows.length > 0,
              学生行数: studentRows.length
            })

            // 打印完整的stats对象结构
            if (!stats) {
              console.warn(`  ⚠️ 作业统计数据为空！statsRes:`, statsRes)
            } else if (studentRows.length === 0) {
              console.warn(`  ⚠️ 学生行是空数组！这个作业可能没有学生提交`)
              console.log(`  stats的所有键:`, Object.keys(stats))
            } else {
              console.log(`  ✓ 有${studentRows.length}条学生记录`)
              console.log(`  第一条记录结构:`, studentRows[0])
            }

            if (stats && studentRows.length > 0) {
              // 使用作业统计中的 studentId / username 与当前学生做精确匹配
              const studentRow = studentRows.find(row => {
                const same = (a, b) => a != null && b != null && String(a) === String(b)
                const match =
                  same(row.studentId, student.id) ||
                  same(row.username, student.username) ||
                  same(row.username, student.realName)

                if (match) {
                  console.log('  匹配到学生作业行:', {
                    rowStudentId: row.studentId,
                    rowUsername: row.username,
                    rowStatus: row.status,
                    rowSubmitTime: row.submitTime,
                    stuId: student.id,
                    stuUsername: student.username,
                    stuRealName: student.realName
                  })
                }
                return match
              })

              // 判断是否已提交：优先根据 status === '已提交'，兼容 submitTime 非空
              const isSubmitted = !!(studentRow && (
                (studentRow.status && String(studentRow.status).indexOf('已提交') !== -1) ||
                studentRow.submitTime
              ))

              console.log(`  匹配结果:`, {
                找到: !!studentRow,
                已提交: isSubmitted,
                判断依据: studentRow ? (studentRow.status || studentRow.submitTime ? (studentRow.status || 'submitTime存在') : '未提交') : '未找到',
                studentRow: studentRow ? {
                  studentId: studentRow.studentId,
                  username: studentRow.username,
                  status: studentRow.status,
                  submitTime: studentRow.submitTime
                } : null
              })

              if (isSubmitted) {
                homeworkCompleted++
                totalHomeworkCompleted++

                console.log(`    ✓ 确认已提交，开始解析得分...`)

                // 解析得分信息
                if (studentRow.answerContent) {
                  console.log(`    answerContent存在，类型:`, typeof studentRow.answerContent)
                  console.log(`    answerContent内容:`, studentRow.answerContent)

                  try {
                    // 如果已经是对象，直接使用；如果是字符串，才解析
                    const content = typeof studentRow.answerContent === 'string'
                      ? JSON.parse(studentRow.answerContent)
                      : studentRow.answerContent

                    console.log(`    解析后的content:`, content)
                    console.log(`    content的所有键:`, Object.keys(content))

                    if (content.score !== undefined) {
                      console.log(`    ✓ 找到score字段: ${content.score}`)
                      homeworkScoreSum += content.score
                      homeworkScoreCount++
                      totalScore += content.score
                      totalScoreCount++
                    } else {
                      console.warn(`    ⚠️ 没有score字段！可能的得分字段:`, {
                        score: content.score,
                        totalScore: content.totalScore,
                        finalScore: content.finalScore
                      })
                    }

                    if (content.correct !== undefined && content.total !== undefined) {
                      console.log(`    ✓ 找到correct/total字段: ${content.correct}/${content.total}`)
                      correctAnswers += content.correct
                      totalAnswers += content.total
                    } else {
                      console.warn(`    ⚠️ 没有correct/total字段！`)
                    }
                  } catch (e) {
                    console.error('解析学生作业得分失败:', e)
                    console.log('原始answerContent:', studentRow.answerContent)
                  }
                } else {
                  console.warn(`    ⚠️ answerContent为空或不存在`)
                }
              }
            }
          }

          // 获取学生讨论参与情况
          console.log(`\n  讨论统计开始...`)
          console.log(`  话题总数: ${topics.length}`)

          if (topics.length === 0) {
            console.warn(`  ⚠️ 课程没有讨论话题！请检查：`)
            console.warn(`     1. 是否在"讨论区"创建了话题？`)
            console.warn(`     2. 讨论话题的courseId是否正确？`)
          } else {
            console.log(`  话题列表的第一个话题:`, topics[0])
            console.log(`  话题ID字段示例:`, {
              creatorId: topics[0].creatorId,
              userId: topics[0].userId,
              createBy: topics[0].createBy
            })
          }

          // 按ID和姓名多种方式匹配当前学生创建的话题：
          // 1）优先使用 creatorName 与学生的 username/realName 匹配
          // 2）再尝试 creatorId 与学生ID 匹配（以防后端以后统一ID）
          const studentTopics = topics.filter(t => {
            const same = (a, b) => a != null && b != null && String(a) === String(b)
            const match =
              same(t.creatorName, student.username) ||
              same(t.creatorName, student.realName) ||
              same(t.creatorId, student.id)

            if (match) {
              console.log(`    ✓ 学生创建的话题: ${t.title}`, {
                creatorId: t.creatorId,
                creatorName: t.creatorName,
                studentId: student.id,
                studentUsername: student.username,
                studentRealName: student.realName
              })
            }
            return match
          })
          const topicCount = studentTopics.length
          console.log(`  学生发起的话题数: ${topicCount}`)

          // 评论数需要从评论列表中统计
          let commentCount = 0
          if (topics.length > 0) {
            console.log(`  开始统计评论...`)
            for (const topic of topics) {
              const commentsRes = await listComments({ topicId: topic.id, pageNum: 1, pageSize: 1000 })
              const comments = Array.isArray(commentsRes?.data) ? commentsRes.data : []

              // 按评论人ID和姓名匹配当前学生自己的评论：
              // 1）优先使用 userName 与学生 username/realName 匹配
              // 2）兼容 userId 与学生ID 匹配
              const myComments = comments.filter(c => {
                const same = (a, b) => a != null && b != null && String(a) === String(b)
                const match =
                  same(c.userName, student.username) ||
                  same(c.userName, student.realName) ||
                  same(c.userId, student.id)

                if (match) {
                  console.log(`      ✓ 学生的评论: ${c.content?.substring(0, 20)}...`, {
                    commentUserId: c.userId,
                    commentUserName: c.userName,
                    studentId: student.id,
                    studentUsername: student.username,
                    studentRealName: student.realName
                  })
                }
                return match
              }).length

              if (myComments > 0) {
                console.log(`    话题【${topic.title}】中的评论数: ${myComments}`)
              }
              commentCount += myComments
            }
          }
          console.log(`  评论总数: ${commentCount}`)

          if (topicCount > 0 || commentCount > 0) {
            studentsWithDiscussion++
          }

          // 计算指标
          const homeworkCompletionRate = homeworkTotal > 0 ? Math.round((homeworkCompleted / homeworkTotal) * 100) : 0
          const homeworkAvgScore = homeworkScoreCount > 0 ? Math.round(homeworkScoreSum / homeworkScoreCount) : 0
          const accuracyRate = totalAnswers > 0 ? Math.round((correctAnswers / totalAnswers) * 100) : 0

          console.log(`  统计结果:`, {
            作业完成: `${homeworkCompleted}/${homeworkTotal}`,
            完成率: homeworkCompletionRate + '%',
            平均分: homeworkAvgScore,
            讨论发帖: topicCount,
            讨论评论: commentCount,
            答题正确率: accuracyRate + '%'
          })

          // 综合评分（作业完成率60% + 讨论参与最高40分，不再包含作业得分）
          const discussionScore = Math.min((topicCount * 5 + commentCount * 2), 20)
          const overallScore = Math.round(
            homeworkCompletionRate * 0.6 +
            discussionScore * 2
          )

          console.log(`  综合评分: ${overallScore} (讨论分: ${discussionScore})`)

          // 评级（5星制）
          let performanceLevel = 0
          if (overallScore >= 90) performanceLevel = 5
          else if (overallScore >= 80) performanceLevel = 4
          else if (overallScore >= 70) performanceLevel = 3
          else if (overallScore >= 60) performanceLevel = 2
          else performanceLevel = 1

          studentAnalysisList.push({
            studentId: student.username || student.id,
            studentName: student.realName || student.username || '未知',
            className: student.className || '未分配',
            homeworkCompleted,
            homeworkTotal,
            homeworkCompletionRate,
            homeworkAvgScore,
            topicCount,
            commentCount,
            accuracyRate,
            overallScore,
            performanceLevel
          })
        }

        // 更新统计数据
        this.analysisData = {
          totalStudents: allStudents.length,
          homeworkCompletionRate: totalHomeworkAssignments > 0
            ? Math.round((totalHomeworkCompleted / totalHomeworkAssignments) * 100)
            : 0,
          discussionParticipationRate: allStudents.length > 0
            ? Math.round((studentsWithDiscussion / allStudents.length) * 100)
            : 0,
          averageScore: totalScoreCount > 0 ? Math.round(totalScore / totalScoreCount) : 0
        }

        this.studentAnalysisList = studentAnalysisList
        this.filteredStudentAnalysisList = studentAnalysisList

        console.log('\n========== 统计完成 ==========')
        console.log('学生列表数量:', studentAnalysisList.length)
        console.log('整体数据:', this.analysisData)
        console.log('====================================\n')

        // 更新时间并显示成功提示
        this.analysisLastUpdateTime = new Date()
        this.$message.success({
          message: `数据更新成功！共统计 ${allStudents.length} 名学生`,
          duration: 2000
        })
      } catch (e) {
        console.error('加载学情分析失败:', e)
        this.$message.error('加载学情分析失败：' + (e.message || ''))
      } finally {
        this.analysisLoading = false
      }
    },

    filterStudentAnalysis() {
      const keyword = (this.analysisSearchKeyword || '').toLowerCase().trim()
      if (!keyword) {
        this.filteredStudentAnalysisList = this.studentAnalysisList
        return
      }

      this.filteredStudentAnalysisList = this.studentAnalysisList.filter(student => {
        return (student.studentName || '').toLowerCase().includes(keyword) ||
               (student.studentId || '').toLowerCase().includes(keyword)
      })
    },

    viewStudentDetail(student) {
      this.$message.info(`查看学生 ${student.studentName} 的详细学情（功能开发中）`)
      // TODO: 打开学生详情对话框，展示更详细的数据
    },

    getScoreColorByPercentage(score) {
      if (score >= 90) return '#67C23A'
      if (score >= 80) return '#409EFF'
      if (score >= 60) return '#E6A23C'
      return '#F56C6C'
    },

    customProgressColor(percentage) {
      if (percentage >= 80) return '#67C23A'
      if (percentage >= 60) return '#E6A23C'
      return '#F56C6C'
    },

    // ========== 学生端学情方法 ==========
    async loadStudentStats() {
      if (!this.courseId) return
      this.analysisLoading = true

      try {
        // 获取当前登录学生的ID（与后端 userId 对齐）
        const tokenInfo = getTokenInfo && getTokenInfo()
        const studentId = tokenInfo ? (tokenInfo.id || tokenInfo.userId) : null

        // 先加载作业列表（会解析scoreInfo）
        await this.loadStudentHomeworks()
        const homeworkList = this.homeworkList || []

        console.log('========== 学生学情统计 ==========')
        console.log('作业总数:', homeworkList.length)

        // 统计作业完成情况
        let homeworkCompleted = 0
        let homeworkTotal = homeworkList.length
        let homeworkScoreSum = 0
        let homeworkScoreCount = 0
        let totalAnswers = 0
        let correctAnswers = 0

        for (const homework of homeworkList) {
          console.log(`作业【${homework.title}】:`, {
            submitted: homework.submitted,
            scoreInfo: homework.scoreInfo
          })

          if (homework.submitted) {
            homeworkCompleted++

            // 使用已解析的scoreInfo
            if (homework.scoreInfo) {
              const score = homework.scoreInfo.score || 0
              homeworkScoreSum += score
              homeworkScoreCount++
              console.log(`  - 得分: ${score}`)

              if (homework.scoreInfo.correct !== undefined) {
                correctAnswers += homework.scoreInfo.correct || 0
                totalAnswers += homework.scoreInfo.total || 0
                console.log(`  - 答对: ${homework.scoreInfo.correct}/${homework.scoreInfo.total}`)
              }
            }
          }
        }

        console.log('统计结果:', {
          已完成: homeworkCompleted,
          总数: homeworkTotal,
          总分: homeworkScoreSum,
          计分次数: homeworkScoreCount,
          答对: correctAnswers,
          总题数: totalAnswers
        })

        // 获取讨论参与情况
        console.log('\n========== 讨论统计开始 ==========')
        console.log('学生ID:', studentId)
        console.log('课程ID:', this.courseId)

        const topicsRes = await listTopics({ courseId: this.courseId, pageNum: 1, pageSize: 1000 })
        console.log('讨论话题API返回:', topicsRes)

        // 支持多种数据结构
        let topics = []
        if (Array.isArray(topicsRes?.data?.records)) {
          // 分页格式：data.records
          topics = topicsRes.data.records
        } else if (Array.isArray(topicsRes?.data?.rows)) {
          // 分页格式：data.rows
          topics = topicsRes.data.rows
        } else if (Array.isArray(topicsRes?.data?.list)) {
          // 分页格式：data.list
          topics = topicsRes.data.list
        } else if (Array.isArray(topicsRes?.data)) {
          // 直接数组格式
          topics = topicsRes.data
        }

        console.log('话题总数:', topics.length)

        if (topics.length === 0) {
          console.warn('⚠️ 课程没有讨论话题！')
        } else {
          console.log('第一个话题示例:', topics[0])
          console.log('话题ID字段:', {
            creatorId: topics[0]?.creatorId,
            userId: topics[0]?.userId,
            createBy: topics[0]?.createBy
          })
        }

        // 按后端真实字段匹配当前学生自己的话题：优先使用 creatorId，其次兼容 userId/createBy
        const myTopics = topics.filter(t => {
          const same = (a, b) => a != null && b != null && String(a) === String(b)
          const match =
            same(t.creatorId, studentId) ||
            same(t.userId, studentId) ||
            same(t.createBy, studentId)

          if (match) {
            console.log(`✓ 我发起的话题: ${t.title}`)
          }
          return match
        })
        const topicCount = myTopics.length
        console.log('学生发起的话题数:', topicCount)

        // 统计评论数（仅统计当前学生自己的评论，按 userId 为主，兼容 creatorId/createBy）
        let commentCount = 0
        if (topics.length > 0) {
          console.log('\n开始统计评论...')
          for (const topic of topics) {
            const commentsRes = await listComments({ topicId: topic.id, pageNum: 1, pageSize: 1000 })
            const comments = Array.isArray(commentsRes?.data) ? commentsRes.data : []

            // 仅匹配当前学生的评论
            const myComments = comments.filter(c => {
              const same = (a, b) => a != null && b != null && String(a) === String(b)
              const match =
                same(c.userId, studentId) ||
                same(c.creatorId, studentId) ||
                same(c.createBy, studentId)

              if (match) {
                console.log(`  ✓ 我的评论: ${c.content?.substring(0, 30)}...`)
              }
              return match
            }).length

            if (myComments > 0) {
              console.log(`话题【${topic.title}】中我的评论数: ${myComments}`)
            }
            commentCount += myComments
          }
        }
        console.log('学生评论总数:', commentCount)
        console.log('========== 讨论统计结束 ==========\n')

        // 计算指标
        const homeworkCompletionRate = homeworkTotal > 0 ? Math.round((homeworkCompleted / homeworkTotal) * 100) : 0
        const avgScore = homeworkScoreCount > 0 ? Math.round(homeworkScoreSum / homeworkScoreCount) : 0
        const accuracyRate = totalAnswers > 0 ? Math.round((correctAnswers / totalAnswers) * 100) : 0

        console.log('计算的指标:', {
          作业完成率: homeworkCompletionRate + '%',
          平均分: avgScore,
          答题正确率: accuracyRate + '%'
        })

        // 计算综合评分（作业完成率60% + 讨论参与最高40分，不再包含作业得分和正确率）
        const discussionScore = Math.min((topicCount * 5 + commentCount * 2), 20)
        const overallScore = Math.round(
          homeworkCompletionRate * 0.6 +
          discussionScore * 2
        )

        console.log('综合评分计算:', {
          讨论分: discussionScore,
          综合评分: overallScore,
          计算公式: `${homeworkCompletionRate}×0.6 + (${topicCount}×5+${commentCount}×2，封顶20)×2`
        })

        // 计算星级
        let performanceLevel = 0
        if (overallScore >= 90) performanceLevel = 5
        else if (overallScore >= 80) performanceLevel = 4
        else if (overallScore >= 70) performanceLevel = 3
        else if (overallScore >= 60) performanceLevel = 2
        else performanceLevel = 1

        console.log('星级评定:', performanceLevel + '星')

        // 更新数据
        this.studentStats = {
          homeworkCompleted,
          homeworkTotal,
          homeworkCompletionRate,
          avgScore,
          topicCount,
          commentCount,
          accuracyRate,
          totalAnswered: totalAnswers,
          correctAnswered: correctAnswers,
          overallScore,
          performanceLevel
        }

        console.log('最终学情数据:', this.studentStats)
        console.log('======================================')

        // 更新时间并显示成功提示
        this.analysisLastUpdateTime = new Date()
        this.$message.success({
          message: `学情数据更新成功！综合评分：${overallScore}分`,
          duration: 2000
        })
      } catch (error) {
        console.error('加载学生学情失败:', error)
        this.$message.error('加载学情数据失败')
      } finally {
        this.analysisLoading = false
      }
    },

    getScoreGradient(score) {
      if (score >= 90) return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      if (score >= 80) return 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
      if (score >= 70) return 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
      if (score >= 60) return 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
      return 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
    },

    getPerformanceText(score) {
      if (score >= 90) return '优秀！继续保持！'
      if (score >= 80) return '良好！再接再厉！'
      if (score >= 70) return '中等，还需努力'
      if (score >= 60) return '及格，加油进步'
      return '需要加强学习'
    },

    // ==================== 视频增强功能方法 ====================

    // 加载视频增强数据（标签和题目）
    async loadVideoEnhancementData(sectionId) {
      try {
        // 加载视频时间标签
        const markersRes = await getVideoMarkers(sectionId)
        if (markersRes.code === 1) {
          this.videoMarkers = markersRes.data || []
        }

        // 加载视频题目（仅学生需要）
        if (!this.isTeacher) {
          const questionsRes = await getVideoQuestions(sectionId)
          if (questionsRes.code === 1) {
            this.videoQuestions = questionsRes.data || []
          }
        }
      } catch (e) {
        console.error('加载视频增强数据失败', e)
        // 即使加载失败也不影响视频播放
      }
    },

    // 视频加载完成
    onVideoLoaded() {
      if (this.$refs.videoPlayer && this.$refs.videoPlayer.duration) {
        this.currentVideoDuration = this.$refs.videoPlayer.duration
        console.log('视频已加载，时长:', this.currentVideoDuration)
      }
    },

    // 获取标签在进度条上的位置百分比
    getMarkerPosition(timeSeconds) {
      // 优先使用保存的时长，确保标签位置稳定
      const duration = this.currentVideoDuration || this.$refs.videoPlayer?.duration || 0
      if (duration === 0) {
        return 0
      }
      return (timeSeconds / duration) * 100
    },

    // 跳转到指定时间
    jumpToTime(seconds) {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.currentTime = seconds
        this.$message.success(`已跳转到 ${this.formatVideoTime(seconds)}`)
      }
    },

    // 点击自定义标签进度条跳转
    onMarkersTimelineClick(e) {
      if (this.currentVideoDuration > 0 && this.$refs.videoPlayer) {
        const rect = e.currentTarget.getBoundingClientRect()
        const clickX = e.clientX - rect.left
        // 扣除右侧全屏按钮的宽度，确保点击进度条位置正确
        const width = rect.width - 30
        const percentage = Math.max(0, Math.min(1, clickX / width))
        const targetTime = percentage * this.currentVideoDuration
        this.jumpToTime(targetTime)
      }
    },

    // 手动切换容器全屏（由真实用户手势触发，保证浏览器权限校验通过）
    toggleContainerFullscreen() {
      const container = this.$refs.videoPlayerContainer
      if (!container) return

      const isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )

      if (!isFullscreen) {
        const requestFs = container.requestFullscreen || container.webkitRequestFullscreen || container.mozRequestFullScreen || container.msRequestFullscreen
        if (requestFs) {
          requestFs.call(container)
        }
      } else {
        const exitFs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen
        if (exitFs) {
          exitFs.call(document)
        }
      }
    },

    // 格式化视频时间
    formatVideoTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${String(secs).padStart(2, '0')}`
    },

    // 切换播放模式
    onPlayModeChange(mode) {
      console.log('切换播放模式:', mode)
      if (mode === 'interactive') {
        this.$message.info('已切换到随堂学习模式，视频会在特定时间点弹出题目')
      } else {
        this.$message.info('已切换到课后复习模式')
      }
      // 重置已答题记录
      this.answeredQuestions = new Set()
    },

    // 触发弹题
    async triggerQuestion(videoQuestion) {
      // 暂停视频
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }

      // 触发弹题时，如果有任何形式的全屏，必须退出全屏，否则答题弹窗会被全屏元素遮挡住！
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        const exitFs = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen
        if (exitFs) {
          try {
            exitFs.call(document)
          } catch (e) {
            console.error('退出全屏失败:', e)
          }
        }
      }

      // 直接使用 videoQuestion 中的题目数据(后端已返回完整信息)
      this.currentQuestion = {
        id: videoQuestion.questionId, // 使用 id 字段名保持一致
        questionId: videoQuestion.questionId,
        questionText: videoQuestion.questionText || '',
        questionTextEn: videoQuestion.questionTextEn || '',
        optionset: videoQuestion.optionset || '',
        answer: videoQuestion.answer || '',
        analysis: videoQuestion.analysis || ''
      }

      this.questionCountdown = videoQuestion.durationSeconds || 60
      this.questionStartTime = Date.now()
      this.studentAnswer = ''
      this.studentMultiAnswer = []
      this.questionResult = null
      this.questionPopVisible = true

      console.log('题目弹出成功:', this.currentQuestion)

      // 启动倒计时
      this.startCountdown()
    },

    // 启动倒计时
    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }

      this.countdownTimer = setInterval(() => {
        this.questionCountdown--
        if (this.questionCountdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
          // 时间到，自动提交
          if (!this.questionResult) {
            this.$message.warning('答题时间已到，自动提交')
            this.submitAnswer()
          }
        }
      }, 1000)
    },

    // 解析选项
    parseOptions(optionset) {
      if (!optionset) {
        return []
      }

      // 支持多种格式：A.xxx|B.xxx 或 (A)xxx;(B)xxx 或 A、xxx|B、xxx
      const options = []

      // 尝试多种分隔符
      let parts = []
      if (optionset.includes('|')) {
        parts = optionset.split('|')
      } else if (optionset.includes(';')) {
        parts = optionset.split(';')
      } else if (optionset.includes('\n')) {
        parts = optionset.split('\n')
      } else {
        // 如果没有分隔符，尝试按照选项字母分割
        parts = optionset.split(/(?=[A-Z][\.\)、\s])/)
      }

      parts.forEach((part, index) => {
        part = part.trim()
        if (!part) return

        // 尝试多种格式匹配
        // 格式1: A. xxx 或 A) xxx 或 A、xxx
        let match = part.match(/^([A-Z])[\.\)、]\s*(.+)$/s)

        // 格式2: (A) xxx
        if (!match) {
          match = part.match(/^\(([A-Z])\)\s*(.+)$/s)
        }

        // 格式3: A xxx (没有标点)
        if (!match) {
          match = part.match(/^([A-Z])\s+(.+)$/s)
        }

        if (match) {
          options.push({
            key: match[1],
            value: match[2].trim()
          })
        } else if (part) {
          // 如果都不匹配，使用索引作为选项字母
          const letter = String.fromCharCode(65 + index) // A, B, C, D...
          options.push({
            key: letter,
            value: part
          })
        }
      })

      return options
    },

    // 选择答案
    selectAnswer(key) {
      if (this.currentQuestion && this.currentQuestion.questionText?.startsWith('[VOTE_MULTI]')) {
        // 多选投票
        const index = this.studentMultiAnswer.indexOf(key)
        if (index > -1) {
          this.studentMultiAnswer.splice(index, 1)
        } else {
          this.studentMultiAnswer.push(key)
        }
        this.studentAnswer = this.studentMultiAnswer.sort().join(',')
      } else {
        // 单选投票 / 普通单选题
        this.studentAnswer = key
      }
    },

    // 检查选项是否选中
    isOptionSelected(key) {
      if (this.currentQuestion && this.currentQuestion.questionText?.startsWith('[VOTE_MULTI]')) {
        return this.studentMultiAnswer && this.studentMultiAnswer.includes(key)
      }
      return this.studentAnswer === key
    },

    // 提交答案
    async submitAnswer() {
      const isVote = this.currentQuestion?.questionText?.startsWith('[VOTE_')
      if (!this.studentAnswer) {
        if (isVote) {
          // 投票如果没选，时间结束自动提交选项A或占位
          this.studentAnswer = 'A'
        } else {
          this.$message.warning('请选择答案')
          return
        }
      }

      // 停止倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }

      // 计算答题用时
      const answerTimeCost = Math.floor((Date.now() - this.questionStartTime) / 1000)

      // 判断对错
      const correctAnswer = isVote ? 'VOTE' : this.currentQuestion.answer?.toUpperCase()
      const userAnswer = this.studentAnswer.toUpperCase()
      const isCorrect = isVote ? true : (correctAnswer === userAnswer)

      // 提交到后端
      try {
        // 提交到视频答题记录表（支持多次作答记录）
        await submitVideoAnswer({
          sectionId: this.currentVideoSectionId,
          questionId: this.currentQuestion.id,
          userAnswer: this.studentAnswer,
          answerTimeCost,
          isCorrect,
          courseId: Number(this.courseId),
          questionContent: this.currentQuestion.questionText || this.currentQuestion.content,
          correctAnswer: isVote ? 'VOTE' : this.currentQuestion.answer
        })

        if (!isVote) {
          // 同时记录到现有的做题记录表
          await addRecord({
            qid: this.currentQuestion.id,
            answer: this.studentAnswer,
            correct: isCorrect ? 1 : 0
          })
        }

        console.log('✅ 答题记录已保存（含作答次数）')
      } catch (e) {
        console.error('❌ 提交答案失败', e)
        // 即使提交失败也显示结果
      }

      // 标记为已答
      this.answeredQuestions.add(this.currentQuestion.id)

      if (isVote) {
        this.$message.success('感谢参与投票！')
        this.continueVideo()
      } else {
        // 显示结果
        this.questionResult = { isCorrect }
      }
    },

    // 继续播放视频
    continueVideo() {
      // 关闭弹题对话框
      this.questionPopVisible = false

      // 重置状态
      this.currentQuestion = null
      this.studentAnswer = ''
      this.questionResult = null

      // 继续播放
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.play()
      }
    },

    // 管理视频标签
    manageVideoMarkers(resource) {
      if (!resource || !resource.sectionId) {
        this.$message.warning('未找到资源所属小节')
        return
      }
      this.currentMarkerSectionId = resource.sectionId
      this.currentMarkerVideoUrl = this.getResourceHlsPreviewUrl(resource.fileUrl)
      this.markerManagerVisible = true
    },

    // 标签保存后刷新
    async onMarkersSaved() {
      // 重新加载标签数据
      if (this.currentVideoSectionId) {
        await this.loadVideoEnhancementData(this.currentVideoSectionId)
      }
      this.$message.success('视频标签已更新')
   },

    // 管理视频问题
    manageVideoQuestions(resource) {
      if (!resource || !resource.sectionId) {
        this.$message.warning('未找到资源所属小节')
        return
      }
      this.currentQuestionSectionId = resource.sectionId
      this.currentQuestionVideoUrl = this.getResourceHlsPreviewUrl(resource.fileUrl)
      this.questionManagerVisible = true
    },

    // 重新转换PPT资源
    async reconvertPptResource(resource) {
      try {
        this.$message.info('正在重新转换PPT，请稍候...')
        const { reconvertPpt } = await import('@/api/amcPptPreview')
        const res = await reconvertPpt(resource.id)
        if (res && (res.code === 1 || res.code === 200)) {
          this.$message.success(`PPT转换完成，共${res.data}页`)
        } else {
          this.$message.error(res?.msg || 'PPT转换失败')
        }
      } catch (e) {
        console.error('重新转换PPT失败', e)
        this.$message.error(e.response?.data?.msg || e.message || '重新转换失败')
      }
    },

    // 问题保存后刷新
    async onQuestionsSaved() {
      if (this.currentVideoSectionId) {
        await this.loadVideoEnhancementData(this.currentVideoSectionId)
      }
      this.$message.success('视频问题已更新')
    },

    // 查看视频答题记录（老师端）
    async viewVideoAnswerRecords(resource) {
      try {
        this.currentAnswerRecordSectionId = resource.sectionId
        this.classStudents = []
        if (this.courseId) {
          try {
            const classRes = await listClasses(this.courseId)
            const classes = Array.isArray(classRes?.data) ? classRes.data : []
            this.classOptions = classes
            let allStudents = []
            for (const cls of classes) {
              try {
                const studentsRes = await listStudents(cls.id)
                const students = Array.isArray(studentsRes?.data) ? studentsRes.data : []
                allStudents = allStudents.concat(students.map(s => ({
                  id: s.id || s.studentId,
                  username: s.username,
                  realName: s.realName,
                  name: s.name || s.studentName || s.username || s.realName,
                  className: cls.name
                })))
              } catch (e) {
                console.error('加载班级学生失败', cls && cls.id, e)
              }
            }
            const seen = new Set()
            this.classStudents = allStudents.filter(s => {
              if (!s.id) return false
              const key = String(s.id)
              if (seen.has(key)) return false
              seen.add(key)
              return true
            })
          } catch (e) {
            console.error('加载课程班级或学生失败', e)
          }
        }
        const questionsRes = await getVideoQuestions(resource.sectionId)
        if (questionsRes && questionsRes.data) {
          this.videoQuestions = questionsRes.data.map(vq => ({
            id: vq.questionId,
            content: vq.questionContent || '题目内容'
          }))
        }
        this.answerRecordsVisible = true
      } catch (e) {
        console.error('打开答题记录失败', e)
        this.$message.error('打开答题记录失败')
      }
    },

    // 查看我的答题记录（学生端）
    showMyAnswerRecords() {
      this.studentAnswerRecordsVisible = true
    }
  },
  computed: {
    displayCourseCategory() {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      const candidates = [
        q.courseType,
        q.courseTypeName,
        q.subjectCode,
        q.repoTitle,
        this.course && this.course.course_name
      ].filter(Boolean).map(item => String(item).trim())
      const matched = candidates.find(item => /AMC|袋鼠|KANGAROO|GESP|CSP|NOIP/i.test(item)) || ''
      const upper = matched.toUpperCase()
      if (upper.includes('KANGAROO') || matched.includes('袋鼠')) return '袋鼠'
      if (upper.includes('GESP')) return 'GESP'
      if (upper.includes('CSP')) return 'CSP'
      if (upper.includes('NOIP')) return 'NOIP'
      if (upper.includes('AMC')) return 'AMC'
      return ''
    },
    displayCourseTitle() {
      const name = (this.course && this.course.course_name ? String(this.course.course_name).trim() : '') || '课程名称'
      const category = this.displayCourseCategory
      if (!category) return name
      const upperName = name.toUpperCase()
      const upperCategory = String(category).toUpperCase()
      if (upperName === upperCategory || upperName.startsWith(`${upperCategory}-`)) return name
      return `${category}-${name}`
    },
    displayPlans() {
      // 学生仅显示已发布(1)与已完成(2)，教师显示全部
      if (this.isTeacher) return this.plans
      return (this.plans || []).filter(p => p.status === 1 || p.status === 2)
    },
    knowledgeViewData() {
      return this.filterKnowledge(this.knowledgeTree || [], this.knowledgeFilter)
    },
    // 当前作业题目
    hwCurrentQuestion() {
      if (!this.hwDoData.questions || this.hwDoData.questions.length === 0) return null
      return this.hwDoData.questions[this.hwCurrentQuestionIndex] || null
    },
    // 格式化最后更新时间
    formattedLastUpdateTime() {
      if (!this.analysisLastUpdateTime) return ''
      const now = new Date()
      const diff = now - this.analysisLastUpdateTime
      const seconds = Math.floor(diff / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)

      if (seconds < 60) return '刚刚更新'
      if (minutes < 60) return `${minutes}分钟前`
      if (hours < 24) return `${hours}小时前`

      const date = this.analysisLastUpdateTime
      return `${date.getMonth() + 1}月${date.getDate()}日 ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`
    }
  },
  watch: {
    '$route.params.id'(val) {
      this.courseId = val
    },
    '$route'(to) {
      this.resolveCourseName()
    },
    knowledgeFilter(val) {
      if (this.$refs.knowledgeTreeRef && typeof this.$refs.knowledgeTreeRef.filter === 'function') {
        this.$refs.knowledgeTreeRef.filter(val)
      }
    },
    // 监听题目索引变化，在查看模式下自动显示答案
    hwCurrentQuestionIndex(newIndex) {
      if (this.hwDoData.isViewOnly && this.hwCurrentQuestion) {
        console.log('=== 切换题目 ===')
        console.log('当前题目索引：', newIndex)
        console.log('当前题目ID：', this.hwCurrentQuestion.id)
        console.log('所有答题记录：', this.hwAllAnswers)

        // 查找当前题目的答案（使用宽松相等避免类型不匹配）
        const answerRecord = this.hwAllAnswers.find(a => {
          console.log(`比较: ${a.questionId} == ${this.hwCurrentQuestion.id}`, a.questionId == this.hwCurrentQuestion.id)
          return a.questionId == this.hwCurrentQuestion.id
        })

        console.log('找到的答案记录：', answerRecord)

        if (answerRecord) {
          this.hwCurrentAnswer = answerRecord.userAnswer || ''
          console.log('设置答案为：', this.hwCurrentAnswer)
        } else {
          this.hwCurrentAnswer = ''
          console.log('未找到答案，设置为空字符串')
        }
      }
    }
  },
  async mounted() {
    // 获取当前用户信息
    try {
      this.currentUser = getTokenInfo()
      console.log('当前用户信息:', this.currentUser)
    } catch (e) {
      console.error('获取用户信息失败', e)
    }
    this.sectionAccessLimit = this.getSectionRouteLimit()

    // 判定角色
    try {
      const roleIdRaw = getRole()
      const roleId = (typeof roleIdRaw === 'string') ? parseInt(roleIdRaw, 10) : roleIdRaw
      // 教师(2)、校长/教研(4)、管理员(3)、机构(6)均视为可编辑
      this.isTeacher = (roleId === 2 || roleId === 4 || roleId === 3 || roleId === 6)
    } catch (e) {
      // 回退到本地缓存 roles 判定
      const roles = localStorage.getItem('roles') || ''
      this.isTeacher = roles.includes('teacher') || roles.includes('mteacher') || roles.includes('admin') || roles.includes('organization')
    }

    // 获取课程详情
    await this.fetchCourseDetail()

    this.resolveCourseName()
    if (!this.course.course_name) {
      this.course.course_name = '课程名称'
    }
    // 准备上传头部（el-upload不走axios拦截器，需要手动带上Authorization）
    try {
      const t = localStorage.getItem('token') || sessionStorage.getItem('token') || ''
      if (t) this.uploadHeaders = { Authorization: t.startsWith('Bearer ') ? t : `Bearer ${t}` }
    } catch (e) {}
    // 初次加载
    await this.fetchPlans()
    await this.fetchNotices()
    await this.fetchObjectives()
    await this.fetchChaptersWithSections()
    await this.fetchKnowledgeTree()
    await this.fetchMaterials()
    this.restoreAllResourceOptimizeTasks()
    // 题库初始化（可延迟到切换到该页签时再加载）
    // await this.loadQbTree()
    if (this.isTeacher) {
      await this.loadTeacherHomeworks()
    } else {
      await this.loadStudentHomeworks()
    }
    this.restoreResourceOptimizeTask()

    // 支持通过 query.menu 直接打开指定模块（用于机构端顶部菜单跳转）
    try {
      const menu = (this.$route && this.$route.query) ? this.$route.query.menu : null
      if (menu) {
        this.handleMenuSelect(String(menu))
      }
    } catch (e) {}

    // 监听全屏变化事件
    this.handleFullscreenChange = () => {
      const fullscreenElement = document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement

      this.isVideoFullscreen = !!(
        fullscreenElement &&
        this.$refs.videoPlayerContainer &&
        fullscreenElement === this.$refs.videoPlayerContainer
      )
      if (this.isVideoFullscreen) {
        this.videoControlsVisible = true
        this.startFullscreenMouseTracking()
      } else {
        this.stopFullscreenMouseTracking()
        this.videoControlsVisible = true
      }
    }

    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange)
  },
  beforeDestroy() {
    this.clearResourceOptimizePolling()
    this.destroyHlsPlayer()
    this.stopFullscreenMouseTracking()
    // 移除全屏事件监听
    if (this.handleFullscreenChange) {
      document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange)
    }
  }
}
</script>

<style scoped>
.course-detail-container {
  padding: 20px;
  background-color: #f9fafb;
  min-height: 100vh;
}
.course-header {
  margin-bottom: 16px;
}
.course-title-with-cover {
  display: flex;
  align-items: center;
}
.course-cover-large {
  width: 120px;
  height: 90px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 16px;
}
.course-info-section h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
}
.course-info-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.course-meta {
  color: #666;
}
.meta-item { margin-right: 12px; }
.course-content {
  display: flex;
  gap: 16px;
}
.course-sidebar { width: 220px; }
.course-main { flex: 1; }
.course-section { background: #fff; padding: 16px; border-radius: 8px; }
.placeholder-block { color: #909399; padding: 12px 0; }
.chapter-collapse-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 20px;
  gap: 12px;
}
.chapter-collapse-main {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}
.chapter-collapse-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
}
.chapter-toggle-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #ecf5ff;
  color: #409EFF;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #b3d8ff;
}
.chapter-toggle-text {
  line-height: 1;
}
.chapter-toggle-indicator .el-icon-arrow-down {
  font-size: 13px;
  transition: transform 0.2s ease;
}
.chapter-toggle-indicator .el-icon-arrow-down.is-expanded {
  transform: rotate(180deg);
}
.chapter-collapse ::v-deep .el-collapse-item__arrow {
  display: none !important;
}
.chapter-collapse ::v-deep(.el-collapse-item__header .el-collapse-item__arrow) {
  display: none;
}
/* Knowledge styles */
.knowledge-tree-wrap {
  max-height: 520px;
  overflow: auto;
  padding: 4px 8px;
}
.knowledge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
}
.knowledge-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  transition: box-shadow .2s ease;
}
.knowledge-card:hover { box-shadow: 0 4px 14px rgba(0,0,0,0.06); }
.kc-title { display: flex; align-items: center; gap: 6px; font-weight: 600; margin-bottom: 8px; }
.kc-title-text { color: #303133; }
.knowledge-icon { color: #409EFF; margin-right: 6px; }
.kc-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.kc-chip { margin: 0; }
.qb-header { margin-bottom: 16px; }
.qb-title { margin: 0; font-weight: 600; color: #303133; }
.qb-actions { display: flex; gap: 8px; }
.qb-left { width: 300px; display: flex; flex-direction: column; gap: 10px; }
.qb-toolbar { display: flex; gap: 10px; }
.qb-right { flex: 1; display: flex; flex-direction: column; gap: 12px; }
.qb-right-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.qb-upload-title { width: 260px; }
.qb-table ::v-deep(.el-table__body tr>td) { padding-top: 10px; padding-bottom: 10px; }
.qb-table ::v-deep(.el-button--text) { padding: 2px 6px; }

.hw-question-preview-trigger {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
  cursor: pointer;
}

.hw-question-preview {
  max-height: 520px;
  overflow-y: auto;
  color: #303133;
}

.hw-question-preview-section {
  margin-bottom: 14px;
}

.hw-question-preview-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.hw-question-preview-content {
  line-height: 1.8;
  word-break: break-word;
}

.hw-question-preview-images {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}

.hw-question-preview-image,
.hw-question-preview-option-image {
  max-width: 100%;
  max-height: 240px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  object-fit: contain;
}

.hw-question-preview-option {
  padding: 8px 10px;
  background: #f8fafc;
  border-radius: 6px;
  margin-bottom: 8px;
}

.hw-question-preview-option-key,
.hw-question-preview-label-inline {
  font-weight: 600;
}

.hw-question-preview-option-image-wrap {
  margin-top: 8px;
}

.hw-question-preview-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

/* 答题界面样式 */
.question-container {
  padding: 8px 0;
}

.question-content {
  background: #f7f9fc;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.question-label {
  font-size: 12px;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.question-text {
  font-size: 16px;
  line-height: 1.8;
  color: #303133;
  font-weight: 500;
}

.options-area {
  margin-bottom: 24px;
}

.options-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 16px;
  font-weight: 500;
}

.options-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.option-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.option-card:hover {
  border-color: #409EFF;
  background: #f0f7ff;
  transform: translateX(4px);
}

.option-card.option-selected {
  border-color: #409EFF;
  background: #ecf5ff;
  box-shadow: 0 2px 12px rgba(64, 158, 255, 0.2);
}

.option-card.option-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background: #f5f7fa;
}

.option-card.option-disabled:hover {
  border-color: #e4e7ed;
  background: #f5f7fa;
  transform: none;
}

.option-radio {
  width: 24px;
  height: 24px;
  border: 2px solid #dcdfe6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.option-card.option-selected .option-radio {
  border-color: #409EFF;
  background: #409EFF;
}

.option-radio i {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
}

.option-text {
  flex: 1;
  font-size: 15px;
  line-height: 1.6;
  color: #303133;
}

.selected-answer {
  margin-top: 16px;
  padding: 12px;
  background: #f0f7ff;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
}

.result-area {
  margin-top: 24px;
}

.result-correct,
.result-wrong {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
}

.result-correct {
  background: linear-gradient(135deg, #e8f8f5 0%, #d4efdf 100%);
  border: 2px solid #27ae60;
}

.result-wrong {
  background: linear-gradient(135deg, #fadbd8 0%, #f5b7b1 100%);
  border: 2px solid #e74c3c;
}

.result-icon {
  font-size: 48px;
  margin-right: 20px;
  flex-shrink: 0;
}

.result-correct .result-icon {
  color: #27ae60;
}

.result-wrong .result-icon {
  color: #e74c3c;
}

.result-content {
  flex: 1;
}

.result-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.result-correct .result-title {
  color: #27ae60;
}

.result-wrong .result-title {
  color: #e74c3c;
}

.result-desc {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.result-detail {
  margin-top: 12px;
}

.answer-line {
  margin: 8px 0;
  font-size: 15px;
}

.answer-line .label {
  color: #666;
  margin-right: 8px;
}

.answer-line .value {
  font-weight: 600;
  font-size: 16px;
  padding: 2px 8px;
  border-radius: 4px;
}

.answer-line .value.wrong {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.1);
}

.answer-line .value.correct {
  color: #27ae60;
  background: rgba(39, 174, 96, 0.1);
}

.analysis-section {
  background: #f7f9fc;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
}

.analysis-title {
  font-size: 14px;
  font-weight: 600;
  color: #409EFF;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.analysis-content {
  font-size: 14px;
  line-height: 1.8;
  color: #606266;
  white-space: pre-wrap;
}

/* 作业头部样式 */
.homework-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  border-radius: 8px;
  color: white;
}

.hw-info-row {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;
}

.hw-info-row span {
  display: flex;
  align-items: center;
  gap: 6px;
}

.hw-info-row i {
  font-size: 16px;
}

/* 倒计时样式 */
.countdown-timer {
  font-weight: 600;
  font-size: 16px;
  padding: 4px 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.3s;
  min-width: 140px;
  text-align: center;
}

.countdown-timer.time-warning {
  background: #E6A23C;
}

.countdown-timer.time-danger {
  background: #F56C6C;
}

/* 章节小节样式 */
.chapter-description {
  padding: 12px 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
}

.chapter-description i {
  color: #409EFF;
}

.section-list {
  padding: 0;
}

.section-item {
  border-bottom: 1px solid #EBEEF5;
  position: relative;
  transition: background-color 0.3s;
}

.section-item:last-child {
  border-bottom: none;
}

.section-item:hover {
  background-color: #f5f7fa;
}

.section-item-locked {
  overflow: hidden;
}

.section-item-locked .section-header,
.section-item-locked .resource-list,
.section-item-locked .no-resources {
  filter: blur(3px);
  user-select: none;
}

.section-item .section-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.section-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.section-number {
  background-color: #409EFF;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
}

.section-title {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.section-right {
  display: flex;
  gap: 8px;
}

.resource-list {
  padding: 8px 20px 12px 60px;
  background-color: #fafafa;
}

.resource-item {
  padding: 10px 16px;
  background-color: white;
  border-radius: 6px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s;
  border: 1px solid #EBEEF5;
}

.resource-item:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  transform: translateY(-1px);
}

.section-lock-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.42);
  z-index: 2;
  cursor: pointer;
}

.section-lock-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  color: #E6A23C;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.resource-item i {
  font-size: 20px;
}

.resource-name {
  flex: 1;
  font-size: 14px;
  color: #303133;
}

.resource-size {
  font-size: 12px;
  color: #909399;
}

.resource-actions {
  display: flex;
  gap: 8px;
}

.no-resources {
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.no-sections {
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.no-sections i {
  font-size: 48px;
  color: #DCDFE6;
}

/* 小节详情对话框样式 */
.section-detail-content {
  padding: 20px;
}

.detail-description h4 {
  color: #303133;
  margin: 0 0 12px 0;
  font-size: 16px;
}

.detail-description p {
  color: #606266;
  line-height: 1.8;
  margin: 0;
}

.detail-resources {
  margin-top: 16px;
}

.detail-resource-item {
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.detail-resource-item:hover {
  background-color: #ecf5ff;
  border-color: #409EFF;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.detail-resource-item i {
  font-size: 32px;
}

.detail-resource-info {
  flex: 1;
}

.detail-resource-name {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
}

.detail-resource-meta {
  font-size: 12px;
  color: #909399;
}

/* 讨论区样式 */
.discussion-container {
  min-height: 400px;
}

.topic-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.topic-item {
  padding: 20px;
  border: 1px solid #EBEEF5;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
}

.topic-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.topic-item.topic-pinned {
  background: #FFF7E6;
  border-color: #FFD666;
}

.topic-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.topic-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  flex: 1;
}

.topic-author {
  font-size: 14px;
  color: #606266;
}

.topic-time {
  font-size: 12px;
  color: #909399;
}

.topic-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.topic-stats {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #909399;
}

.topic-stats span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.topic-actions {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #EBEEF5;
  display: flex;
  gap: 8px;
}

/* 话题详情 */
.topic-detail-header h2 {
  font-size: 24px;
  color: #303133;
  margin: 0 0 12px 0;
}

.topic-detail-meta {
  display: flex;
  gap: 16px;
  font-size: 14px;
  color: #909399;
  margin-bottom: 20px;
}

.topic-detail-meta .author {
  color: #606266;
  font-weight: 500;
}

.topic-detail-content {
  font-size: 15px;
  line-height: 1.8;
  color: #606266;
  margin-bottom: 20px;
  white-space: pre-wrap;
}

.topic-detail-actions {
  display: flex;
  gap: 12px;
}

/* 评论区 */
.comments-section {
  margin-top: 20px;
}

.comments-section h3 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 16px;
}

.comment-input-wrapper {
  margin-bottom: 24px;
  padding: 16px;
  background: #F5F7FA;
  border-radius: 8px;
}

.comment-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.comment-item {
  padding: 16px;
  background: #FAFAFA;
  border-radius: 8px;
  border-left: 3px solid #409EFF;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.comment-author {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.comment-time {
  font-size: 12px;
  color: #909399;
}

.comment-content {
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
  margin-bottom: 8px;
  white-space: pre-wrap;
}

.comment-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}

.comment-actions .el-button {
  font-size: 13px;
}

.comment-actions .el-button.el-button--warning {
  background-color: #FFF7E6;
  border-color: #FBBF24;
  color: #D97706;
}

.comment-actions .el-button.el-button--warning:hover {
  background-color: #FEF3C7;
  border-color: #F59E0B;
  color: #B45309;
}

/* 回复功能样式 */
.reply-to {
  color: #409EFF;
  font-weight: 500;
  margin-right: 4px;
}

.reply-input-wrapper {
  margin-top: 12px;
  margin-left: 20px;
  padding: 12px;
  background: #F0F9FF;
  border-left: 3px solid #409EFF;
  border-radius: 4px;
}

/* 查看模式答案显示样式 */
.answer-view-mode {
  margin: 20px 0;
}

.answer-info-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.answer-info-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.answer-info-row .info-label {
  font-size: 15px;
  color: #606266;
  font-weight: 500;
  min-width: 100px;
}

.answer-info-row .info-value {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 学情分析样式 */
.analysis-card {
  min-height: 160px;
  transition: all 0.3s ease;
  cursor: default;
  border-radius: 12px;
  overflow: visible !important;
}

.analysis-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.analysis-card .el-card__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 24px 20px !important;
  overflow: visible !important;
  text-align: center;
}

.analysis-card .card-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  overflow: visible;
}

.analysis-card .card-label {
  font-size: 16px;
  color: #606266;
  letter-spacing: 1px;
  white-space: nowrap;
  font-weight: 600;
  order: -1;
}

.analysis-card .card-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.analysis-card .card-icon i {
  font-size: 28px;
  color: white;
}

.analysis-card .card-value {
  font-size: 36px;
  font-weight: 700;
  color: #303133;
  line-height: 1;
  letter-spacing: -0.5px;
}

/* 表格行样式优化 */
.el-table .el-table__row {
  transition: background-color 0.2s;
}

.el-table .el-table__row:hover {
  background-color: #f5f7fa !important;
}

/* 清除浮动 */
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

/* 学生端学情样式 */
.student-stat-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
}

.student-stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.student-stat-card .stat-content {
  display: flex;
  align-items: center;
  padding: 20px;
}

.student-stat-card .stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.student-stat-card .stat-icon i {
  font-size: 26px;
  color: white;
}

.student-stat-card .stat-info {
  flex: 1;
}

.student-stat-card .stat-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.student-stat-card .stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  line-height: 1;
  margin-bottom: 6px;
}

.student-stat-card .stat-desc {
  font-size: 12px;
  color: #C0C4CC;
}

.chapter-sort-item {
  border-radius: 8px;
}

.chapter-sort-item.is-dragging {
  opacity: 0.75;
}

.chapter-drag-hint,
.section-drag-hint {
  color: #909399;
  cursor: move;
  margin-right: 8px;
  font-size: 16px;
}

.chapter-sort-tip {
  color: #909399;
  font-size: 12px;
}

.section-item.section-item-draggable {
  cursor: move;
}

.section-item.is-dragging {
  opacity: 0.7;
  border: 1px dashed #409EFF;
}

.progress-item {
  margin-bottom: 12px;
}

.progress-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.score-circle {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.score-number {
  font-size: 48px;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.score-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 8px;
}

.breakdown-item {
  text-align: left;
}

.breakdown-label {
  display: block;
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.learning-tips .el-alert {
  border-radius: 8px;
}

/* ==================== 视频增强功能样式 ==================== */

/* 视频播放器容器 */
.video-player-container {
  position: relative;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

/* 视频加载错误提示 */
.video-error-tip {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  padding: 20px;
}

/* 视频标签 */
.video-markers {
  position: absolute;
  bottom: 70px;
  left: 15px;
  right: 15px;
  height: 20px;
  pointer-events: auto;
  z-index: 10;
  display: flex;
  align-items: center;
}

/* 进度条轨道 */
.markers-timeline-track {
  position: absolute;
  left: 0;
  right: 45px; /* 右侧留空 45px 给自制的极简全屏切换按钮 */
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  cursor: pointer;
  pointer-events: auto;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.markers-timeline-played {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #409EFF;
  border-radius: 2px;
}

.markers-timeline-handle {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  background: #fff;
  border: 2px solid #409EFF;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  transition: transform 0.1s;
}

.markers-timeline-track:hover .markers-timeline-handle {
  transform: translate(-50%, -50%) scale(1.3);
}

.video-marker {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.2s;
  z-index: 2;
}

.video-marker:hover {
  transform: translate(-50%, -50%) translateY(-2px);
  z-index: 20;
}

.video-marker:hover .marker-label {
  background: rgba(0, 0, 0, 0.85);
  color: white;
  font-weight: 600;
  padding: 4px 8px;
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -8px);
}

.video-marker:hover .marker-line {
  background: #409EFF;
  height: 8px;
}

.video-marker:hover .marker-dot {
  transform: scale(1.3);
  background: #409EFF;
}

.marker-label {
  font-size: 11px;
  color: #fff;
  background: rgba(0, 0, 0, 0.85);
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  transition: all 0.2s;
  font-weight: 500;
  line-height: 1.2;
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translate(-50%, 5px);
  /* 默认隐藏标签文字 */
  opacity: 0;
  visibility: hidden;
}

.marker-line {
  width: 1.5px;
  height: 0;  /* 默认隐藏竖线 */
  background: #409EFF;
  transition: all 0.2s;
  border-radius: 1px;
}

/* 全屏模式：fixed定位覆盖整个屏幕 */
.markers-fullscreen {
  position: fixed;
  bottom: 60px;
  left: 20px;
  right: 20px;
  z-index: 2147483647;
  transition: opacity 0.3s;
}

.markers-hidden {
  opacity: 0;
  pointer-events: none;
}

.marker-dot {
  width: 10px;
  height: 10px;
  background: #fff;
  border: 2.5px solid #409EFF;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
  transition: all 0.2s;
}

/* 当播放器容器全屏时，让视频填满屏幕 */
.video-player-container:fullscreen video,
.video-player-container:-webkit-full-screen video {
  max-height: 100vh !important;
  height: 100% !important;
  width: 100% !important;
  border-radius: 0 !important;
}

/* 全屏状态下，自制标签进度条更完美地贴合在原生控制条上方 */
.video-player-container:fullscreen .video-markers,
.video-player-container:-webkit-full-screen .video-markers {
  bottom: 80px; /* 全屏时上移，避开底部原生控件栏的高度 */
  left: 40px;
  right: 40px;
}

/* 隐藏原生的全屏按钮，确保用户使用自制的完美对齐的标签条全屏 */
video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
video::-moz-media-controls-fullscreen-button {
  display: none !important;
}

/* 隐藏原生的视频进度条，避免多重进度条冗余，使自制的高精度标签进度条成为唯一的控制器 */
video::-webkit-media-controls-timeline {
  display: none !important;
}
video::-moz-media-controls-timeline {
  display: none !important;
}

/* 极简自制全屏切换按钮 */
.markers-fullscreen-toggle {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  pointer-events: auto;
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
}

.markers-fullscreen-toggle:hover {
  color: #fff;
  background: #409EFF;
  transform: translateY(-50%) scale(1.1);
}

/* 弹题对话框 */
.question-dialog-content {
  position: relative;
  padding: 20px 10px;
}

.countdown-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
  display: flex;
  align-items: center;
  gap: 6px;
}

.countdown-badge.countdown-vote {
  background: linear-gradient(135deg, #E6A23C 0%, #F56C6C 100%);
  box-shadow: 0 2px 8px rgba(230, 162, 60, 0.3);
}

.countdown-badge i {
  font-size: 18px;
}

/* 投票器样式 */
.vote-widget-container {
  margin-top: 10px;
}

.vote-header-tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #909399;
  background: #FFFBE6;
  border: 1px solid #FFE58F;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 20px;
}

.vote-widget-title {
  color: #303133;
  font-weight: 600;
  font-size: 17px;
  line-height: 1.5;
}

.vote-option-card {
  border: 1px solid #E4E7ED;
  cursor: pointer;
  transition: all 0.3s;
}

.vote-option-card:hover {
  border-color: #E6A23C !important;
  background: #FFFDF0 !important;
  transform: translateX(4px);
}

.vote-option-card.selected {
  border-color: #E6A23C !important;
  background: linear-gradient(135deg, #FFFDF0 0%, #FFE7C6 100%) !important;
  box-shadow: 0 2px 8px rgba(230, 162, 60, 0.15) !important;
}

.option-checkbox-indicator {
  width: 20px;
  height: 20px;
  border: 2px solid #DCDFE6;
  border-radius: 4px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  transition: all 0.2s;
  flex-shrink: 0;
}

.vote-option-card:hover .option-checkbox-indicator {
  border-color: #E6A23C;
}

.vote-option-card.selected .option-checkbox-indicator {
  border-color: #E6A23C;
  background: #E6A23C;
}

.checkbox-indicator-checked {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

/* 题目内容 */
.question-content-box {
  margin: 30px 0 20px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-radius: 8px;
  border-left: 4px solid #409EFF;
}

.question-content-box.vote-widget-title-box {
  border-left: 4px solid #E6A23C;
}

.question-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  line-height: 1.6;
  margin-bottom: 10px;
}

.question-title-en {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  font-style: italic;
}

/* 选项卡片 */
.options-container {
  margin: 20px 0;
}

.option-card {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  margin-bottom: 12px;
  background: #fff;
  border: 2px solid #DCDFE6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.option-card:hover {
  border-color: #409EFF;
  background: #F0F9FF;
  transform: translateX(4px);
}

.option-card.selected {
  border-color: #409EFF;
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

.option-radio {
  width: 20px;
  height: 20px;
  border: 2px solid #DCDFE6;
  border-radius: 50%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.option-card.selected .option-radio {
  border-color: #409EFF;
  background: #409EFF;
}

.radio-checked {
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.option-content {
  flex: 1;
  display: flex;
  align-items: center;
}

.option-label {
  font-size: 16px;
  font-weight: bold;
  color: #409EFF;
  margin-right: 8px;
}

.option-text {
  font-size: 15px;
  color: #303133;
  line-height: 1.5;
}

/* 答题结果 */
.question-result {
  margin: 20px 0;
}

.question-analysis {
  margin-top: 20px;
}

/* 薄弱知识点提醒对话框 */
::v-deep .weak-knowledge-dialog {
  border-radius: 12px;
}

::v-deep .weak-knowledge-dialog .el-message-box__header {
  padding: 20px 20px 10px;
  background: linear-gradient(135deg, #FFF7E6 0%, #FFE7BA 100%);
  border-radius: 12px 12px 0 0;
}

::v-deep .weak-knowledge-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
  color: #D46B08;
}

::v-deep .weak-knowledge-dialog .el-message-box__content {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

::v-deep .weak-knowledge-dialog .el-message-box__btns {
  padding: 15px 20px 20px;
}

.resource-upload-status {
  margin-top: 12px;
}

.resource-upload-status__content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 4px;
  font-size: 13px;
}

.resource-upload-status__content--uploading {
  background: #f4faff;
  color: #409EFF;
}

.resource-upload-status__content--success {
  background: #f0f9eb;
  color: #67C23A;
}

.resource-upload-status__content--error {
  background: #fef0f0;
  color: #F56C6C;
}

.resource-upload-status__icon {
  font-size: 16px;
}

.resource-upload-status__name {
  flex: 1;
  color: #606266;
  word-break: break-all;
}

.resource-upload-status__text {
  white-space: nowrap;
}
</style>
